// Helper function to serialize objects for JSON (handles DOMRect, etc.)
function serializeForJSON(obj) {
  if (obj === null || obj === undefined) return null;
  if (typeof obj !== 'object') return obj;
  if (obj instanceof DOMRect || (obj.x !== undefined && obj.y !== undefined && obj.width !== undefined && obj.height !== undefined)) {
    return {
      x: obj.x,
      y: obj.y,
      width: obj.width,
      height: obj.height,
      top: obj.top,
      left: obj.left,
      right: obj.right,
      bottom: obj.bottom
    };
  }
  if (Array.isArray(obj)) {
    return obj.map(serializeForJSON);
  }
  var result = {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      try {
        result[key] = serializeForJSON(obj[key]);
      } catch (e) {
        result[key] = '[Error serializing: ' + String(e) + ']';
      }
    }
  }
  return result;
}

// Helper function to log to both console AND debug log
// Debug server endpoint
// var DEBUG_SERVER_URL = 'http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb';
var DEBUG_LOG_ENABLED = true;
var DEBUG_FETCH_ERROR_COUNT = 0;
var DEBUG_FETCH_SUCCESS_COUNT = 0;

// Test debug server connectivity on first call
var DEBUG_SERVER_TESTED = false;
function testDebugServer() {
  if (DEBUG_SERVER_TESTED) return;
  DEBUG_SERVER_TESTED = true;
  console.log('[DEBUG] ========================================');
  console.log('[DEBUG] Testing debug server connectivity...');
  console.log('[DEBUG] URL:', DEBUG_SERVER_URL);
  console.log('[DEBUG] ========================================');
  
  // Try regular fetch first
  fetch(DEBUG_SERVER_URL, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({test: true, timestamp: Date.now(), location: 'testDebugServer'})
  }).then(function(response) {
    console.log('[DEBUG] ✓ Server test SUCCESS - Status:', response.status, response.statusText);
    console.log('[DEBUG] Response headers:', Object.fromEntries(response.headers.entries()));
    DEBUG_FETCH_SUCCESS_COUNT++;
  }).catch(function(err) {
    console.error('[DEBUG] ✗ Server test FAILED:', err);
    console.error('[DEBUG] Error type:', typeof err);
    console.error('[DEBUG] Error name:', err.name);
    console.error('[DEBUG] Error message:', err.message);
    if (err.stack) console.error('[DEBUG] Error stack:', err.stack);
    DEBUG_FETCH_ERROR_COUNT++;
    
    // Try with no-cors as fallback
    console.log('[DEBUG] Trying no-cors mode...');
    fetch(DEBUG_SERVER_URL, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({test: true, timestamp: Date.now(), location: 'testDebugServer-no-cors'}),
      mode: 'no-cors'
    }).then(function() {
      console.log('[DEBUG] ✓ no-cors mode succeeded (response not readable)');
    }).catch(function(noCorsErr) {
      console.error('[DEBUG] ✗ no-cors mode also failed:', noCorsErr);
    });
  });
}

function debugLog(location, message, data, hypothesisId) {
  if (!DEBUG_LOG_ENABLED) return;
  
  try {
    // Test server on first call
    if (!DEBUG_SERVER_TESTED) {
      testDebugServer();
    }
    
    var serializedData = serializeForJSON(data || {});
    var logData = {
      location: location,
      message: message,
      data: serializedData,
      timestamp: Date.now(),
      sessionId: 'debug-session',
      runId: 'run1',
      hypothesisId: hypothesisId || 'G'
    };
    
    // Always log to console first
    console.log('[DEBUG]', message, serializedData || '');
    
    // Try to send to debug server
    var fetchPromise = fetch(DEBUG_SERVER_URL, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(logData),
      mode: 'no-cors' // Try no-cors mode to avoid CORS issues
    }).then(function(response) {
      DEBUG_FETCH_SUCCESS_COUNT++;
      if (DEBUG_FETCH_SUCCESS_COUNT === 1) {
        console.log('[DEBUG] First successful fetch! Server is reachable.');
      }
      return response;
    }).catch(function(err) {
      DEBUG_FETCH_ERROR_COUNT++;
      console.error('[DEBUG] Fetch failed:', {
        name: err.name,
        message: err.message,
        url: DEBUG_SERVER_URL,
        errorCount: DEBUG_FETCH_ERROR_COUNT,
        successCount: DEBUG_FETCH_SUCCESS_COUNT
      });
      
      // If we have too many errors, disable further attempts
      if (DEBUG_FETCH_ERROR_COUNT > 10 && DEBUG_FETCH_SUCCESS_COUNT === 0) {
        console.warn('[DEBUG] Too many fetch failures. Disabling debug server logging. Check if server is running at:', DEBUG_SERVER_URL);
        DEBUG_LOG_ENABLED = false;
      }
      
      // Fallback: Store in localStorage as backup
      try {
        var storedLogs = JSON.parse(localStorage.getItem('debug_logs') || '[]');
        storedLogs.push(logData);
        // Keep only last 100 logs
        if (storedLogs.length > 100) {
          storedLogs = storedLogs.slice(-100);
        }
        localStorage.setItem('debug_logs', JSON.stringify(storedLogs));
        if (DEBUG_FETCH_ERROR_COUNT === 1) {
          console.log('[DEBUG] Fallback: Storing logs in localStorage. Check localStorage.debug_logs');
        }
      } catch (storageErr) {
        console.error('[DEBUG] Failed to store in localStorage:', storageErr);
      }
    });
    
    // Also try with CORS mode (might work if server allows it)
    if (DEBUG_FETCH_ERROR_COUNT > 0 && DEBUG_FETCH_ERROR_COUNT < 5) {
      fetch(DEBUG_SERVER_URL, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(logData)
      }).catch(function() {
        // Silent fail for this attempt
      });
    }
    
  } catch (e) {
    console.error('[DEBUG] Error in debugLog:', e, message, {
      error: String(e),
      stack: e.stack
    });
  }
}

// Add MutationObserver to detect when address-input-container is added to DOM
(function() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (node.classList && node.classList.contains('address-input-container'))) {
          // #region agent log
//           fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:9',message:'MutationObserver detected address-input-container',data:{parentNode:node.parentNode?.className||'null',parentTag:node.parentNode?.tagName||'null',isInDropdown:node.parentNode?.classList.contains('store-selection-dropdown')||false,computedPosition:window.getComputedStyle(node).position,computedLeft:window.getComputedStyle(node).left,computedTop:window.getComputedStyle(node).top,rect:JSON.stringify(node.getBoundingClientRect())},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
          // #endregion
          console.log('========================================');
          console.log('[Header Location Selector] V7: DETECTED address-input-container added to DOM!');
          console.log('[Header Location Selector] Container:', node);
          console.log('[Header Location Selector] Parent:', node.parentNode);
          console.log('[Header Location Selector] Parent className:', node.parentNode ? node.parentNode.className : 'null');
          console.log('[Header Location Selector] Container style:', node.style.cssText);
          console.log('[Header Location Selector] Computed position:', window.getComputedStyle(node).position);
          console.log('[Header Location Selector] Computed top:', window.getComputedStyle(node).top);
          console.log('[Header Location Selector] Computed left:', window.getComputedStyle(node).left);
          console.log('[Header Location Selector] Is in dropdown?', node.parentNode && node.parentNode.classList.contains('store-selection-dropdown'));
          console.log('========================================');
          
          // If it's not in the dropdown, try to move it
          if (node.parentNode && !node.parentNode.classList.contains('store-selection-dropdown')) {
            // #region agent log
//             fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:26',message:'MutationObserver moving container - NOT in dropdown',data:{currentParent:node.parentNode?.className||'null',currentParentTag:node.parentNode?.tagName||'null',dropdownFound:!!document.querySelector('.store-selection-dropdown'),savedItemFound:!!document.querySelector('.saved-address-item')},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
            // #endregion
            var dropdown = document.querySelector('.store-selection-dropdown');
            var savedItem = dropdown ? dropdown.querySelector('.saved-address-item') : null;
            if (dropdown && savedItem) {
              console.log('[Header Location Selector] V7: Moving address-input-container to dropdown after savedAddressItem');
              var childrenBefore = Array.from(dropdown.children);
              var savedItemIndexBefore = childrenBefore.indexOf(savedItem);
              dropdown.insertBefore(node, savedItem.nextSibling);
              var childrenAfter = Array.from(dropdown.children);
              var containerIndexAfter = childrenAfter.indexOf(node);
              var savedItemIndexAfter = childrenAfter.indexOf(savedItem);
              // #region agent log
//               fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:34',message:'MutationObserver moved container - AFTER move',data:{newParent:node.parentNode?.className||'null',containerIndex:containerIndexAfter,savedItemIndex:savedItemIndexAfter,isAfterSaved:containerIndexAfter===savedItemIndexAfter+1,childrenOrder:childrenAfter.map(function(c,i){return i+':'+(c.className||c.tagName);}),rect:JSON.stringify(node.getBoundingClientRect()),computedPosition:window.getComputedStyle(node).position,computedLeft:window.getComputedStyle(node).left,computedTop:window.getComputedStyle(node).top},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
              // #endregion
              node.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
              console.log('[Header Location Selector] V7: Moved and restyled');
            }
          } else {
            // Container IS in dropdown - log its position relative to siblings
            var dropdown = node.parentNode;
            var children = Array.from(dropdown.children);
            var containerIndex = children.indexOf(node);
            var savedItem = dropdown.querySelector('.saved-address-item');
            var savedItemIndex = savedItem ? children.indexOf(savedItem) : -1;
            // #region agent log
//             fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:47',message:'MutationObserver - container already in dropdown',data:{containerIndex:containerIndex,savedItemIndex:savedItemIndex,isAfterSaved:containerIndex===savedItemIndex+1,childrenOrder:children.map(function(c,i){return i+':'+(c.className||c.tagName);}),rect:JSON.stringify(node.getBoundingClientRect()),computedPosition:window.getComputedStyle(node).position,computedLeft:window.getComputedStyle(node).left,computedTop:window.getComputedStyle(node).top},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
            // #endregion
            
            // Set up a MutationObserver to watch for style attribute changes
            var styleObserver = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                  var computed = window.getComputedStyle(node);
                  var rect = node.getBoundingClientRect();
                  // #region agent log
//                   fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:58',message:'Style attribute changed on address-input-container',data:{oldValue:mutation.oldValue,newValue:node.style.cssText,computedPosition:computed.position,computedLeft:computed.left,computedTop:computed.top,computedTransform:computed.transform,rect:{x:rect.x,y:rect.y,width:rect.width,height:rect.height,top:rect.top,left:rect.left}},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                  // #endregion
                  console.warn('[Header Location Selector] V7: WARNING - Style attribute changed on address-input-container!', {
                    oldValue: mutation.oldValue,
                    newValue: node.style.cssText,
                    computed: {
                      position: computed.position,
                      left: computed.left,
                      top: computed.top,
                      transform: computed.transform
                    },
                    rect: rect
                  });
                  
                  // If position changed to something other than static, re-apply our fix
                  if (computed.position !== 'static' || computed.left !== 'auto' || computed.top !== 'auto' || computed.transform !== 'none') {
                    console.log('[Header Location Selector] V7: Re-applying static positioning after style change');
                    node.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                  }
                }
              });
            });
            
            styleObserver.observe(node, {
              attributes: true,
              attributeFilter: ['style'],
              attributeOldValue: true
            });
            
            // Also observe for DOM position changes (if container is moved to different parent)
            var domObserver = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                  // Check if container was moved
                  var currentParent = node.parentNode;
                  var isInDropdown = currentParent && currentParent.classList.contains('store-selection-dropdown');
                  var savedItem = currentParent ? currentParent.querySelector('.saved-address-item') : null;
                  var containerIndex = currentParent ? Array.from(currentParent.children).indexOf(node) : -1;
                  var savedItemIndex = savedItem ? Array.from(currentParent.children).indexOf(savedItem) : -1;
                  
                  // #region agent log
//                   fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:87',message:'DOM position changed - container moved',data:{isInDropdown:isInDropdown,containerIndex:containerIndex,savedItemIndex:savedItemIndex,isAfterSaved:containerIndex===savedItemIndex+1,parentClass:currentParent?.className||'null',rect:JSON.stringify(node.getBoundingClientRect())},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                  // #endregion
                  
                  // CRITICAL: If container was removed from DOM (parent is null), re-insert it
                  if (!currentParent) {
                    console.warn('[Header Location Selector] V8: ⚠⚠⚠ Container REMOVED from DOM! Re-inserting...');
                    // Find the dropdown and savedAddressItem
                    var dropdown = document.querySelector('.store-selection-dropdown');
                    var savedItem = dropdown ? dropdown.querySelector('.saved-address-item') : null;
                    if (dropdown && savedItem) {
                      console.log('[Header Location Selector] V8: Re-inserting container after savedAddressItem');
                      dropdown.insertBefore(node, savedItem.nextSibling);
                      // Re-apply flex fix
                      if (dropdown.style.display !== 'flex') {
                        dropdown.style.setProperty('display', 'flex', 'important');
                        dropdown.style.setProperty('flex-direction', 'column', 'important');
                        dropdown.style.setProperty('align-items', 'stretch', 'important');
                      }
                      node.style.setProperty('order', '2', 'important');
                      if (savedItem) savedItem.style.setProperty('order', '1', 'important');
                      void dropdown.offsetHeight; // Force reflow
                    }
                    return;
                  }
                  
                  if (!isInDropdown || (savedItem && containerIndex !== savedItemIndex + 1)) {
                    console.warn('[Header Location Selector] V8: ⚠⚠⚠ Container moved to wrong position!');
                    console.warn('[Header Location Selector] V8: Current parent:', currentParent?.className);
                    console.warn('[Header Location Selector] V8: Container index:', containerIndex, 'Saved item index:', savedItemIndex);
                    
                    // Try to fix it
                    if (isInDropdown && savedItem) {
                      console.log('[Header Location Selector] V8: Attempting to fix position...');
                      currentParent.insertBefore(node, savedItem.nextSibling);
                      // Re-apply flex fix
                      if (currentParent.style.display !== 'flex') {
                        currentParent.style.setProperty('display', 'flex', 'important');
                        currentParent.style.setProperty('flex-direction', 'column', 'important');
                        currentParent.style.setProperty('align-items', 'stretch', 'important');
                      }
                      node.style.setProperty('order', '2', 'important');
                      if (savedItem) savedItem.style.setProperty('order', '1', 'important');
                      void currentParent.offsetHeight; // Force reflow
                    }
                  }
                }
              });
            });
            
            // Observe the parent for childList changes
            if (node.parentNode) {
              domObserver.observe(node.parentNode, {
                childList: true,
                subtree: false
              });
            }
            
                console.log('[Header Location Selector] V8: Set up style and DOM observers on address-input-container');
                
                // CRITICAL: Also observe the dropdown itself for child changes
                // When store items are added, ensure address input stays in correct position
                var dropdown = node.parentNode;
                if (dropdown && dropdown.classList && dropdown.classList.contains('store-selection-dropdown') && !dropdown._addressInputObserver) {
                  dropdown._addressInputObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                      if (mutation.type === 'childList') {
                        var container = dropdown.querySelector('.address-input-container');
                        var savedItem = dropdown.querySelector('.saved-address-item');
                        
                        if (container && savedItem) {
                          var containerIndex = Array.from(targetDropdown.children).indexOf(container);
                          var savedItemIndex = Array.from(targetDropdown.children).indexOf(savedItem);
                          
                          // If container is not right after savedItem, fix it
                          if (containerIndex !== savedItemIndex + 1) {
                            console.warn('[Header Location Selector] V8: Dropdown children changed - container moved! Re-positioning...');
                            console.warn('[Header Location Selector] V8: Container index:', containerIndex, 'Saved item index:', savedItemIndex);
                            dropdown.insertBefore(container, savedItem.nextSibling);
                            // Re-apply flex fix
                            dropdown.style.setProperty('display', 'flex', 'important');
                            dropdown.style.setProperty('flex-direction', 'column', 'important');
                            container.style.setProperty('order', '2', 'important');
                            if (savedItem) savedItem.style.setProperty('order', '1', 'important');
                            void dropdown.offsetHeight; // Force reflow
                          }
                        } else if (container && !savedItem) {
                          // Container exists but savedItem is missing - this shouldn't happen, but log it
                          console.warn('[Header Location Selector] V8: Container exists but savedItem is missing!');
                        } else if (!container && savedItem) {
                          // Container was removed! Re-insert it
                          console.warn('[Header Location Selector] V8: Container was REMOVED from dropdown! This should not happen.');
                        }
                      }
                    });
                  });
                  
                  dropdown._addressInputObserver.observe(dropdown, {
                    childList: true,
                    subtree: false
                  });
                  
                  console.log('[Header Location Selector] V8: Set up dropdown observer to watch for child changes');
                }
          }
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('[Header Location Selector] V7: MutationObserver set up to watch for address-input-container');
})();

// Inject CSS to force address-input-container to use normal flow positioning
// This will override any theme CSS that might be positioning it incorrectly
(function() {
  var style = document.createElement('style');
  style.id = 'address-input-container-fix';
  style.textContent = `
    .address-input-container {
      position: static !important;
      top: auto !important;
      left: auto !important;
      right: auto !important;
      bottom: auto !important;
      transform: none !important;
      z-index: auto !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      float: none !important;
      clear: both !important;
      display: block !important;
    }
    .store-selection-dropdown .address-input-container {
      position: static !important;
      top: auto !important;
      left: auto !important;
      right: auto !important;
      bottom: auto !important;
      transform: none !important;
    }
    .store-selection-dropdown {
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      flex-wrap: nowrap !important;
    }
    .store-selection-dropdown > * {
      flex-shrink: 0 !important;
      flex-grow: 0 !important;
      width: 100% !important;
      order: initial !important;
    }
    .store-selection-dropdown .saved-address-item {
      order: 1 !important;
    }
    .store-selection-dropdown .address-input-container {
      order: 2 !important;
    }
  `;
  document.head.appendChild(style);
  console.log('[Header Location Selector] V7: Injected CSS to force normal flow positioning');
})();

// PREVENT GOOGLE MAPS GEOCODER INITIALIZATION EARLY
// This must happen before the Multi-Location App loads
(function() {
  // Override Google Maps Geocoder before it's used
  var originalGoogleMaps = window.google && window.google.maps;
  if (originalGoogleMaps) {
    // Override Geocoder constructor
    if (originalGoogleMaps.Geocoder) {
      var OriginalGeocoder = originalGoogleMaps.Geocoder;
      originalGoogleMaps.Geocoder = function() {
        // Check if we're in shipping mode
        var isShipping = document.body.classList.contains('shipping-mode-shipping') ||
                        (window.currentMethod === 'shipping') ||
                        (window.StateManager && window.StateManager.currentMethod === 'shipping');
        if (isShipping) {
          // Return a mock object to prevent errors
          return {
            geocode: function() { return Promise.resolve({ results: [] }); },
            reverseGeocode: function() { return Promise.resolve({ results: [] }); }
          };
        }
        return new OriginalGeocoder();
      };
    }
    
    // Override Autocomplete constructor
    if (originalGoogleMaps.places && originalGoogleMaps.places.Autocomplete) {
      var OriginalAutocomplete = originalGoogleMaps.places.Autocomplete;
      originalGoogleMaps.places.Autocomplete = function() {
        // Check if we're in shipping mode
        var isShipping = document.body.classList.contains('shipping-mode-shipping') ||
                        (window.currentMethod === 'shipping') ||
                        (window.StateManager && window.StateManager.currentMethod === 'shipping');
        if (isShipping) {
          // Return a mock object to prevent errors
          return {
            addListener: function() {},
            getPlace: function() { return {}; },
            setBounds: function() {},
            setComponentRestrictions: function() {}
          };
        }
        // Properly call constructor with arguments
        var args = Array.prototype.slice.call(arguments);
        return new (Function.prototype.bind.apply(OriginalAutocomplete, [null].concat(args)))();
      };
    }
  }
  
  // Also intercept when Google Maps loads later
  var checkGoogleMaps = setInterval(function() {
    if (window.google && window.google.maps) {
      var maps = window.google.maps;
      if (maps.Geocoder && !maps.Geocoder._overridden) {
        var OriginalGeocoder = maps.Geocoder;
        maps.Geocoder = function() {
          var isShipping = document.body.classList.contains('shipping-mode-shipping') ||
                          (window.currentMethod === 'shipping') ||
                          (window.StateManager && window.StateManager.currentMethod === 'shipping');
          if (isShipping) {
            return {
              geocode: function() { return Promise.resolve({ results: [] }); },
              reverseGeocode: function() { return Promise.resolve({ results: [] }); }
            };
          }
          return new OriginalGeocoder();
        };
        maps.Geocoder._overridden = true;
      }
      
      if (maps.places && maps.places.Autocomplete && !maps.places.Autocomplete._overridden) {
        var OriginalAutocomplete2 = maps.places.Autocomplete;
        maps.places.Autocomplete = function() {
          var isShipping = document.body.classList.contains('shipping-mode-shipping') ||
                          (window.currentMethod === 'shipping') ||
                          (window.StateManager && window.StateManager.currentMethod === 'shipping');
          if (isShipping) {
            return {
              addListener: function() {},
              getPlace: function() { return {}; },
              setBounds: function() {},
              setComponentRestrictions: function() {}
            };
          }
          // Properly call constructor with arguments
          var args = Array.prototype.slice.call(arguments);
          return new (Function.prototype.bind.apply(OriginalAutocomplete2, [null].concat(args)))();
        };
        maps.places.Autocomplete._overridden = true;
      }
      
      // Stop checking once overridden (with safety checks)
      var geocoderOverridden = maps.Geocoder && maps.Geocoder._overridden;
      var autocompleteOverridden = maps.places && maps.places.Autocomplete && maps.places.Autocomplete._overridden;
      if (geocoderOverridden && autocompleteOverridden) {
        clearInterval(checkGoogleMaps);
      }
    }
  }, 100);
  
  // Stop checking after 10 seconds
  setTimeout(function() {
    clearInterval(checkGoogleMaps);
  }, 10000);
})();

if(!window.StorageManager){
  window.StorageManager = {
        blockedUntil: {
          localStorage: 0,
          sessionStorage: 0
        },
        blockDuration: 300000, // Block for 5 minutes after failure to prevent spam
        
        // Safe localStorage access
        getLocalStorage: function(key) {
          if (Date.now() < this.blockedUntil.localStorage) {
            return null; // Still blocked, don't try
          }
          try {
            var value = localStorage.getItem(key);
            return value;
          } catch(e) {
            // Blocked - set block time
            this.blockedUntil.localStorage = Date.now() + this.blockDuration;
            return null;
          }
        },
        
        setLocalStorage: function(key, value) {
          if (Date.now() < this.blockedUntil.localStorage) {
            return false; // Still blocked, don't try
          }
          try {
            localStorage.setItem(key, value);
            return true;
          } catch(e) {
            // Blocked - set block time
            this.blockedUntil.localStorage = Date.now() + this.blockDuration;
            return false;
          }
        },
        
        // Safe sessionStorage access
        getSessionStorage: function(key) {
          if (Date.now() < this.blockedUntil.sessionStorage) {
            return null; // Still blocked, don't try
          }
          try {
            var value = sessionStorage.getItem(key);
            return value;
          } catch(e) {
            // Blocked - set block time
            this.blockedUntil.sessionStorage = Date.now() + this.blockDuration;
            return null;
          }
        },
        
        setSessionStorage: function(key, value) {
          if (Date.now() < this.blockedUntil.sessionStorage) {
            return false; // Still blocked, don't try
          }
          try {
            sessionStorage.setItem(key, value);
            return true;
          } catch(e) {
            // Blocked - set block time
            this.blockedUntil.sessionStorage = Date.now() + this.blockDuration;
            return false;
          }
        },
        
        // Safe Object.keys for localStorage
        getLocalStorageKeys: function() {
          if (Date.now() < this.blockedUntil.localStorage) {
            return []; // Still blocked, don't try
          }
          try {
            return Object.keys(localStorage);
          } catch(e) {
            // Blocked - set block time
            this.blockedUntil.localStorage = Date.now() + this.blockDuration;
            return [];
          }
        },
        
        // Safe Object.keys for sessionStorage
        getSessionStorageKeys: function() {
          if (Date.now() < this.blockedUntil.sessionStorage) {
            return []; // Still blocked, don't try
          }
          try {
            return Object.keys(sessionStorage);
          } catch(e) {
            // Blocked - set block time
            this.blockedUntil.sessionStorage = Date.now() + this.blockDuration;
            return [];
          }
        }
      };
  }
  
  (function() {
    var isUpdating = false;
    var lastLocationName = null;
    
    function updateLocationText() {
      // COMPLETELY DISABLE STORAGE ACCESS if Tracking Prevention is active
      // This prevents all storage errors from flooding the console
      if (!window._storageAccessDisabled) {
        // Try to detect if storage is blocked by attempting one access
        try {
          localStorage.getItem('_test');
        } catch(e) {
          // Storage is blocked - disable ALL storage access
          window._storageAccessDisabled = true;
          if (window.StorageManager && window.StorageManager.blockedUntil) {
            window.StorageManager.blockedUntil.localStorage = Date.now() + 86400000; // Block for 24 hours
            window.StorageManager.blockedUntil.sessionStorage = Date.now() + 86400000;
          }
        }
      }
      
      // If storage is disabled, only use API, skip all storage checks
      if (window._storageAccessDisabled) {
        if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.getSelectedLocation) {
          var locPromise = window.inventoryInfo.api.getSelectedLocation();
          if (locPromise && typeof locPromise.then === 'function') {
            locPromise.then(function(loc) {
              if (loc && loc.name) {
                var locationTextEl = document.querySelector('.location-picker-text');
                var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                if (locationTextEl) locationTextEl.textContent = loc.name;
                if (locationTextElMobile) {
                  locationTextElMobile.textContent = loc.name;
                  locationTextElMobile.style.display = 'inline-block';
                }
                lastLocationName = loc.name;
              }
            }).catch(function() {});
          }
        }
        return; // Exit early, completely skip storage checks
      }
      
      // Use debouncing to prevent rapid-fire updates
      if (window._updateLocationTextDebounce) {
        clearTimeout(window._updateLocationTextDebounce);
      }
      window._updateLocationTextDebounce = setTimeout(function() {
        updateLocationTextInternal();
      }, 200);
    }
    
    function updateLocationTextInternal() {
      // Check if shipping mode is active - if so, force Online Warehouse and exit early
      // Check window.currentMethod first (highest priority)
      var currentMethod = window.currentMethod;
      
      // Also check StateManager if available
      if (!currentMethod && window.StateManager && window.StateManager.currentMethod) {
        currentMethod = window.StateManager.currentMethod;
      }
      
      // Check for shipping mode indicators
      var widget = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
      var shippingModeActive = currentMethod === 'shipping' ||
                             document.body.classList.contains('shipping-mode-shipping') ||
                             (widget && widget.classList.contains('shipping-mode-shipping'));
      
      if (shippingModeActive) {
        var onlineLocationLabel = (window.inventoryInfo && window.inventoryInfo.settings && window.inventoryInfo.settings.onlineLocationLabel) 
                                  ? window.inventoryInfo.settings.onlineLocationLabel 
                                  : 'Online Warehouse';
        // Use centralized update function
        if (typeof window.updateHeaderText === 'function') {
          window.updateHeaderText(onlineLocationLabel);
        } else {
          // Fallback if function not available
          var locationTextEl = document.querySelector('.location-picker-text');
          var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
          if (locationTextEl && locationTextEl.textContent !== onlineLocationLabel) {
            locationTextEl.textContent = onlineLocationLabel;
          }
          if (locationTextElMobile && locationTextElMobile.textContent !== onlineLocationLabel) {
            locationTextElMobile.textContent = onlineLocationLabel;
            locationTextElMobile.style.display = 'inline-block';
          }
        }
        // Clear any selected location when in shipping mode
        if (window.inventoryInfo && window.inventoryInfo.selectedLocation) {
          window.inventoryInfo.selectedLocation = null;
        }
        return;
      }
      
      // Prevent concurrent executions, but add timeout safety
      if (isUpdating) {
        // If stuck for more than 5 seconds, reset and try again
        if (window._lastUpdateAttempt && (Date.now() - window._lastUpdateAttempt) > 5000) {
          isUpdating = false;
        } else {
          return;
        }
      }
      
      var locationTextEl = document.querySelector('.location-picker-text');
      var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
      if (!locationTextEl && !locationTextElMobile) {
        return;
      }
      
      isUpdating = true;
      window._lastUpdateAttempt = Date.now();
      
      // Safety timeout to always reset isUpdating
      setTimeout(function() {
        isUpdating = false;
      }, 3000);
      
      var locationName = null;
      var foundMethod = '';
      
      // Method 1: Check inventoryInfo API
      if (window.inventoryInfo) {
        try {
          // Check API object
          if (window.inventoryInfo.api) {
            // getSelectedLocation returns a Promise - handle it properly
            if (window.inventoryInfo.api.getSelectedLocation) {
              var locPromise = window.inventoryInfo.api.getSelectedLocation();
              
              // If it's a Promise, we need to handle it asynchronously
              if (locPromise && typeof locPromise.then === 'function') {
                locPromise.then(function(loc) {
                  if (loc && loc.name && loc.name !== lastLocationName) {
                    var locationTextEl = document.querySelector('.location-picker-text');
                    var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                    if (locationTextEl) {
                      locationTextEl.textContent = loc.name;
                    }
                    if (locationTextElMobile) {
                      locationTextElMobile.textContent = loc.name;
                      locationTextElMobile.style.display = 'inline-block';
                    }
                    lastLocationName = loc.name;
                    isUpdating = false;
                  }
                }).catch(function(err) {
                  isUpdating = false;
                });
                // Don't wait for promise, continue checking other methods
              } else if (locPromise && locPromise.name) {
                // If it's not a promise (synchronous)
                locationName = locPromise.name;
                foundMethod = 'getSelectedLocation';
              }
            }
            
            // Try getSelectedLocationInfo (might also be async)
            if (!locationName && window.inventoryInfo.api.getSelectedLocationInfo) {
              try {
                var locInfo = window.inventoryInfo.api.getSelectedLocationInfo();
                if (locInfo && typeof locInfo.then === 'function') {
                  locInfo.then(function(info) {
                    if (info && info.name && info.name !== lastLocationName) {
                      var locationTextEl = document.querySelector('.location-picker-text');
                      var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                      if (locationTextEl) {
                        locationTextEl.textContent = info.name;
                      }
                      if (locationTextElMobile) {
                        locationTextElMobile.textContent = info.name;
                        locationTextElMobile.style.display = 'inline-block';
                      }
                      lastLocationName = info.name;
                      isUpdating = false;
                    }
                  }).catch(function(err) {
                    isUpdating = false;
                  });
                } else if (locInfo && locInfo.name) {
                  locationName = locInfo.name;
                  foundMethod = 'getSelectedLocationInfo';
                }
              } catch (e) {
                // Silently handle errors
              }
            }
            
            // Try getSelectedLocationId and then fetch location name
            if (!locationName && window.inventoryInfo.api.getSelectedLocationId) {
              var locId = window.inventoryInfo.api.getSelectedLocationId();
              if (locId && typeof locId.then === 'function') {
                locId.then(function(id) {
                  // Try to get location name from locationSettings or other sources
                  if (window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.locations) {
                    var locations = window.inventoryInfo.locationSettings.locations;
                    for (var i = 0; i < locations.length; i++) {
                      if (locations[i].id === id || locations[i].locationId === id) {
                        var locationTextEl = document.querySelector('.location-picker-text');
                        var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                        var locationName = locations[i].name || locations[i].locationName || 'My Store';
                        if (locationTextEl && locationName !== lastLocationName) {
                          locationTextEl.textContent = locationName;
                        }
                        if (locationTextElMobile && locationName !== lastLocationName) {
                          locationTextElMobile.textContent = locationName;
                          locationTextElMobile.style.display = 'inline-block';
                        }
                        lastLocationName = locationName;
                        isUpdating = false;
                        break;
                      }
                    }
                  }
                }).catch(function(err) {
                  isUpdating = false;
                });
              } else if (locId) {
                // Try to find location by ID
                if (window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.locations) {
                  var locations = window.inventoryInfo.locationSettings.locations;
                  for (var i = 0; i < locations.length; i++) {
                    if (locations[i].id === locId || locations[i].locationId === locId) {
                      locationName = locations[i].name || locations[i].locationName;
                      foundMethod = 'getSelectedLocationId';
                      break;
                    }
                  }
                }
              }
            }
          }
          
          // Check direct properties
          if (!locationName && window.inventoryInfo.selectedLocation) {
            var loc = window.inventoryInfo.selectedLocation;
            if (loc && loc.name) {
              locationName = loc.name;
              foundMethod = 'selectedLocation property';
            }
          }
          if (!locationName && window.inventoryInfo.currentLocation) {
            var loc = window.inventoryInfo.currentLocation;
            if (loc && loc.name) {
              locationName = loc.name;
              foundMethod = 'currentLocation property';
            }
          }
          if (!locationName && window.inventoryInfo.location) {
            var loc = window.inventoryInfo.location;
            if (loc && loc.name) {
              locationName = loc.name;
              foundMethod = 'location property';
            }
          }
        } catch(e) {
          // Silently handle errors
        }
      }
      
      // Method 2: Check localStorage (using StorageManager to prevent repeated access)
      // Cache storage check results to avoid repeated access - only check once per page load
      if (!locationName && !window._locationStorageChecked) {
        window._locationStorageChecked = true;
        var StorageManager = window.StorageManager || {};
        // Check if storage is already blocked - if so, skip entirely
        if (StorageManager.blockedUntil && Date.now() < StorageManager.blockedUntil.localStorage) {
          // Storage is blocked, skip localStorage check
        } else {
          var allKeys = StorageManager.getLocalStorageKeys ? StorageManager.getLocalStorageKeys() : [];
        if (allKeys.length > 0) {
          var locationKeys = allKeys.filter(function(k) {
            return k.toLowerCase().indexOf('location') !== -1 || 
                   k.toLowerCase().indexOf('inventory') !== -1 ||
                   k.toLowerCase().indexOf('iia') !== -1;
          });
          
          for (var i = 0; i < locationKeys.length; i++) {
            var stored = StorageManager.getLocalStorage ? StorageManager.getLocalStorage(locationKeys[i]) : null;
            if (stored) {
              try {
                var data = JSON.parse(stored);
                if (data && data.name) {
                  locationName = data.name;
                  foundMethod = 'localStorage: ' + locationKeys[i];
                  break;
                } else if (data && typeof data === 'object') {
                  // Try to find name in nested object
                  var findName = function(obj) {
                    if (obj.name) return obj.name;
                    for (var key in obj) {
                      if (typeof obj[key] === 'object' && obj[key] && obj[key].name) {
                        return obj[key].name;
                      }
                    }
                    return null;
                  };
                  var name = findName(data);
                  if (name) {
                    locationName = name;
                    foundMethod = 'localStorage (nested): ' + locationKeys[i];
                    break;
                  }
                }
              } catch(e) {
                // Might be plain string
                if (stored && stored.length < 100 && stored.length > 0) {
                  locationName = stored;
                  foundMethod = 'localStorage (string): ' + locationKeys[i];
                  break;
                }
              }
            }
          }
        }
        }
      }
      
      // Method 3: Check sessionStorage (using StorageManager)
      // Only check if we haven't found location name yet and haven't checked sessionStorage
      if (!locationName && !window._locationSessionStorageChecked) {
        window._locationSessionStorageChecked = true;
        var StorageManager = window.StorageManager || {};
        var sessionKeys = StorageManager.getSessionStorageKeys ? StorageManager.getSessionStorageKeys() : [];
        if (sessionKeys.length > 0) {
          sessionKeys = sessionKeys.filter(function(k) {
            return k.toLowerCase().indexOf('location') !== -1 || 
                   k.toLowerCase().indexOf('inventory') !== -1;
          });
          for (var i = 0; i < sessionKeys.length; i++) {
            var stored = StorageManager.getSessionStorage ? StorageManager.getSessionStorage(sessionKeys[i]) : null;
            if (stored) {
              try {
                var data = JSON.parse(stored);
                if (data && data.name) {
                  locationName = data.name;
                  foundMethod = 'sessionStorage: ' + sessionKeys[i];
                  break;
                }
              } catch(e) {}
            }
          }
        }
      }
      
      // Update the text - check both lastLocationName AND current text content
      var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
      var locationTextElMenu = document.querySelector('.location-picker-text-menu');
      
      if (locationName) {
        // Update if location changed OR if text doesn't match (in case DOM was reset)
        var needsUpdate = false;
        if (locationName !== lastLocationName) {
          needsUpdate = true;
        } else {
          // Check if text elements actually show the correct location
          if (locationTextEl && locationTextEl.textContent !== locationName) {
            needsUpdate = true;
          }
          if (locationTextElMobile && locationTextElMobile.textContent !== locationName) {
            needsUpdate = true;
          }
        }
        
        if (needsUpdate) {
          if (locationTextEl) {
            locationTextEl.textContent = locationName;
            
            // Check if shipping should be disabled for this location
            if (typeof window.enforceShippingOnlyForOnlineWarehouse === 'function') {
              window.enforceShippingOnlyForOnlineWarehouse();
            }
          }
          if (locationTextElMobile) {
            locationTextElMobile.textContent = locationName;
            locationTextElMobile.style.display = 'inline-block';
          }
          if (locationTextElMenu) {
            locationTextElMenu.textContent = locationName;
          }
          lastLocationName = locationName;
        }
      } else if (!locationName) {
        // No location found - reset to default
        if (locationTextEl && locationTextEl.textContent !== 'My Store') {
          locationTextEl.textContent = 'My Store';
          lastLocationName = null;
        }
        if (locationTextElMobile && locationTextElMobile.textContent !== 'My Store') {
          locationTextElMobile.textContent = 'My Store';
          locationTextElMobile.style.display = 'none';
          lastLocationName = null;
        }
      }
      
      isUpdating = false;
    }
    
    // Update on page load
    function initLocationDisplay() {
      // Run immediately
      updateLocationText();
      // Run again after delays to catch async updates
      setTimeout(updateLocationText, 1000);
      setTimeout(updateLocationText, 3000);
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initLocationDisplay, 500);
      });
    } else {
      setTimeout(initLocationDisplay, 500);
    }
    
    // Listen for storage changes (only if not blocked)
    try {
      window.addEventListener('storage', function(e) {
        if (e.key && (e.key.toLowerCase().indexOf('location') !== -1 || e.key.toLowerCase().indexOf('inventory') !== -1)) {
          setTimeout(updateLocationText, 100);
        }
      });
    } catch(e) {
      // Storage access blocked - silently continue
    }
    
    // Unified override for showLocationPicker - consolidate all functionality
    var originalShowLocationPicker = null;
    var showLocationPickerHooked = false;
    
    function hookShowLocationPicker() {
      if (showLocationPickerHooked) {
        return true; // Already hooked
      }
      
      if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.showLocationPicker) {
        // Only hook if we haven't already stored the original
        if (!originalShowLocationPicker) {
          originalShowLocationPicker = window.inventoryInfo.api.showLocationPicker;
        }
        
        // Create unified wrapper that does everything
        window.inventoryInfo.api.showLocationPicker = function() {
          console.log('[Location Picker Hook] V7: showLocationPicker() called!');
          console.log('[Location Picker Hook] V7: window.currentMethod:', window.currentMethod);
          
          // Check if we're in local delivery/pickup mode by multiple methods
          var isLocalDelivery = false;
          
          // Method 1: Check window.currentMethod
          if (window.currentMethod === 'local_delivery' || window.currentMethod === 'local_pickup') {
            isLocalDelivery = true;
            console.log('[Location Picker Hook] V7: Detected local delivery/pickup via window.currentMethod');
          }
          
          // Method 2: Check active button
          var activeBtn = document.querySelector('.header-method-btn.active[data-method="local_delivery"], .mobile-method-btn.active[data-method="local_delivery"], .header-method-btn.active[data-method="local_pickup"], .mobile-method-btn.active[data-method="local_pickup"]');
          if (activeBtn) {
            isLocalDelivery = true;
            console.log('[Location Picker Hook] V7: Detected local delivery/pickup via active button');
          }
          
          // Method 3: Check data-active attribute
          var activeBtn2 = document.querySelector('.header-method-btn[data-active="true"][data-method="local_delivery"], .mobile-method-btn[data-active="true"][data-method="local_delivery"]');
          if (activeBtn2) {
            isLocalDelivery = true;
            console.log('[Location Picker Hook] V7: Detected local delivery/pickup via data-active button');
          }
          
          // Method 4: Check if custom availability widget exists (if it does, we're on a product page with local delivery)
          var customWidget = document.getElementById('custom-availability-widget');
          if (customWidget && customWidget.offsetParent !== null) {
            // Widget is visible, we should use our custom dropdown
            isLocalDelivery = true;
            console.log('[Location Picker Hook] V7: Detected local delivery/pickup via custom widget');
          }
          
          // Method 5: Check if Change link was clicked (from within widget)
          // If the call stack includes our change link, use custom dropdown
          var stack = new Error().stack || '';
          if (stack.includes('changeLink') || stack.includes('iia-change-link') || stack.includes('header-change-link')) {
            isLocalDelivery = true;
            console.log('[Location Picker Hook] V7: Detected local delivery/pickup via call stack (Change link)');
          }
          
          // Method 6: ALWAYS use custom dropdown if showLocationDropdown is available
          // This ensures we always use our custom dropdown with proper address input positioning
          if (typeof showLocationDropdown === 'function') {
            console.log('[Location Picker Hook] V7: showLocationDropdown function is available, using it');
            isLocalDelivery = true; // Force use of custom dropdown
          }
          
          console.log('[Location Picker Hook] V7: isLocalDelivery:', isLocalDelivery);
          
          // If we're in local delivery/pickup mode, don't open the full-screen modal
          // Instead, use our dropdown
          if (isLocalDelivery) {
            // FIX: Try to find the element that was actually clicked (e.g., "Change" link)
            // This prevents the dropdown from appearing at the off-screen delivery button position
            var clickedElement = null;
            
            // Try to find a recently clicked element by checking for active/focused elements
            var activeElement = document.activeElement;
            if (activeElement && (
              activeElement.textContent.includes('Change') || 
              activeElement.className.includes('change') ||
              activeElement.id.includes('change')
            )) {
              clickedElement = activeElement;
            }
            
            // Fallback: search for any visible Change link
            if (!clickedElement) {
              var changeLinks = document.querySelectorAll('a[href*="javascript"], .iia-change-link, a[class*="change"]');
              for (var i = 0; i < changeLinks.length; i++) {
                var link = changeLinks[i];
                if (link.textContent.includes('Change') && link.getBoundingClientRect().x > 0) {
                  clickedElement = link;
                  break;
                }
              }
            }
            
            // Final fallback: use the delivery button (old behavior)
            if (!clickedElement) {
              if (!activeBtn && !activeBtn2) {
                activeBtn = document.querySelector('.header-method-btn[data-method="local_delivery"], .mobile-method-btn[data-method="local_delivery"], .header-method-btn[data-method="local_pickup"], .mobile-method-btn[data-method="local_pickup"]');
              }
              clickedElement = activeBtn || activeBtn2;
            }
            
            if (typeof showLocationDropdown === 'function') {
              console.log('[Location Picker Hook] V7: Showing custom dropdown instead of modal');
              showLocationDropdown(clickedElement);
              return null; // Don't open the modal - CRITICAL to prevent original function from running
            } else {
              console.warn('[Location Picker Hook] V7: showLocationDropdown function not available');
            }
          }
          
          // Only call original function if we're NOT in local delivery/pickup mode
          // This prevents the modal from opening and creating address inputs in wrong location
          console.log('[Location Picker Hook] V7: Calling original showLocationPicker (modal will open)');
          var result = originalShowLocationPicker ? originalShowLocationPicker.apply(this, arguments) : null;
          
          // Ensure header is visible
          if (typeof ensureHeaderVisible === 'function') {
            ensureHeaderVisible();
            setTimeout(ensureHeaderVisible, 100);
            setTimeout(ensureHeaderVisible, 500);
            setTimeout(ensureHeaderVisible, 1000);
          }
          
          // Automatically expand/show location list when modal opens
          function expandLocationList() {
            // Try multiple selectors for the location picker modal
            var modal = document.querySelector('.iia-locationModal, [class*="iia-locationModal"], dialog[open], .iia-modal, [class*="iia-modal"]');
            if (!modal) {
              // Try to find any dialog element that's open
              var dialogs = document.querySelectorAll('dialog');
              for (var i = 0; i < dialogs.length; i++) {
                if (dialogs[i].open || dialogs[i].hasAttribute('open')) {
                  modal = dialogs[i];
                  break;
                }
              }
            }
            
            if (modal) {
              // Find dropdown/select elements and expand them
              var selects = modal.querySelectorAll('select, .iia-locations-select, [class*="iia-locations-select"]');
              selects.forEach(function(select) {
                // For select elements, try multiple methods to open the dropdown
                if (select.tagName === 'SELECT') {
                  // Method 1: Set size attribute to show options (temporary)
                  var originalSize = select.size;
                  var optionCount = select.options.length;
                  if (optionCount > 0 && optionCount <= 20) {
                    select.size = optionCount;
                    // Reset after a moment
                    setTimeout(function() {
                      select.size = originalSize || 1;
                    }, 100);
                  }
                  
                  // Method 2: Focus and trigger events
                  if (select.focus) {
                    select.focus();
                  }
                  
                  // Method 3: Create and dispatch mousedown event
                  try {
                    var mousedownEvent = new MouseEvent('mousedown', {
                      bubbles: true,
                      cancelable: true,
                      view: window,
                      button: 0
                    });
                    select.dispatchEvent(mousedownEvent);
                  } catch(e) {}
                  
                  // Method 4: Create and dispatch click event
                  try {
                    var clickEvent = new MouseEvent('click', {
                      bubbles: true,
                      cancelable: true,
                      view: window,
                      button: 0
                    });
                    select.dispatchEvent(clickEvent);
                  } catch(e) {}
                  
                  // Method 5: Try to trigger the dropdown by simulating user interaction
                  try {
                    var mouseupEvent = new MouseEvent('mouseup', {
                      bubbles: true,
                      cancelable: true,
                      view: window,
                      button: 0
                    });
                    select.dispatchEvent(mouseupEvent);
                  } catch(e) {}
                } else {
                  // For non-select elements, just ensure they're visible
                  select.style.display = 'block';
                  select.style.visibility = 'visible';
                  select.style.opacity = '1';
                }
              });
              
              // Also look for any collapsible/expandable elements
              var collapsibles = modal.querySelectorAll('[class*="collapse"], [class*="expand"], [aria-expanded="false"]');
              collapsibles.forEach(function(el) {
                var clickEvent = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window
                });
                el.dispatchEvent(clickEvent);
              });
              
              // Look for location list containers and ensure they're visible
              var locationLists = modal.querySelectorAll('.iia-location-list, [class*="iia-location-list"], .iia-list-item, [class*="iia-list"], [class*="location-list"], [class*="locations-list"]');
              locationLists.forEach(function(list) {
                list.style.display = 'block';
                list.style.visibility = 'visible';
                list.style.opacity = '1';
                list.style.maxHeight = 'none';
                list.style.height = 'auto';
                list.style.overflow = 'visible';
              });
              
              // Look for any elements that might be hiding the location list
              var hiddenElements = modal.querySelectorAll('[style*="display: none"], [style*="display:none"], [hidden], [aria-hidden="true"]');
              hiddenElements.forEach(function(el) {
                // Only show if it looks like a location-related element
                var classList = el.className || '';
                var id = el.id || '';
                if (classList.indexOf('location') !== -1 || 
                    classList.indexOf('iia') !== -1 ||
                    id.indexOf('location') !== -1 ||
                    id.indexOf('iia') !== -1) {
                  el.style.display = 'block';
                  el.style.visibility = 'visible';
                  el.style.opacity = '1';
                  el.removeAttribute('hidden');
                  el.setAttribute('aria-hidden', 'false');
                }
              });
            }
          }
          
          // Try to expand immediately and after delays (modal might not be ready yet)
          setTimeout(expandLocationList, 50);
          setTimeout(expandLocationList, 200);
          setTimeout(expandLocationList, 500);
          
          // Also watch for modal to appear
          var modalObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(function(node) {
                  if (node.nodeType === 1) { // Element node
                    if (node.classList && (
                      node.classList.contains('iia-locationModal') ||
                      node.classList.contains('iia-modal') ||
                      node.tagName === 'DIALOG'
                    )) {
                      expandLocationList();
                      modalObserver.disconnect();
                    }
                  }
                });
              }
            });
          });
          if (document.body && document.body.nodeType === 1) {
            try {
              modalObserver.observe(document.body, {
                childList: true,
                subtree: true
              });
            } catch(e) {
              // Silently fail if observation fails
            }
          }
          
          // Disconnect observer after 5 seconds
          setTimeout(function() {
            modalObserver.disconnect();
          }, 5000);
          
          // Update location text after selection
          setTimeout(updateLocationText, 1000);
          setTimeout(updateLocationText, 3000);
          
          // Reapply formatting after location picker closes
          setTimeout(reapplyFormatting, 500);
          setTimeout(reapplyFormatting, 1500);
          
          return result;
        };
        
        showLocationPickerHooked = true;
        return true;
      }
      return false;
    }
    
    // Try to hook immediately
    hookShowLocationPicker();
    
    // Try to hook when API becomes available (with timeout)
    var apiCheckCount = 0;
    var apiCheckInterval = setInterval(function() {
      apiCheckCount++;
      if (hookShowLocationPicker() || apiCheckCount >= 20) {
        clearInterval(apiCheckInterval);
      }
    }, 1000);
    
    // Function to re-run all formatting when location changes
    function reapplyFormatting() {
      // Reset formatted flags to allow re-processing
      var titleTexts = document.querySelectorAll('.iia-title-text');
      titleTexts.forEach(function(el) {
        delete el.dataset.formatted;
        delete el.dataset.lastContent;
      });
      
      var addresses = document.querySelectorAll('.iia-address');
      addresses.forEach(function(el) {
        delete el.dataset.formatted;
        delete el.dataset.lastContent;
      });
      
      // Run formatting functions and update header
      setTimeout(function() {
        if (typeof window.formatPhoneNumbers === 'function') window.formatPhoneNumbers();
        if (typeof formatAddresses === 'function') formatAddresses();
        if (typeof fixTitleTextLineBreaks === 'function') fixTitleTextLineBreaks();
        if (typeof fixRadioButtonLayout === 'function') fixRadioButtonLayout();
        if (typeof addSelectedLocationIndicator === 'function') addSelectedLocationIndicator();
        updateLocationText(); // Update header too
      }, 100);
      setTimeout(function() {
        if (typeof window.formatPhoneNumbers === 'function') window.formatPhoneNumbers();
        if (typeof formatAddresses === 'function') formatAddresses();
        if (typeof fixTitleTextLineBreaks === 'function') fixTitleTextLineBreaks();
        if (typeof fixRadioButtonLayout === 'function') fixRadioButtonLayout();
        updateLocationText(); // Update header too
      }, 500);
      setTimeout(function() {
        if (typeof window.formatPhoneNumbers === 'function') window.formatPhoneNumbers();
        if (typeof formatAddresses === 'function') formatAddresses();
        if (typeof fixTitleTextLineBreaks === 'function') fixTitleTextLineBreaks();
        if (typeof fixRadioButtonLayout === 'function') fixRadioButtonLayout();
        updateLocationText(); // Update header too
      }, 1500);
    }
    
    // Listen for custom events - reapply formatting when location changes
    // Use debouncing to prevent rapid-fire updates
    document.addEventListener('locationChanged', function() {
      updateLocationText(); // Already debounced internally
      // Check if StateManager exists before using it
      if (typeof StateManager !== 'undefined' && StateManager && StateManager.debounce) {
        StateManager.debounce('reapplyFormatting', reapplyFormatting, 300);
      } else {
        // Fallback: use setTimeout if StateManager not available
        setTimeout(reapplyFormatting, 300);
      }
      // Check if shipping should be disabled (but not if we're switching to shipping)
      if (typeof window.enforceShippingOnlyForOnlineWarehouse === 'function' && !window.isSwitchingToShipping) {
        setTimeout(window.enforceShippingOnlyForOnlineWarehouse, 300);
      }
    });
    document.addEventListener('locationSelected', function() {
      updateLocationText(); // Already debounced internally
      // Check if StateManager exists before using it
      if (typeof StateManager !== 'undefined' && StateManager && StateManager.debounce) {
        StateManager.debounce('reapplyFormatting', reapplyFormatting, 300);
      } else {
        // Fallback: use setTimeout if StateManager not available
        setTimeout(reapplyFormatting, 300);
      }
      // Check if shipping should be disabled (but not if we're switching to shipping)
      if (typeof window.enforceShippingOnlyForOnlineWarehouse === 'function' && !window.isSwitchingToShipping) {
        setTimeout(window.enforceShippingOnlyForOnlineWarehouse, 300);
      }
    });
    document.addEventListener('inventoryInfo:locationChanged', function() {
      updateLocationText(); // Already debounced internally
      // Check if StateManager exists before using it
      if (typeof StateManager !== 'undefined' && StateManager && StateManager.debounce) {
        StateManager.debounce('reapplyFormatting', reapplyFormatting, 300);
      } else {
        // Fallback: use setTimeout if StateManager not available
        setTimeout(reapplyFormatting, 300);
      }
      // Check if shipping should be disabled (but not if we're switching to shipping)
      if (typeof window.enforceShippingOnlyForOnlineWarehouse === 'function' && !window.isSwitchingToShipping) {
        setTimeout(window.enforceShippingOnlyForOnlineWarehouse, 300);
      }
    });
    
    // Also listen for any changes to the inventory widget
    // Note: showLocationPicker is already hooked above, no need to override again
    
    // Export functions globally for use in other scopes
    window.updateLocationText = updateLocationText;
    window.hookShowLocationPicker = hookShowLocationPicker;
    
})();  // <--- ADD THIS LINE HERE TO CLOSE THE FIRST SCRIPT
    
                // StorageManager is already defined at the top of the script - duplicate removed
                
                // Header Shopping Method Selector (Mud Bay style)
    // State Management System to prevent race conditions and flickering
  (function() {
      // CRITICAL: Restore method IMMEDIATELY, even before DOM is ready
      // This ensures window.currentMethod is set before other scripts initialize
      (function restoreImmediately() {
        try {
          var savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
          if (savedMethod && ['shipping', 'local_delivery', 'local_pickup'].includes(savedMethod)) {
            window.currentMethod = savedMethod;
            console.log('[Header Location Selector] IMMEDIATE restoration:', savedMethod);
            
            // Also try to restore via MutationObserver if DOM elements aren't ready
            // BUT only for non-shipping methods and only once
            if (typeof MutationObserver !== 'undefined' && savedMethod !== 'shipping') {
              var observerTriggered = false;
              var observer = new MutationObserver(function(mutations) {
                // Only trigger once
                if (observerTriggered) return;
                
                var selector = document.querySelector('.header-method-selector');
                if (selector && savedMethod && savedMethod !== 'shipping') {
                  var btn = selector.querySelector('.header-method-btn[data-method="' + savedMethod + '"]');
                  if (btn && !btn.classList.contains('active')) {
                    // Check current method - don't override if user already selected shipping
                    var currentMethodCheck = window.currentMethod || 'shipping';
                    if (currentMethodCheck !== 'shipping') {
                      console.log('[Header Location Selector] MutationObserver: Clicking button for', savedMethod);
                      observerTriggered = true;
                      btn.click();
                      observer.disconnect();
                    }
                  }
                }
              });
              
              if (document.body) {
                observer.observe(document.body, { childList: true, subtree: true });
                // Disconnect after 3 seconds to avoid memory leaks and prevent interference
                setTimeout(function() { 
                  observer.disconnect(); 
                  console.log('[Header Location Selector] MutationObserver disconnected');
                }, 3000);
              }
            }
          }
        } catch(e) {
          console.warn('[Header Location Selector] Error in immediate restoration:', e);
        }
      })();
      
      console.log('[Header Location Selector] Script loading, window.currentMethod:', window.currentMethod);
      
      // Check for header selector, but don't return early - we need to define everything first
      var headerMethodSelector = document.querySelector('.header-method-selector');
      var shouldInitImmediately = headerMethodSelector !== null;
      
      if (!shouldInitImmediately) {
        console.log('[Header Location Selector] Header selector not found yet, will define functions and retry');
      } else {
        console.log('[Header Location Selector] Header selector found, will initialize after setup');
      }
      console.log('[Header Location Selector] Header selector found, initializing...');
      
      // ===== STATE MANAGEMENT =====
      // Initialize with saved method if available, otherwise default to shipping
      // Check localStorage first (synchronous) - but window.currentMethod was already set above
      var initialMethod = window.currentMethod || 'shipping';
      console.log('[Header Location Selector] Using initialMethod from window.currentMethod:', initialMethod);
      
      // Double-check storage in case window.currentMethod wasn't set
      if (initialMethod === 'shipping') {
        console.log('[Header Location Selector] Re-checking storage since initialMethod is shipping...');
        try {
          var StorageManager = window.StorageManager || {};
          var savedMethod = StorageManager.getLocalStorage ? StorageManager.getLocalStorage('shippingMethod') : null;
          if (!savedMethod) {
            savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
          }
          console.log('[Header Location Selector] Saved method from storage (re-check):', savedMethod);
          if (savedMethod && ['shipping', 'local_delivery', 'local_pickup'].includes(savedMethod)) {
            initialMethod = savedMethod;
            window.currentMethod = savedMethod; // Set globally
            console.log('[Header Location Selector] ✓ Restored method from storage (re-check):', savedMethod);
          }
        } catch(e) {
          console.warn('[Header Location Selector] Error reading storage (re-check):', e);
        }
      }
      
      var StateManager = {
        currentMethod: initialMethod,
        lastMethod: null,
        isUpdating: false,
        updateQueue: [],
        debounceTimers: {},
        
        // Debounced update function
        debounce: function(key, fn, delay) {
          if (this.debounceTimers[key]) {
            clearTimeout(this.debounceTimers[key]);
          }
          this.debounceTimers[key] = setTimeout(fn, delay || 300);
        },
        
        // Queue update to prevent race conditions
        queueUpdate: function(fn, priority) {
          if (this.isUpdating && priority !== 'high') {
            this.updateQueue.push(fn);
            return;
          }
          this.executeUpdate(fn);
        },
        
        // Execute update with lock
        executeUpdate: function(fn) {
          if (this.isUpdating) {
            this.updateQueue.push(fn);
            return;
          }
          this.isUpdating = true;
          try {
            fn();
          } catch(e) {
            // Silently handle errors
          }
          this.isUpdating = false;
          
          // Process queue
          if (this.updateQueue.length > 0) {
            var next = this.updateQueue.shift();
            setTimeout(function() {
              StateManager.executeUpdate(next);
            }, 50);
          }
        },
        
        // Check if method changed
        methodChanged: function() {
          return this.currentMethod !== this.lastMethod;
        },
        
        // Update method
        setMethod: function(method) {
          // Prevent resetting to shipping if we have a saved non-shipping preference
          if (method === 'shipping') {
            try {
              var savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
              if (savedMethod && savedMethod !== 'shipping' && ['local_pickup', 'local_delivery'].includes(savedMethod)) {
                // User has a saved preference for pickup/delivery - don't reset to shipping
                console.log('[Header Location Selector] Blocked reset to shipping, saved method is:', savedMethod);
                return; // Don't update to shipping
              }
            } catch(e) {}
          }
          
          this.lastMethod = this.currentMethod;
          this.currentMethod = method;
          // Keep window.currentMethod in sync
          window.currentMethod = method;
        }
      };
      
      // Initialize with saved method if available, otherwise default to shipping
      // IMPORTANT: StateManager.currentMethod is already set from saved values above
      // Use StateManager's value if available, otherwise check window.currentMethod, then default
      var currentMethod = StateManager.currentMethod || window.currentMethod || 'shipping';
      window.currentMethod = currentMethod; // Make it globally accessible
      StateManager.currentMethod = currentMethod; // Ensure StateManager is in sync
      var inventoryInfo = window.inventoryInfo || {};
      var availabilityWidget = null;
      
      // Initialize
      function initHeaderMethodSelector() {
        console.log('[Header Location Selector] initHeaderMethodSelector called, currentMethod:', currentMethod);
        // Find availability widget
        availabilityWidget = document.getElementById('inventory-info-app') || 
                             document.querySelector('.iia-container');
        
        // CRITICAL: Re-check saved method here in case script loaded before localStorage was ready
        try {
          var savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
          if (savedMethod && savedMethod !== 'shipping' && ['shipping', 'local_delivery', 'local_pickup'].includes(savedMethod)) {
            console.log('[Header Location Selector] Found saved method in initHeaderMethodSelector:', savedMethod);
            if (currentMethod === 'shipping' || savedMethod !== currentMethod) {
              currentMethod = savedMethod;
              StateManager.currentMethod = savedMethod;
              window.currentMethod = savedMethod;
              console.log('[Header Location Selector] Updated to saved method:', savedMethod);
            }
          }
        } catch(e) {
          console.warn('[Header Location Selector] Error re-checking storage in init:', e);
        }
        
        // Use the currentMethod that was set at initialization (already checked localStorage/window.currentMethod)
        // StateManager.currentMethod is also already set from saved values
        // Just ensure everything is in sync
        if (StateManager.currentMethod && StateManager.currentMethod !== 'shipping') {
          currentMethod = StateManager.currentMethod;
          window.currentMethod = currentMethod;
          lastSavedMethod = currentMethod;
          console.log('[Header Location Selector] Using StateManager method (restored from storage):', currentMethod);
        }
        
        // Check if method is already set by widget auto-select or restore function (priority override)
        if (window.currentMethod && ['shipping', 'local_delivery', 'local_pickup'].includes(window.currentMethod) && window.currentMethod !== currentMethod) {
          currentMethod = window.currentMethod;
          lastSavedMethod = window.currentMethod;
          StateManager.currentMethod = window.currentMethod;
          if (window.StateManager && window.StateManager.setMethod) {
            window.StateManager.setMethod(window.currentMethod);
          }
          console.log('[Header Location Selector] Overriding with window.currentMethod:', currentMethod);
        }
        
        // If we still defaulted to shipping, check cart attributes as final fallback
        if (currentMethod === 'shipping' && typeof fetch !== 'undefined') {
          // Fallback: Check cart attributes for saved method
          // This ensures method persists even if localStorage is cleared
          (function() {
              fetch('/cart.js')
                .then(function(response) {
                  return response.json();
                })
                .then(function(cart) {
                  if (cart && cart.attributes) {
                    var attributes = cart.attributes;
                    var cartMethod = null;
                    
                    // Check cart attributes in priority order
                    if (attributes._is_pickup === 'true' || attributes._shipping_method === 'local_pickup') {
                      cartMethod = 'local_pickup';
                    } else if (attributes._is_delivery === 'true' || attributes._shipping_method === 'local_delivery') {
                      cartMethod = 'local_delivery';
                    } else if (attributes._shipping_method) {
                      cartMethod = attributes._shipping_method;
                    }
                    
                    if (cartMethod && ['shipping', 'local_delivery', 'local_pickup'].includes(cartMethod)) {
                      currentMethod = cartMethod;
                      lastSavedMethod = cartMethod;
                      window.currentMethod = cartMethod;
                      StateManager.currentMethod = cartMethod;
                      
                      // Save to localStorage for future loads
                      try {
                        if (StorageManager.setLocalStorage) {
                          StorageManager.setLocalStorage('shippingMethod', cartMethod);
                        } else {
                          localStorage.setItem('shippingMethod', cartMethod);
                        }
                        if (StorageManager.setSessionStorage) {
                          StorageManager.setSessionStorage('shippingMethod', cartMethod);
                        } else {
                          sessionStorage.setItem('shippingMethod', cartMethod);
                        }
                      } catch(e) {
                        console.warn('[Header Location Selector] Could not save to localStorage:', e);
                      }
                      
                      // Update StateManager
                      if (StateManager && StateManager.setMethod) {
                        StateManager.setMethod(cartMethod);
                      }
                      
                      // Update UI to reflect the restored method
                      updateActiveButton();
                      updateWidgetDisplay();
                      
                      console.log('[Header Location Selector] Restored method from cart attributes:', cartMethod);
                    }
                  }
                })
                .catch(function(error) {
                  // Silently fail - cart might not be available
                });
          })();
        }
        
        // Ensure StateManager is synced before updating UI
        StateManager.currentMethod = currentMethod;
        window.currentMethod = currentMethod;
        console.log('[Header Location Selector] About to update UI, currentMethod:', currentMethod);
        
        // Set initial active state
        updateActiveButton();
        updateWidgetDisplay();
        
        // Also trigger StateManager.setMethod to ensure all listeners are notified
        if (currentMethod !== 'shipping') {
          StateManager.setMethod(currentMethod);
          console.log('[Header Location Selector] ✓ Initialized with method:', currentMethod);
          
          // Force UI update one more time after a tiny delay to ensure buttons are in DOM
          setTimeout(function() {
            var activeBtn = headerMethodSelector ? headerMethodSelector.querySelector('.header-method-btn[data-method="' + currentMethod + '"]') : null;
            var activeBtnIsActive = activeBtn && (activeBtn.classList.contains('active') || activeBtn.getAttribute('data-active') === 'true');
            
            console.log('[Header Location Selector] Checking UI state - method:', currentMethod, 'button found:', !!activeBtn, 'is active:', activeBtnIsActive);
            
            if (!activeBtnIsActive && activeBtn) {
              console.log('[Header Location Selector] Button not active, forcing click');
              activeBtn.click();
            } else if (!activeBtn) {
              console.warn('[Header Location Selector] Button not found for method:', currentMethod);
              updateActiveButton(); // Try updating again
            }
          }, 100);
        } else {
          console.log('[Header Location Selector] Initialized with default shipping method');
        }
        
        // Also force update UI after a short delay to catch late restorations
        setTimeout(function() {
          var saved = null;
          try {
            saved = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
          } catch(e) {}
          
          if (saved && saved !== 'shipping' && saved !== currentMethod) {
            console.log('[Header Location Selector] Found saved method (500ms), updating UI:', saved);
            currentMethod = saved;
            StateManager.currentMethod = saved;
            window.currentMethod = saved;
            StateManager.setMethod(saved);
            updateActiveButton();
            updateWidgetDisplay();
            
            // Force click the button if UI still doesn't update
            setTimeout(function() {
              var btn = headerMethodSelector ? headerMethodSelector.querySelector('.header-method-btn[data-method="' + saved + '"]') : null;
              if (btn && !btn.classList.contains('active')) {
                console.log('[Header Location Selector] Forcing button click for:', saved);
                btn.click();
              }
            }, 100);
          }
        }, 500);
        
        // Check if shipping should be disabled based on current location
        // Wait longer to ensure widget is fully initialized AND restoration has completed
        setTimeout(function() {
          // Only enforce if widget has loaded and we're not switching
          // BUT don't enforce if we have a saved method preference (to prevent overriding restoration)
          var shouldEnforce = !isSwitchingToShipping && !window.isSwitchingToShipping && availabilityWidget;
          if (shouldEnforce) {
            // Check if we have a saved preference that should not be overridden
            try {
              var savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
              if (savedMethod && savedMethod !== 'shipping' && savedMethod === currentMethod) {
                // We have a saved non-shipping method and it matches current - don't enforce
                console.log('[Header Location Selector] Skipping enforcement, saved method matches:', savedMethod);
                shouldEnforce = false;
              }
            } catch(e) {}
          }
          
          if (shouldEnforce) {
            enforceShippingOnlyForOnlineWarehouse();
          }
          
          // Double-check and force UI update if method doesn't match saved value
          // This ensures restoration works even if it happened late
          var savedMethod = null;
          try {
            var StorageManager = window.StorageManager || {};
            savedMethod = StorageManager.getLocalStorage ? StorageManager.getLocalStorage('shippingMethod') : null;
            if (!savedMethod) {
              savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
            }
          } catch(e) {}
          
          // Also check cart attributes as backup
          if (!savedMethod || savedMethod === 'shipping') {
            fetch('/cart.js').then(function(response) {
              return response.json();
            }).then(function(cart) {
              if (cart && cart.attributes) {
                var attributes = cart.attributes;
                if (attributes._is_pickup === 'true' || attributes._shipping_method === 'local_pickup') {
                  savedMethod = 'local_pickup';
                } else if (attributes._is_delivery === 'true' || attributes._shipping_method === 'local_delivery') {
                  savedMethod = 'local_delivery';
                } else if (attributes._shipping_method) {
                  savedMethod = attributes._shipping_method;
                }
              }
              
              // Now apply the saved method
              if (savedMethod && savedMethod !== 'shipping' && savedMethod !== currentMethod && ['shipping', 'local_delivery', 'local_pickup'].includes(savedMethod)) {
                console.log('[Header Location Selector] Delayed restoration (2s): Updating UI to saved method:', savedMethod);
                currentMethod = savedMethod;
                StateManager.currentMethod = savedMethod;
                window.currentMethod = savedMethod;
                // Use setMethod to update, which will respect saved preferences
                StateManager.setMethod(savedMethod);
                updateActiveButton();
                updateWidgetDisplay();
                
                // Force click the button if UI still doesn't update
                setTimeout(function() {
                  var btn = headerMethodSelector ? headerMethodSelector.querySelector('.header-method-btn[data-method="' + savedMethod + '"]') : null;
                  if (btn && !btn.classList.contains('active')) {
                    console.log('[Header Location Selector] Forcing button click for:', savedMethod);
                    btn.click();
                  }
                }, 100);
              }
            }).catch(function() {});
          } else if (savedMethod && savedMethod !== 'shipping' && savedMethod !== currentMethod && ['shipping', 'local_delivery', 'local_pickup'].includes(savedMethod)) {
            console.log('[Header Location Selector] Delayed restoration (2s): Updating UI to saved method:', savedMethod);
            currentMethod = savedMethod;
            StateManager.currentMethod = savedMethod;
            window.currentMethod = savedMethod;
            StateManager.setMethod(savedMethod);
            updateActiveButton();
            updateWidgetDisplay();
            
            // Force click the button if UI still doesn't update
            setTimeout(function() {
              var btn = headerMethodSelector ? headerMethodSelector.querySelector('.header-method-btn[data-method="' + savedMethod + '"]') : null;
              if (btn && !btn.classList.contains('active')) {
                console.log('[Header Location Selector] Forcing button click for:', savedMethod);
                btn.click();
              }
            }, 100);
          }
        }, 2000);
        
        // Add click handlers for desktop buttons
        if (headerMethodSelector) {
          var buttons = headerMethodSelector.querySelectorAll('.header-method-btn');
          buttons.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              var method = this.getAttribute('data-method');
              if (method && method !== currentMethod) {
                // Update method immediately
                StateManager.setMethod(method);
                currentMethod = method;
                window.currentMethod = method; // Update global reference
                // Reset update lock to ensure immediate execution
                StateManager.isUpdating = false;
                
                // If switching to shipping, immediately update header to Online Warehouse
                if (method === 'shipping') {
                  // Set flag to prevent enforcement during switch
                  isSwitchingToShipping = true;
                  window.isSwitchingToShipping = true;
                  
                  var onlineLocationLabel = (inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocationLabel) 
                                            ? inventoryInfo.settings.onlineLocationLabel 
                                            : 'Online Warehouse';
                  if (typeof window.updateHeaderText === 'function') {
                    window.updateHeaderText(onlineLocationLabel);
                  } else {
                    // Fallback direct update
                    var locationTextEl = document.querySelector('.location-picker-text');
                    var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                    if (locationTextEl) locationTextEl.textContent = onlineLocationLabel;
                    if (locationTextElMobile) {
                      locationTextElMobile.textContent = onlineLocationLabel;
                      locationTextElMobile.style.display = 'inline-block';
                    }
                  }
                  
                  // Clear flag after updates complete
                  setTimeout(function() {
                    isSwitchingToShipping = false;
                    window.isSwitchingToShipping = false;
                  }, 2000);
                } else {
                  // Not switching to shipping, clear flag
                  isSwitchingToShipping = false;
                  window.isSwitchingToShipping = false;
                }
                
                // Execute updates immediately
                updateActiveButton();
                updateWidgetDisplay();
                savePreference();
                
                // If switching to local delivery/pickup, show dropdown
                if (method === 'local_delivery' || method === 'local_pickup') {
                  var clickedButton = this;
                  setTimeout(function() {
                    showLocationDropdown(clickedButton);
                  }, 100);
                }
              }
            });
          });
        }
        
        // Add click handlers for mobile buttons
        var mobileSelector = document.querySelector('.mobile-method-selector');
        if (mobileSelector) {
          var mobileButtons = mobileSelector.querySelectorAll('.mobile-method-btn');
          mobileButtons.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              var method = this.getAttribute('data-method');
              if (method && method !== currentMethod) {
                // Update method immediately
                StateManager.setMethod(method);
                currentMethod = method;
                window.currentMethod = method; // Update global reference
                // Reset update lock to ensure immediate execution
                StateManager.isUpdating = false;
                
                // If switching to shipping, immediately update header to Online Warehouse
                if (method === 'shipping') {
                  // Set flag to prevent enforcement during switch
                  isSwitchingToShipping = true;
                  window.isSwitchingToShipping = true;
                  
                  var onlineLocationLabel = (inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocationLabel) 
                                            ? inventoryInfo.settings.onlineLocationLabel 
                                            : 'Online Warehouse';
                  if (typeof window.updateHeaderText === 'function') {
                    window.updateHeaderText(onlineLocationLabel);
                  } else {
                    // Fallback direct update
                    var locationTextEl = document.querySelector('.location-picker-text');
                    var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                    if (locationTextEl) locationTextEl.textContent = onlineLocationLabel;
                    if (locationTextElMobile) {
                      locationTextElMobile.textContent = onlineLocationLabel;
                      locationTextElMobile.style.display = 'inline-block';
                    }
                  }
                  
                  // Clear flag after updates complete
                  setTimeout(function() {
                    isSwitchingToShipping = false;
                    window.isSwitchingToShipping = false;
                  }, 2000);
                } else {
                  // Not switching to shipping, clear flag
                  isSwitchingToShipping = false;
                  window.isSwitchingToShipping = false;
                }
                
                // Execute updates immediately
                updateActiveButton();
                updateWidgetDisplay();
                savePreference();
                
                // If switching to local delivery/pickup, show dropdown
                if (method === 'local_delivery' || method === 'local_pickup') {
                  var clickedButton = this;
                  setTimeout(function() {
                    showLocationDropdown(clickedButton);
                  }, 100);
                }
              }
            });
          });
        }
      }
      
      // Check if location is Online Warehouse
      function isOnlineWarehouse(locationName) {
        if (!locationName) return false;
        var name = locationName.toLowerCase();
        var onlineLabels = ['online warehouse', 'online', 'warehouse', 'all locations', 'everywhere'];
        return onlineLabels.some(function(label) {
          return name.indexOf(label) !== -1;
        });
      }
      
      // Flag to prevent recursive calls
      var isEnforcingShippingRule = false;
      var isSwitchingToShipping = false; // Flag to prevent enforcement during shipping switch
      window.isSwitchingToShipping = false; // Make it globally accessible
      
      // Enforce that shipping is only available for Online Warehouse
      function enforceShippingOnlyForOnlineWarehouse() {
        // Prevent recursive calls or enforcement during shipping switch
        if (isEnforcingShippingRule) return;
        if (isSwitchingToShipping || window.isSwitchingToShipping) return; // Don't enforce while switching to shipping
        
        // Don't enforce during initial page load (wait for widget to initialize)
        if (!availabilityWidget || !document.querySelector('.iia-list-item')) {
          return;
        }
        
        // IMPORTANT: Don't enforce if we have a saved method preference (localStorage or cart attributes)
        // This prevents overriding user's selection when navigating between pages
        try {
          var savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
          if (savedMethod && savedMethod !== 'shipping') {
            // User has a saved preference for pickup/delivery, don't override it
            return;
          }
        } catch(e) {}
        
        // Also check cart attributes for saved method preference
        if (typeof fetch !== 'undefined' && currentMethod !== 'shipping') {
          // If currentMethod is already not shipping, check if it was intentionally saved
          fetch('/cart.js').then(function(response) {
            return response.json();
          }).then(function(cart) {
            if (cart && cart.attributes) {
              var attributes = cart.attributes;
              if (attributes._is_pickup === 'true' || attributes._is_delivery === 'true' || 
                  (attributes._shipping_method && attributes._shipping_method !== 'shipping')) {
                // Method was intentionally saved in cart, don't override
                return;
              }
            }
          }).catch(function() {});
        }
        
        if (currentMethod !== 'shipping') return; // Only check if shipping is selected
        
        // Get current location name
        var locationName = null;
        var locationTextEl = document.querySelector('.location-picker-text');
        if (locationTextEl) {
          locationName = locationTextEl.textContent;
        }
        
        // If we have a location name and it's not Online Warehouse, switch to local_delivery
        if (locationName && !isOnlineWarehouse(locationName)) {
          isEnforcingShippingRule = true; // Set flag to prevent recursion
          console.log('Physical location selected (' + locationName + '), switching from shipping to local_delivery');
          // Switch to local_delivery
          currentMethod = 'local_delivery';
          window.currentMethod = 'local_delivery';
          StateManager.setMethod('local_delivery');
          
          // Update UI directly without calling updateActiveButton to avoid recursion
          // Update desktop buttons
          if (headerMethodSelector) {
            var buttons = headerMethodSelector.querySelectorAll('.header-method-btn');
            buttons.forEach(function(btn) {
              var isActive = btn.getAttribute('data-method') === currentMethod;
              if (isActive) {
                btn.style.borderColor = '#298029';
                btn.style.backgroundColor = '#f0f8f0';
                btn.style.color = '#298029';
                btn.style.fontWeight = '500';
                btn.setAttribute('data-active', 'true');
                btn.classList.add('active');
              } else {
                btn.style.borderColor = '#d0d0d0';
                btn.style.backgroundColor = '#ffffff';
                btn.style.color = '#293149';
                btn.style.fontWeight = '400';
                btn.removeAttribute('data-active');
                btn.classList.remove('active');
              }
            });
          }
          
          // Update mobile buttons
          var mobileSelector = document.querySelector('.mobile-method-selector');
          if (mobileSelector) {
            var mobileButtons = mobileSelector.querySelectorAll('.mobile-method-btn');
            mobileButtons.forEach(function(btn) {
              var isActive = btn.getAttribute('data-method') === currentMethod;
              if (isActive) {
                btn.style.borderColor = '#298029';
                btn.style.backgroundColor = '#f0f8f0';
                btn.style.color = '#298029';
                btn.style.fontWeight = '500';
                btn.setAttribute('data-active', 'true');
                btn.classList.add('active');
              } else {
                btn.style.borderColor = '#d0d0d0';
                btn.style.backgroundColor = '#ffffff';
                btn.style.color = '#293149';
                btn.style.fontWeight = '400';
                btn.removeAttribute('data-active');
                btn.classList.remove('active');
              }
            });
          }
          
          updateWidgetDisplay();
          savePreference();
          
          // Reset flag after a short delay
          setTimeout(function() {
            isEnforcingShippingRule = false;
          }, 100);
        }
      }
      
      function updateActiveButton() {
        // Only enforce shipping rule if we're not already enforcing (prevent recursion)
        // BUT skip enforcement if we have a saved method preference that matches current
        if (!isEnforcingShippingRule) {
          var shouldEnforce = true;
          try {
            var savedMethod = localStorage.getItem('shippingMethod') || sessionStorage.getItem('shippingMethod');
            if (savedMethod && savedMethod !== 'shipping' && savedMethod === currentMethod) {
              // We have a saved non-shipping method and it matches current - don't enforce
              shouldEnforce = false;
            }
          } catch(e) {}
          
          if (shouldEnforce) {
            enforceShippingOnlyForOnlineWarehouse();
          }
        }
        
        // Update desktop buttons
        if (headerMethodSelector) {
          var buttons = headerMethodSelector.querySelectorAll('.header-method-btn');
          var activeButton = null;
          buttons.forEach(function(btn) {
            var btnMethod = btn.getAttribute('data-method');
            var isActive = btnMethod === currentMethod;
            if (isActive) {
              activeButton = btn;
              btn.style.borderColor = '#298029';
              btn.style.backgroundColor = '#f0f8f0';
              btn.style.color = '#298029';
              btn.style.fontWeight = '500';
              btn.setAttribute('data-active', 'true');
              btn.classList.add('active');
            } else {
              btn.style.borderColor = '#d0d0d0';
              btn.style.backgroundColor = '#ffffff';
              btn.style.color = '#293149';
              btn.style.fontWeight = '400';
              btn.removeAttribute('data-active');
              btn.classList.remove('active');
            }
          });
          
          // If we have a currentMethod but no active button was found, try to click it
          if (currentMethod && currentMethod !== 'shipping' && !activeButton) {
            var targetButton = headerMethodSelector.querySelector('.header-method-btn[data-method="' + currentMethod + '"]');
            if (targetButton) {
              console.log('[Header Location Selector] No active button found, clicking method button:', currentMethod);
              targetButton.click();
            }
          }
        }
        
        // Update mobile buttons
        var mobileSelector = document.querySelector('.mobile-method-selector');
        var mobileActiveButton = null;
        if (mobileSelector) {
          var mobileButtons = mobileSelector.querySelectorAll('.mobile-method-btn');
          mobileButtons.forEach(function(btn) {
            var btnMethod = btn.getAttribute('data-method');
            var isActive = btnMethod === currentMethod;
            if (isActive) {
              mobileActiveButton = btn;
              btn.style.borderColor = '#298029';
              btn.style.backgroundColor = '#f0f8f0';
              btn.style.color = '#298029';
              btn.style.fontWeight = '500';
              btn.setAttribute('data-active', 'true');
              btn.classList.add('active');
            } else {
              btn.style.borderColor = '#d0d0d0';
              btn.style.backgroundColor = '#ffffff';
              btn.style.color = '#293149';
              btn.style.fontWeight = '400';
              btn.removeAttribute('data-active');
              btn.classList.remove('active');
            }
          });
          
          // If we have a currentMethod but no active mobile button was found, try to click it
          if (currentMethod && currentMethod !== 'shipping' && !mobileActiveButton) {
            var targetMobileButton = mobileSelector.querySelector('.mobile-method-btn[data-method="' + currentMethod + '"]');
            if (targetMobileButton) {
              console.log('[Header Location Selector] No active mobile button found, clicking method button:', currentMethod);
              targetMobileButton.click();
            }
          }
        }
      }
      
      // Show dropdown to select a store - positioned below the clicked button (accessible globally)
      function showLocationDropdown(buttonElement) {
        // #region agent log
        debugLog('header-location-selector.js:2185', 'showLocationDropdown called', {
          buttonElementExists: !!buttonElement,
          buttonElementId: buttonElement?.id || 'no-id',
          buttonElementMethod: buttonElement?.getAttribute('data-method') || 'no-method',
          windowCurrentMethod: window.currentMethod || 'no-method'
        }, 'A');
        // #endregion
        console.log('[showLocationDropdown] ========================================');
        console.log('[showLocationDropdown] FUNCTION CALLED');
        console.log('[showLocationDropdown] Timestamp:', new Date().toISOString());
        console.log('[showLocationDropdown] Button element:', buttonElement);
        console.log('[showLocationDropdown] ========================================');
        
        // CRITICAL: Don't show dropdown/modal for shipping method
        var currentMethodCheck = window.currentMethod || (buttonElement && buttonElement.getAttribute('data-method')) || 'shipping';
        if (currentMethodCheck === 'shipping') {
          console.log('[Header Location Selector] showLocationDropdown called for shipping - ignoring');
          return;
        }
        
        // Also check the button's data-method attribute
        if (buttonElement) {
          var buttonMethod = buttonElement.getAttribute('data-method');
          if (buttonMethod === 'shipping') {
            console.log('[Header Location Selector] Button is shipping - not showing dropdown');
            return;
          }
        }
        
        // Aggressively close any existing modals first
        var modals = document.querySelectorAll('.iia-locationModal, [class*="iia-locationModal"], .iia-modal, [class*="iia-modal"], dialog[open]');
        modals.forEach(function(modal) {
          try {
            modal.style.display = 'none';
            modal.style.visibility = 'hidden';
            modal.style.opacity = '0';
            modal.style.pointerEvents = 'none';
            modal.remove();
          } catch(e) {}
        });
        
        // Remove all overlays that might be covering the screen
        var overlays = document.querySelectorAll('.store-selection-overlay, .modal-overlay, [class*="overlay"], .backdrop, [class*="backdrop"]');
        overlays.forEach(function(overlay) {
          try {
            overlay.style.display = 'none';
            overlay.style.visibility = 'hidden';
            overlay.remove();
          } catch(e) {}
        });
        
        // Ensure body is not locked
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.classList.remove('modal-open', 'overflow-hidden');
        
        // Remove existing dropdown if any
        var existingDropdown = document.querySelector('.store-selection-dropdown');
        if (existingDropdown) {
          existingDropdown.remove();
        }
        
        // Store references to functions that will be defined in onclick handler
        // so saved address handler can access them
        var showStoreSelectionModalRef = null;
        var waitForInventoryInfoRef = null;
        // Store the button element for positioning the modal
        var storedButtonElement = buttonElement;
        
        // Helper function to show store selection modal with saved coordinates
        // This can be called immediately without waiting for onclick handler initialization
        function showStoreModalWithCoords(deliveryCoords, addressText) {
          // Validate and normalize coordinates
          if (deliveryCoords && deliveryCoords.lat && deliveryCoords.lng) {
            deliveryCoords.lat = parseFloat(deliveryCoords.lat);
            deliveryCoords.lng = parseFloat(deliveryCoords.lng);
            
            if (isNaN(deliveryCoords.lat) || isNaN(deliveryCoords.lng)) {
              console.error('Invalid coordinates:', deliveryCoords);
              return;
            }
          } else {
            console.warn('No delivery coordinates provided');
            return;
          }
          
          // Wait for inventoryInfo, then show modal
          function waitAndShow() {
            if (window.inventoryInfo && window.inventoryInfo.locationSettings) {
              // Use the showStoreSelectionModal function if available, otherwise create modal directly
              if (showStoreSelectionModalRef) {
                showStoreSelectionModalRef(deliveryCoords, addressText);
              } else {
                // Fallback: wait a bit more for function to be defined
                setTimeout(waitAndShow, 50);
              }
            } else {
              // Wait for inventoryInfo
              setTimeout(waitAndShow, 100);
            }
          }
          waitAndShow();
        }
        
        // Get all physical locations
        var locations = [];
        if (inventoryInfo && inventoryInfo.locationSettings && inventoryInfo.locationSettings.locations) {
          locations = inventoryInfo.locationSettings.locations.filter(function(loc) {
            // Filter out online warehouse
            var onlineId = inventoryInfo.settings && inventoryInfo.settings.onlineLocation;
            return loc && loc.id && String(loc.id) !== String(onlineId);
          });
        }
        
        // Find the button element if not provided
        if (!buttonElement) {
          var activeBtn = document.querySelector('.header-method-btn[data-active="true"], .header-method-btn.active, .mobile-method-btn.active');
          if (!activeBtn) {
            activeBtn = document.querySelector('.header-method-btn[data-method="' + currentMethod + '"], .mobile-method-btn[data-method="' + currentMethod + '"]');
          }
          buttonElement = activeBtn;
        }
        
        if (!buttonElement) {
          // Can't find button, just open the location picker
          if (inventoryInfo && inventoryInfo.api && inventoryInfo.api.showLocationPicker) {
            inventoryInfo.api.showLocationPicker();
          }
          return;
        }
        
        // Get button position
        var buttonRect = buttonElement ? buttonElement.getBoundingClientRect() : null;
        
        console.log('[showLocationDropdown] Button element:', buttonElement);
        console.log('[showLocationDropdown] Button rect:', buttonRect);
        console.log('[showLocationDropdown] Calculated dropdown position: top=' + (buttonRect ? buttonRect.bottom + 5 : 'N/A') + ' left=' + (buttonRect ? Math.max(0, buttonRect.left - (400 - buttonRect.width) / 2) : 'N/A'));
        
        // REMOVED: Fallback search for Change link - we now pass the correct element from the caller
        // The showLocationPicker hook now properly detects the clicked element and passes it here
        
        // Create dropdown menu
        var dropdown = document.createElement('div');
        dropdown.className = 'store-selection-dropdown';
        
        // Position dropdown below the button - make it larger
        if (buttonRect) {
          var dropdownWidth = Math.max(buttonRect.width, 400);
          var dropdownLeft = Math.max(0, buttonRect.left - (dropdownWidth - buttonRect.width) / 2);
          var dropdownTop = buttonRect.bottom + 5;
          
          console.log('[showLocationDropdown] Final dropdown position: top=' + dropdownTop + ' left=' + dropdownLeft + ' width=' + dropdownWidth);
          
          dropdown.style.cssText = 'position: fixed; top: ' + dropdownTop + 'px; left: ' + dropdownLeft + 'px; background: white; border: 1px solid #d0d0d0; border-radius: 4px; padding: 8px 0; z-index: 100001; box-shadow: 0 4px 12px rgba(0,0,0,0.15); width: ' + dropdownWidth + 'px; max-width: 90vw; max-height: 500px; overflow-y: auto;';
        } else {
          dropdown.style.cssText = 'position: absolute; top: 100%; left: 0; margin-top: 5px; background: white; border: 1px solid #d0d0d0; border-radius: 4px; padding: 8px 0; z-index: 100001; box-shadow: 0 4px 12px rgba(0,0,0,0.15); width: 400px; max-width: 90vw; max-height: 500px; overflow-y: auto;';
        }
        
        // Helper to check if location is online
        function isOnlineLocationCheck(locId) {
          if (!locId) return true;
          if (inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocation) {
            var onlineId = inventoryInfo.settings.onlineLocation;
            return String(locId) === String(onlineId);
          }
          return false;
        }
        
        // Add "Enter Zip Code" option first
        var zipCodeItem = document.createElement('div');
        zipCodeItem.className = 'store-dropdown-item store-dropdown-zipcode';
        zipCodeItem.style.cssText = 'padding: 10px 16px; cursor: pointer; font-size: 13px; color: #293149; border-bottom: 1px solid #e0e0e0; font-weight: 500; display: flex; align-items: center; gap: 8px;';
        
        // Add location icon
        var locationIcon = document.createElement('svg');
        locationIcon.setAttribute('viewBox', '0 0 20 20');
        locationIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        locationIcon.style.cssText = 'width: 16px; height: 16px; fill: #298029; flex-shrink: 0;';
        locationIcon.innerHTML = '<path d="M10 0C4.477 0 0 4.477 0 10c0 7 10 10 10 10s10-3 10-10c0-5.523-4.477-10-10-10zm0 14c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"/>';
        zipCodeItem.appendChild(locationIcon);
        
        var zipCodeText = document.createElement('span');
        zipCodeText.textContent = 'Enter Delivery Address';
        zipCodeItem.appendChild(zipCodeText);
        
        zipCodeItem.onmouseover = function() {
          this.style.backgroundColor = '#f0f8f0';
        };
        zipCodeItem.onmouseout = function() {
          this.style.backgroundColor = 'transparent';
        };

          
        dropdown.appendChild(zipCodeItem);
        
        // Check for saved delivery address and display it
        try {
          var savedAddressData = localStorage.getItem('savedDeliveryAddress');
          if (savedAddressData) {
            var savedAddress = JSON.parse(savedAddressData);
            if (savedAddress && savedAddress.address) {
              // Create saved address item
              var savedAddressItem = document.createElement('div');
              savedAddressItem.className = 'saved-address-item';
              savedAddressItem.style.cssText = 'padding: 12px 16px; border-bottom: 1px solid #e0e0e0; cursor: pointer; transition: background-color 0.2s;';
              
              var savedAddressLabel = document.createElement('div');
              savedAddressLabel.textContent = 'Use Saved Address:';
              savedAddressLabel.style.cssText = 'font-size: 11px; color: #666; margin-bottom: 4px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px;';
              
              var savedAddressText = document.createElement('div');
              savedAddressText.textContent = savedAddress.address;
              savedAddressText.style.cssText = 'font-size: 13px; color: #293149; margin-bottom: 6px; font-weight: 500;';
              
              var changeAddressLink = document.createElement('div');
              changeAddressLink.textContent = 'Enter different address';
              changeAddressLink.className = 'change-address-link'; // Add class for easier selection
              changeAddressLink.style.cssText = 'font-size: 12px; color: #298029; text-decoration: underline; cursor: pointer; pointer-events: auto; z-index: 1000; position: relative;';
              
              // Add a unique ID for debugging
              changeAddressLink.id = 'change-address-link-' + Date.now();
              
              console.log('[Header Location Selector] V7: Created changeAddressLink element:', changeAddressLink);
              console.log('[Header Location Selector] V7: changeAddressLink.id:', changeAddressLink.id);
              
              // Create the click handler function - make it VERY aggressive
              var changeAddressClickHandler = function(e) {
                // #region agent log
                debugLog('header-location-selector.js:2401', 'changeAddressClickHandler FIRED', {
                  eventType: e?.type,
                  currentTarget: e?.currentTarget?.id || 'no-id',
                  target: e?.target?.tagName || 'no-tag',
                  changeAddressLinkId: changeAddressLink.id,
                  savedAddressItemExists: !!savedAddressItem,
                  dropdownExists: !!dropdown,
                  zipCodeItemExists: !!zipCodeItem
                }, 'E');
                // #endregion
                console.log('========================================');
                console.log('[Header Location Selector] V8: "Enter different address" CLICKED (onclick handler)!!!');
                console.log('[Header Location Selector] Timestamp:', new Date().toISOString());
                console.log('[Header Location Selector] Event:', e);
                console.log('[Header Location Selector] changeAddressLink:', changeAddressLink);
                console.log('[Header Location Selector] changeAddressLink.id:', changeAddressLink.id);
                console.log('[Header Location Selector] savedAddressItem:', savedAddressItem);
                console.log('[Header Location Selector] dropdown:', dropdown);
                console.log('[Header Location Selector] zipCodeItem:', zipCodeItem);
                console.log('========================================');
                
                if (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                }
                
                handleChangeAddressClick(e);
                return false;
              };
              
              // Store handler reference for delegation
              changeAddressLink._clickHandler = changeAddressClickHandler;
              
              // Use both onclick and addEventListener to catch the click
              // Set onclick FIRST
              changeAddressLink.onclick = changeAddressClickHandler;
              
              // Then add multiple event listeners with different phases
              // Capture phase - fires BEFORE bubbling
              changeAddressLink.addEventListener('click', changeAddressClickHandler, true);
              
              // Bubble phase - fires during bubbling
              changeAddressLink.addEventListener('click', changeAddressClickHandler, false);
              
              // Also try mousedown as backup
              changeAddressLink.addEventListener('mousedown', function(e) {
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2126',message:'MOUSEDOWN on changeAddressLink',data:{targetTag:e.target?.tagName||'null',targetId:e.target?.id||'null'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
                // #endregion
                console.log('[Header Location Selector] V7: "Enter different address" MOUSEDOWN!!!');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                changeAddressClickHandler(e);
                return false;
              }, true);
              
              console.log('[Header Location Selector] V7: changeAddressLink._clickHandler set:', typeof changeAddressLink._clickHandler);
              console.log('[Header Location Selector] V7: changeAddressLink.onclick set:', typeof changeAddressLink.onclick);
              console.log('[Header Location Selector] V7: changeAddressLink event listeners count:', changeAddressLink.addEventListener ? 'addEventListener available' : 'N/A');
              
              // Additional event listeners are now set above in changeAddressClickHandler setup
              
              // Extract the handler logic to a function
              function handleChangeAddressClick(e) {
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2142',message:'handleChangeAddressClick called',data:{hasExistingInput:!!dropdown.querySelector('.address-input-container')},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
                // #endregion
                
                // Check if address input already exists
                var existingInput = dropdown.querySelector('.address-input-container');
                if (existingInput) {
                  // Toggle: remove if exists
                  console.log('[Header Location Selector] Removing existing address input');
                  existingInput.remove();
                  changeAddressLink.style.display = 'block';
                  return;
                }
                
                // Hide the "Enter different address" link
                changeAddressLink.style.display = 'none';
                console.log('[Header Location Selector] Hidden "Enter different address" link');
                
                // Set a flag to indicate we're calling from changeAddressLink
                // This will prevent zipCodeItem from being replaced and insert after savedAddressItem
                zipCodeItem.setAttribute('data-insert-after-saved', 'true');
                console.log('[Header Location Selector] Set data-insert-after-saved flag on zipCodeItem');
                console.log('[Header Location Selector] dropdown._savedAddressItem:', dropdown._savedAddressItem);
                console.log('[Header Location Selector] dropdown.querySelector(".saved-address-item"):', dropdown.querySelector('.saved-address-item'));
                
                // Trigger zipCodeItem click to create address input with all the proper initialization
                // The flag will cause it to be inserted in the right position automatically
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2168',message:'Calling zipCodeItem.click() programmatically',data:{zipCodeItemExists:!!zipCodeItem,hasInsertAfterFlag:zipCodeItem.getAttribute('data-insert-after-saved')==='true'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
                // #endregion
                console.log('[Header Location Selector] Triggering zipCodeItem.click()');
                zipCodeItem.click();
                
                // Remove the flag after a short delay
                setTimeout(function() {
                  zipCodeItem.removeAttribute('data-insert-after-saved');
                  console.log('[Header Location Selector] Removed data-insert-after-saved flag');
                }, 50);
              } // End of handleChangeAddressClick function
              
              savedAddressItem.appendChild(savedAddressLabel);
              savedAddressItem.appendChild(savedAddressText);
              savedAddressItem.appendChild(changeAddressLink);
              
              // Log after appending to verify it's in the DOM
              console.log('[Header Location Selector] V7: changeAddressLink appended to savedAddressItem');
              console.log('[Header Location Selector] V7: changeAddressLink.parentNode:', changeAddressLink.parentNode);
              console.log('[Header Location Selector] V7: changeAddressLink.onclick:', typeof changeAddressLink.onclick);
              
              // CRITICAL: Add a direct click handler on changeAddressLink that works independently
              // This will fire even if savedAddressItem.onclick doesn't detect it
              changeAddressLink.addEventListener('click', function(e) {
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2188',message:'DIRECT CLICK HANDLER ON changeAddressLink FIRED',data:{targetTag:e.target?.tagName||'null',targetId:e.target?.id||'null',targetClass:e.target?.className||'null',eventPhase:e.eventPhase,timeStamp:e.timeStamp},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
                // #endregion
                console.log('[Header Location Selector] V7: ========== DIRECT CLICK HANDLER ON changeAddressLink FIRED ==========');
                console.log('[Header Location Selector] V7: Event:', e);
                console.log('[Header Location Selector] V7: Target:', e.target);
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                handleChangeAddressClick(e);
                return false;
              }, true); // Use capture phase to fire before anything else
              
              // Make the whole item clickable to use the saved address
              // BUT: Don't intercept clicks on changeAddressLink - let it handle its own clicks
              savedAddressItem.onclick = function(e) {
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2201',message:'savedAddressItem.onclick called',data:{targetTag:e.target?.tagName||'null',targetId:e.target?.id||'null',targetClass:e.target?.className||'null',isChangeLink:e.target===changeAddressLink||(changeAddressLink.contains&&changeAddressLink.contains(e.target))||false},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'B'})}).catch(()=>{});
                // #endregion
                console.log('[Header Location Selector] V7: savedAddressItem.onclick called, target:', e.target);
                console.log('[Header Location Selector] V7: changeAddressLink:', changeAddressLink);
                console.log('[Header Location Selector] V7: e.target === changeAddressLink?', e.target === changeAddressLink);
                console.log('[Header Location Selector] V7: changeAddressLink.contains(e.target)?', changeAddressLink.contains ? changeAddressLink.contains(e.target) : 'N/A');
                
                // Check if clicking on changeAddressLink or its children (including text nodes)
                // Use multiple detection methods to be absolutely sure
                var clickedOnChangeLink = false;
                var target = e.target;
                
                // Method 1: Direct match
                if (target === changeAddressLink) {
                  clickedOnChangeLink = true;
                  console.log('[Header Location Selector] V7: Detection method 1: Direct match');
                }
                // Method 2: Contains check
                else if (changeAddressLink.contains && changeAddressLink.contains(target)) {
                  clickedOnChangeLink = true;
                  console.log('[Header Location Selector] V7: Detection method 2: Contains check');
                }
                // Method 3: Text node check
                else if (target.nodeType === 3 && target.parentNode === changeAddressLink) {
                  clickedOnChangeLink = true;
                  console.log('[Header Location Selector] V7: Detection method 3: Text node check');
                }
                // Method 4: Closest check (for any descendant)
                else if (target.closest && target.closest('.change-address-link') === changeAddressLink) {
                  clickedOnChangeLink = true;
                  console.log('[Header Location Selector] V7: Detection method 4: Closest check');
                }
                // Method 5: Check if target has the class or ID
                else if (target.classList && target.classList.contains('change-address-link')) {
                  clickedOnChangeLink = true;
                  console.log('[Header Location Selector] V7: Detection method 5: Class check');
                }
                // Method 6: Check if target ID matches
                else if (target.id && target.id.startsWith('change-address-link-')) {
                  clickedOnChangeLink = true;
                  console.log('[Header Location Selector] V7: Detection method 6: ID check');
                }
                // Method 7: Walk up the parent chain
                else {
                  var current = target;
                  var maxDepth = 5; // Safety limit
                  var depth = 0;
                  while (current && depth < maxDepth) {
                    if (current === changeAddressLink || 
                        (current.classList && current.classList.contains('change-address-link')) ||
                        (current.id && current.id.startsWith('change-address-link-'))) {
                      clickedOnChangeLink = true;
                      console.log('[Header Location Selector] V7: Detection method 7: Parent chain walk (depth ' + depth + ')');
                      break;
                    }
                    current = current.parentNode;
                    depth++;
                  }
                }
                
                console.log('[Header Location Selector] V7: clickedOnChangeLink result:', clickedOnChangeLink);
                console.log('[Header Location Selector] V7: target.nodeType:', target.nodeType);
                console.log('[Header Location Selector] V7: target.tagName:', target.tagName);
                console.log('[Header Location Selector] V7: target.className:', target.className);
                console.log('[Header Location Selector] V7: target.id:', target.id);
                console.log('[Header Location Selector] V7: target.textContent:', target.textContent ? target.textContent.substring(0, 50) : 'null');
                
                // If clicking on changeAddressLink or its children, MANUALLY trigger the handler
                if (clickedOnChangeLink) {
                  console.log('[Header Location Selector] V7: ✓✓✓ Click on changeAddressLink detected - MANUALLY triggering handler');
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  
                  // Call handleChangeAddressClick directly (same function the changeAddressLink handler calls)
                  console.log('[Header Location Selector] V7: Calling handleChangeAddressClick directly from savedAddressItem.onclick');
                  handleChangeAddressClick(e);
                  return false;
                }
                e.preventDefault();
                e.stopPropagation();
                
                // Use saved address directly with saved coordinates
                var addressText = savedAddress.address;
                var savedCoords = savedAddress.coordinates;
                
                // If we have saved coordinates, use them directly
                if (savedCoords && savedCoords.lat && savedCoords.lng) {
                  // Ensure coordinates are numbers, not strings
                  var lat = parseFloat(savedCoords.lat);
                  var lng = parseFloat(savedCoords.lng);
                  
                  // Validate coordinates
                  if (isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0) {
                    console.warn('Invalid saved coordinates, re-geocoding address:', savedCoords);
                    // Fall back to geocoding
                    zipCodeItem.click();
                    setTimeout(function() {
                      var addressInput = document.querySelector('.address-input-container input[type="text"]');
                      var addressSearchBtn = document.querySelector('.address-input-container button');
                      if (addressInput && addressSearchBtn) {
                        addressInput.value = addressText;
                        setTimeout(function() {
                          if (addressSearchBtn && !addressSearchBtn.disabled) {
                            addressSearchBtn.click();
                          }
                        }, 100);
                      }
                    }, 200);
                    return;
                  }
                  
                  var deliveryCoords = {
                    lat: lat,
                    lng: lng,
                    formatted: addressText
                  };
                  
                  console.log('Using saved address with coordinates:', deliveryCoords);
                  console.log('Coordinate types - lat:', typeof lat, 'lng:', typeof lng);
                  
                  // Trigger initialization by creating a synthetic event
                  // This will initialize the functions without showing the input
                  var initEvent = new Event('click', { bubbles: false });
                  Object.defineProperty(initEvent, 'target', { value: zipCodeItem, enumerable: true });
                  
                  // Store a flag to prevent showing input during initialization
                  zipCodeItem.setAttribute('data-init-only', 'true');
                  
                  // Wait for functions to be initialized
                  var attempts = 0;
                  var maxAttempts = 40; // Wait up to 2 seconds
                  function checkForFunctions() {
                    attempts++;
                    if (showStoreSelectionModalRef && waitForInventoryInfoRef) {
                      // Functions are now available, use them
                      console.log('Functions now available, showing modal with saved coordinates');
                      zipCodeItem.removeAttribute('data-init-only');
                      
                      // Remove the address input container that was created during initialization
                      var addressInputContainer = document.querySelector('.address-input-container');
                      if (addressInputContainer) {
                        addressInputContainer.remove();
                      }
                      
                      waitForInventoryInfoRef(function() {
                        console.log('inventoryInfo ready, showing modal with coordinates:', deliveryCoords);
                        showStoreSelectionModalRef(deliveryCoords, addressText);
                      });
                    } else if (attempts < maxAttempts) {
                      // Keep waiting, trigger initialization if not done yet
                      if (attempts === 1) {
                        // Trigger onclick to initialize functions
                        zipCodeItem.dispatchEvent(initEvent);
                      }
                      setTimeout(checkForFunctions, 50);
                    } else {
                      // Last resort: use input flow (will re-geocode but should work)
                      console.warn('Functions not available after initialization, using input flow');
                      zipCodeItem.removeAttribute('data-init-only');
                      zipCodeItem.click();
                      setTimeout(function() {
                        var addressInput = document.querySelector('.address-input-container input[type="text"]');
                        var addressSearchBtn = document.querySelector('.address-input-container button');
                        if (addressInput && addressSearchBtn) {
                          addressInput.value = addressText;
                          setTimeout(function() {
                            if (addressSearchBtn && !addressSearchBtn.disabled) {
                              addressSearchBtn.click();
                            }
                          }, 100);
                        }
                      }, 200);
                    }
                  }
                  // Start checking for functions
                  setTimeout(checkForFunctions, 50);
                } else {
                  // No saved coordinates, fall back to geocoding flow
                  zipCodeItem.click();
                  setTimeout(function() {
                    var addressInput = document.querySelector('.address-input-container input[type="text"]');
                    var addressSearchBtn = document.querySelector('.address-input-container button');
                    
                    if (addressInput && addressSearchBtn) {
                      addressInput.value = addressText;
                      setTimeout(function() {
                        if (addressSearchBtn && !addressSearchBtn.disabled) {
                          addressSearchBtn.click();
                        }
                      }, 100);
                    }
                  }, 200);
                }
              };
              
              savedAddressItem.onmouseover = function() {
                this.style.backgroundColor = '#f0f8f0';
              };
              savedAddressItem.onmouseout = function() {
                this.style.backgroundColor = 'transparent';
              };
              
              // Insert saved address item right after zipCodeItem
              dropdown.insertBefore(savedAddressItem, zipCodeItem.nextSibling);
              
              // Store reference to savedAddressItem on dropdown for later access
              dropdown._savedAddressItem = savedAddressItem;
            }
          }
        } catch(e) {
          console.warn('Could not load saved address:', e);
        }
        
        zipCodeItem.onclick = function(e) {
          // #region agent log
//           fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2414',message:'zipCodeItem.onclick called',data:{isInitOnly:zipCodeItem.getAttribute('data-init-only')==='true',insertAfterSaved:zipCodeItem.getAttribute('data-insert-after-saved')==='true',eventType:e?.type||'programmatic'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
          // #endregion
          console.log('========================================');
          console.log('[Header Location Selector] V7: zipCodeItem.onclick CALLED!!!');
          console.log('[Header Location Selector] Timestamp:', new Date().toISOString());
          
          e.preventDefault();
          e.stopPropagation();
          
          var isInitOnly = zipCodeItem.getAttribute('data-init-only') === 'true';
          var insertAfterSaved = zipCodeItem.getAttribute('data-insert-after-saved') === 'true';
          
          // CRITICAL FIX: If we're in the dropdown and there's a savedAddressItem, 
          // ALWAYS insert after savedAddressItem instead of replacing zipCodeItem
          // This ensures the address input appears in the correct location
          console.log('[Header Location Selector] V8: AUTO-FIX CHECK STARTING - insertAfterSaved:', insertAfterSaved, 'isInitOnly:', isInitOnly);
          if (!insertAfterSaved && !isInitOnly) {
            var currentDropdown = zipCodeItem.closest('.store-selection-dropdown');
            console.log('[Header Location Selector] V8: AUTO-FIX - currentDropdown:', !!currentDropdown, currentDropdown ? currentDropdown.className : 'null');
            // #region agent log
//             fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2499',message:'AUTO-FIX check',data:{hasDropdown:!!currentDropdown,dropdownClass:currentDropdown?.className||'null',isInitOnly:isInitOnly,insertAfterSavedBefore:insertAfterSaved},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
            // #endregion
            if (currentDropdown) {
              // Try multiple methods to find savedAddressItem
              var savedItem = null;
              
              // Method 1: Stored reference
              if (currentDropdown._savedAddressItem) {
                savedItem = currentDropdown._savedAddressItem;
                console.log('[Header Location Selector] V8: AUTO-FIX - Found via dropdown._savedAddressItem');
              }
              
              // Method 2: QuerySelector
              if (!savedItem) {
                savedItem = currentDropdown.querySelector('.saved-address-item');
                if (savedItem) {
                  console.log('[Header Location Selector] V8: AUTO-FIX - Found via querySelector');
                }
              }
              
              // Method 3: Global search
              if (!savedItem) {
                savedItem = document.querySelector('.saved-address-item');
                if (savedItem) {
                  console.log('[Header Location Selector] V8: AUTO-FIX - Found via global search');
                }
              }
              
              // #region agent log
//               fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2502',message:'AUTO-FIX - savedItem search',data:{foundSavedItem:!!savedItem,savedItemClass:savedItem?.className||'null',savedItemParent:savedItem?.parentNode?.className||'null',allDropdownChildren:Array.from(currentDropdown.children).map(function(c){return c.className||c.tagName;})},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
              // #endregion
              if (savedItem) {
                console.log('[Header Location Selector] V8: AUTO-FIX: ✓✓✓ Found savedAddressItem, forcing insertAfterSaved=true');
                insertAfterSaved = true;
                zipCodeItem.setAttribute('data-insert-after-saved', 'true');
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2505',message:'AUTO-FIX - insertAfterSaved set to true',data:{insertAfterSavedAfter:insertAfterSaved,attributeSet:zipCodeItem.getAttribute('data-insert-after-saved')},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                // #endregion
              } else {
                console.warn('[Header Location Selector] V8: AUTO-FIX: ✗✗✗ savedAddressItem NOT FOUND!');
                console.log('[Header Location Selector] V8: AUTO-FIX: Dropdown children:', Array.from(currentDropdown.children).map(function(c) { return c.className || c.tagName; }));
                console.log('[Header Location Selector] V8: AUTO-FIX: dropdown._savedAddressItem:', currentDropdown._savedAddressItem);
                console.log('[Header Location Selector] V8: AUTO-FIX: Global search result:', document.querySelector('.saved-address-item'));
              }
            } else {
              console.warn('[Header Location Selector] V8: AUTO-FIX: ✗✗✗ Dropdown NOT FOUND!');
            }
          } else {
            console.log('[Header Location Selector] V8: AUTO-FIX SKIPPED - insertAfterSaved:', insertAfterSaved, 'isInitOnly:', isInitOnly);
          }
          
          console.log('[Header Location Selector] isInitOnly:', isInitOnly, 'insertAfterSaved:', insertAfterSaved);
          console.log('[Header Location Selector] zipCodeItem:', zipCodeItem);
          console.log('[Header Location Selector] zipCodeItem.parentNode:', zipCodeItem.parentNode);
          console.log('========================================');
          
          // Replace zip code item with address input field (unless init-only or inserting after saved address)
          var addressInput = null;
          var addressSearchBtn = null;
          var addressInputContainer = null;
          
          if (!isInitOnly) {
            var scopeCheck = "alive";
            
            // CRITICAL: Check for and remove ANY existing address-input-container FIRST (globally, not just in dropdown)
            var existingContainers = document.querySelectorAll('.address-input-container');
            console.log('[Header Location Selector] ⚠⚠⚠ CHECKING FOR DUPLICATES: Found', existingContainers.length, 'existing address-input-container elements');
            if (existingContainers.length > 0) {
              existingContainers.forEach(function(existing, index) {
                console.log('[Header Location Selector] ⚠⚠⚠ DUPLICATE #' + index + ':');
                console.log('[Header Location Selector]   Element:', existing);
                console.log('[Header Location Selector]   Parent:', existing.parentNode);
                console.log('[Header Location Selector]   Parent className:', existing.parentNode ? existing.parentNode.className : 'null');
                console.log('[Header Location Selector]   Parent tagName:', existing.parentNode ? existing.parentNode.tagName : 'null');
                console.log('[Header Location Selector]   Is in dropdown?', existing.parentNode && existing.parentNode.classList.contains('store-selection-dropdown'));
                console.log('[Header Location Selector]   getBoundingClientRect():', existing.getBoundingClientRect());
                existing.remove();
                console.log('[Header Location Selector]   ✓ Removed duplicate #' + index);
              });
              console.log('[Header Location Selector] ✓✓✓ Removed ALL', existingContainers.length, 'existing address-input-container elements');
            }
            
            addressInputContainer = document.createElement('div');
            addressInputContainer.className = 'address-input-container';
            addressInputContainer.setAttribute('data-created-by', 'zipCodeItem-onclick-' + Date.now());
            // Use normal flow positioning - no fixed/absolute positioning
            // CRITICAL: Force all positioning properties to prevent any CSS from overriding
            addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
            
            var addressInputLabel = document.createElement('label');
            addressInputLabel.textContent = 'Enter Delivery Address:';
            addressInputLabel.style.cssText = 'display: block; font-size: 12px; color: #666; margin-bottom: 6px; font-weight: 500;';
            
            var addressInputWrapper = document.createElement('div');
            addressInputWrapper.style.cssText = 'display: flex; gap: 8px; align-items: center;';
            
            addressInput = document.createElement('input');
            addressInput.type = 'text';
            addressInput.placeholder = 'Enter street address, city, state';
            addressInput.style.cssText = 'flex: 1; padding: 10px 12px; border: 1px solid #d0d0d0; border-radius: 3px; font-size: 14px; min-width: 250px;';
            addressInput.id = 'delivery-address-input-' + Date.now();
            
            addressSearchBtn = document.createElement('button');
            addressSearchBtn.textContent = 'Search';
            addressSearchBtn.style.cssText = 'padding: 6px 12px; background: #298029; color: white; border: none; border-radius: 3px; font-size: 13px; cursor: pointer; font-weight: 500;';

            addressInputContainer.appendChild(addressInputLabel);
            addressInputWrapper.appendChild(addressInput);
            addressInputWrapper.appendChild(addressSearchBtn);
            addressInputContainer.appendChild(addressInputWrapper);

            // Replace the zip code item with the address input (unless inserting after saved address)
            // CRITICAL: Always check for savedAddressItem in DOM, even if insertAfterSaved is false
            // This ensures we insert in the correct position even if the flag wasn't set properly
            var currentDropdownForInsert = zipCodeItem.closest('.store-selection-dropdown');
            var savedItemInDOM = null;
            
            // METHOD 1: Check stored reference on dropdown object
            if (currentDropdownForInsert && currentDropdownForInsert._savedAddressItem) {
              savedItemInDOM = currentDropdownForInsert._savedAddressItem;
              console.log('[Header Location Selector] V7: Found savedAddressItem via dropdown._savedAddressItem reference');
            }
            
            // METHOD 2: Query in current dropdown
            if (!savedItemInDOM && currentDropdownForInsert) {
              savedItemInDOM = currentDropdownForInsert.querySelector('.saved-address-item');
              if (savedItemInDOM) {
                console.log('[Header Location Selector] V7: Found savedAddressItem via querySelector in dropdown');
              }
            }
            
            // METHOD 3: Global search as fallback
            if (!savedItemInDOM) {
              savedItemInDOM = document.querySelector('.saved-address-item');
              if (savedItemInDOM) {
                console.warn('[Header Location Selector] V7: Found savedAddressItem globally (not in current dropdown)');
              }
            }
            
            // METHOD 4: Check closure variable if available
            if (!savedItemInDOM && typeof savedAddressItem !== 'undefined' && savedAddressItem && savedAddressItem.parentNode) {
              savedItemInDOM = savedAddressItem;
              console.log('[Header Location Selector] V7: Found savedAddressItem via closure variable');
            }
            
            // #region agent log
//             fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2649',message:'BEFORE insertion decision',data:{insertAfterSaved:insertAfterSaved,hasDropdown:!!currentDropdownForInsert,foundSavedItemInDOM:!!savedItemInDOM,willInsertAfter:insertAfterSaved||!!savedItemInDOM,dropdownChildren:currentDropdownForInsert?Array.from(currentDropdownForInsert.children).map(function(c){return c.className||c.tagName;}):[],savedItemParent:savedItemInDOM?.parentNode?.className||'null'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
            // #endregion
            console.log('[Header Location Selector] V8: ========== BEFORE INSERTION DECISION ==========');
            console.log('[Header Location Selector] V8: insertAfterSaved:', insertAfterSaved);
            console.log('[Header Location Selector] V8: savedItemInDOM found:', !!savedItemInDOM);
            console.log('[Header Location Selector] V8: willInsertAfter:', insertAfterSaved || !!savedItemInDOM);
            console.log('[Header Location Selector] V8: Dropdown exists:', !!currentDropdownForInsert);
            console.log('[Header Location Selector] V8: Dropdown children:', currentDropdownForInsert ? Array.from(currentDropdownForInsert.children).map(function(c) { return c.className || c.tagName; }) : 'no dropdown');
            console.log('[Header Location Selector] V8: savedItemInDOM parent:', savedItemInDOM ? savedItemInDOM.parentNode?.className : 'null');
            console.log('[Header Location Selector] V8: ============================================');
            
            // FORCE insert after saved if it exists, regardless of flag
            // CRITICAL: Even if both are false, do one final check
            if (!insertAfterSaved && !savedItemInDOM) {
              console.warn('[Header Location Selector] V8: ⚠⚠⚠ BOTH insertAfterSaved AND savedItemInDOM are false!');
              console.warn('[Header Location Selector] V8: Doing FINAL EMERGENCY CHECK for savedAddressItem...');
              
              // Final emergency check - try everything
              var emergencyDropdown = zipCodeItem.closest('.store-selection-dropdown');
              var emergencySavedItem = null;
              
              if (emergencyDropdown) {
                // Try stored reference
                if (emergencyDropdown._savedAddressItem) {
                  emergencySavedItem = emergencyDropdown._savedAddressItem;
                  console.warn('[Header Location Selector] V8: ✓✓✓ EMERGENCY: Found via dropdown._savedAddressItem!');
                }
                // Try querySelector
                if (!emergencySavedItem) {
                  emergencySavedItem = emergencyDropdown.querySelector('.saved-address-item');
                  if (emergencySavedItem) {
                    console.warn('[Header Location Selector] V8: ✓✓✓ EMERGENCY: Found via querySelector!');
                  }
                }
              }
              // Try global
              if (!emergencySavedItem) {
                emergencySavedItem = document.querySelector('.saved-address-item');
                if (emergencySavedItem) {
                  console.warn('[Header Location Selector] V8: ✓✓✓ EMERGENCY: Found via global search!');
                }
              }
              // Try closure
              if (!emergencySavedItem && typeof savedAddressItem !== 'undefined' && savedAddressItem) {
                emergencySavedItem = savedAddressItem;
                console.warn('[Header Location Selector] V8: ✓✓✓ EMERGENCY: Found via closure variable!');
              }
              
              if (emergencySavedItem) {
                savedItemInDOM = emergencySavedItem;
                console.warn('[Header Location Selector] V8: ✓✓✓ EMERGENCY CHECK SUCCESS - Using savedItemInDOM!');
              } else {
                console.error('[Header Location Selector] V8: ✗✗✗ EMERGENCY CHECK FAILED - savedAddressItem does not exist!');
                console.error('[Header Location Selector] V8: This means there is NO saved address, so replacing zipCodeItem is CORRECT behavior.');
              }
            }
            
            if (insertAfterSaved || savedItemInDOM) {
              // If we found savedItemInDOM but insertAfterSaved was false, log it
              if (!insertAfterSaved && savedItemInDOM) {
                console.warn('[Header Location Selector] V7: insertAfterSaved was false but found savedAddressItem in DOM - using it anyway!');
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2586',message:'FORCING insert after saved - found in DOM',data:{insertAfterSavedFlag:insertAfterSaved,foundInDOM:!!savedItemInDOM,savedItemClass:savedItemInDOM?.className||'null'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                // #endregion
              }
              // #region agent log
//               fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2501',message:'Inserting address-input-container after savedAddressItem',data:{savedAddressItemExists:typeof savedAddressItem!=='undefined'&&!!savedAddressItem,dropdownExists:!!dropdown,zipCodeItemParent:zipCodeItem.parentNode?.className||'null'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
              // #endregion
              console.log('[Header Location Selector] ========== INSERTING AFTER SAVED ADDRESS ==========');
              console.log('[Header Location Selector] savedAddressItem from closure:', savedAddressItem);
              console.log('[Header Location Selector] dropdown from closure:', dropdown);
              console.log('[Header Location Selector] zipCodeItem.parentNode:', zipCodeItem.parentNode);
              
              // Use savedAddressItem from closure - it should be available since we're in the same function scope
              // savedAddressItem is defined in the try block above, so it's in scope here
              // BUT: Prefer savedItemInDOM (just found above) as it's the actual DOM element
              var targetItem = null;
              var targetDropdown = null;
              
              // Prefer savedItemInDOM (just found) over savedAddressItem (from closure)
              // This ensures we use the actual DOM element
              if (savedItemInDOM && savedItemInDOM.parentNode) {
                targetItem = savedItemInDOM;
                targetDropdown = savedItemInDOM.parentNode;
                console.log('[Header Location Selector] V7: Using savedItemInDOM from querySelector (preferred)');
              } else if (typeof savedAddressItem !== 'undefined' && savedAddressItem && savedAddressItem.parentNode) {
                console.log('[Header Location Selector] Using savedAddressItem from closure');
                targetItem = savedAddressItem;
                targetDropdown = savedAddressItem.parentNode;
              } else {
                console.log('[Header Location Selector] savedAddressItem not available from closure, finding it...');
                // Find the dropdown first
                targetDropdown = dropdown || zipCodeItem.parentNode;
                if (!targetDropdown || !targetDropdown.classList.contains('store-selection-dropdown')) {
                  targetDropdown = zipCodeItem.closest('.store-selection-dropdown');
                }
                
                if (targetDropdown) {
                  targetItem = targetDropdown.querySelector('.saved-address-item');
                  console.log('[Header Location Selector] Found savedAddressItem via querySelector:', targetItem);
                }
              }
              
              if (targetItem && targetDropdown) {
                console.log('[Header Location Selector] targetItem:', targetItem);
                console.log('[Header Location Selector] targetDropdown:', targetDropdown);
                console.log('[Header Location Selector] targetItem.nextSibling:', targetItem.nextSibling);
                
                // CRITICAL: Ensure addressInputContainer is NOT positioned fixed/absolute - it should flow naturally in the dropdown
                // Remove any positioning that might have been set and force normal flow
                // Use !important on ALL positioning properties to override any theme CSS
                addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                
                console.log('[Header Location Selector] Forced normal flow positioning on addressInputContainer');
                console.log('[Header Location Selector] addressInputContainer.style BEFORE insert:', addressInputContainer.style.cssText);
                
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2453',message:'BEFORE insertBefore',data:{targetDropdownClass:targetDropdown.className,targetItemClass:targetItem.className,nextSibling:targetItem.nextSibling?.className||'null',containerId:addressInputContainer.id},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'B'})}).catch(()=>{});
                // #endregion
                
                // Insert right after savedAddressItem in the dropdown
                console.log('[Header Location Selector] V7: About to insert - targetItem:', targetItem);
                console.log('[Header Location Selector] V7: About to insert - targetItem.nextSibling:', targetItem.nextSibling);
                console.log('[Header Location Selector] V7: About to insert - targetDropdown children before:', Array.from(targetDropdown.children).map(function(c) { return c.className || c.tagName; }));
                
                targetDropdown.insertBefore(addressInputContainer, targetItem.nextSibling);
                
                // CRITICAL: Force dropdown to use flex column layout IMMEDIATELY after insertion
                // This must happen BEFORE any logs to ensure proper layout
                
                // METHOD 1: Add a unique data attribute to target it specifically
                targetDropdown.setAttribute('data-address-fix-applied', Date.now().toString());
                
                // METHOD 2: Inject a style tag with maximum specificity
                var styleId = 'store-dropdown-flex-fix-' + Date.now();
                var existingStyleTag = document.getElementById(styleId);
                if (existingStyleTag) {
                  existingStyleTag.remove();
                }
                var flexFixStyle = document.createElement('style');
                flexFixStyle.id = styleId;
                flexFixStyle.textContent = `
                  .store-selection-dropdown[data-address-fix-applied] {
                    display: flex !important;
                    flex-direction: column !important;
                    align-items: stretch !important;
                    flex-wrap: nowrap !important;
                  }
                  .store-selection-dropdown[data-address-fix-applied] .saved-address-item {
                    order: 1 !important;
                  }
                  .store-selection-dropdown[data-address-fix-applied] .address-input-container {
                    order: 2 !important;
                  }
                `;
                document.head.appendChild(flexFixStyle);
                
                // METHOD 3: Use inline styles as backup
                var existingStyle = targetDropdown.style.cssText || '';
                targetDropdown.style.cssText = existingStyle + ' display: flex !important; flex-direction: column !important; align-items: stretch !important; flex-wrap: nowrap !important;';
                
                // Force a reflow to ensure styles are applied
                void targetDropdown.offsetHeight;
                
                // METHOD 4: Set up a MutationObserver to watch for style changes and re-apply if overridden
                var styleObserver = new MutationObserver(function(mutations) {
                  mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                      var currentDisplay = window.getComputedStyle(targetDropdown).display;
                      if (currentDisplay !== 'flex') {
                        console.warn('[Header Location Selector] V8: Display was overridden to', currentDisplay, '- re-applying flex fix');
                        targetDropdown.style.setProperty('display', 'flex', 'important');
                        targetDropdown.style.setProperty('flex-direction', 'column', 'important');
                        void targetDropdown.offsetHeight; // Force reflow
                        debugLog('header-location-selector.js:2926', 'Display override detected and fixed', {
                          overriddenDisplay: currentDisplay,
                          reApplied: true
                        }, 'F');
                      }
                    }
                  });
                });
                styleObserver.observe(targetDropdown, {
                  attributes: true,
                  attributeFilter: ['style'],
                  attributeOldValue: true
                });
                
                // Also check periodically (as backup)
                var checkInterval = setInterval(function() {
                  var currentDisplay = window.getComputedStyle(targetDropdown).display;
                  if (currentDisplay !== 'flex') {
                    console.warn('[Header Location Selector] V8: Periodic check - Display is', currentDisplay, '- re-applying flex fix');
                    targetDropdown.style.setProperty('display', 'flex', 'important');
                    targetDropdown.style.setProperty('flex-direction', 'column', 'important');
                    void targetDropdown.offsetHeight;
                  }
                }, 100);
                
                // Stop checking after 5 seconds (should be enough time)
                setTimeout(function() {
                  clearInterval(checkInterval);
                  styleObserver.disconnect();
                }, 5000);
                
                // Verify everything was set correctly
                var inlineDisplay = targetDropdown.style.display;
                var inlineFlexDir = targetDropdown.style.flexDirection;
                var inlineStyleText = targetDropdown.style.cssText;
                var computedDisplay = window.getComputedStyle(targetDropdown).display;
                var computedFlexDir = window.getComputedStyle(targetDropdown).flexDirection;
                var dataAttr = targetDropdown.getAttribute('data-address-fix-applied');
                var styleTagExists = document.getElementById(styleId) !== null;
                var matchingRules = [];
                var cssRuleError = null;
                try {
                  var sheets = Array.from(document.styleSheets);
                  for (var i = 0; i < sheets.length; i++) {
                    try {
                      var rules = sheets[i].cssRules || sheets[i].rules;
                      if (rules) {
                        for (var j = 0; j < rules.length; j++) {
                          try {
                            if (rules[j].selectorText && rules[j].selectorText.includes('store-selection-dropdown') && rules[j].style && rules[j].style.display) {
                              matchingRules.push({
                                selector: rules[j].selectorText,
                                display: rules[j].style.display,
                                specificity: (rules[j].selectorText.match(/\./g) || []).length + (rules[j].selectorText.match(/#/g) || []).length
                              });
                            }
                          } catch (ruleErr) {
                            cssRuleError = String(ruleErr);
                          }
                        }
                      }
                    } catch (sheetErr) {
                      cssRuleError = String(sheetErr);
                    }
                  }
                } catch (e) {
                  cssRuleError = String(e);
                }
                
                var dropdownRect = targetDropdown.getBoundingClientRect();
                var containerRect = addressInputContainer.getBoundingClientRect();
                var savedItemRect = targetItem ? targetItem.getBoundingClientRect() : null;
                var parentComputed = window.getComputedStyle(targetDropdown);
                
                // CRITICAL: Log immediately to console first (will always show up)
                console.log('========================================');
                console.log('[Header Location Selector] V8: IMMEDIATE FLEX FIX APPLIED');
                console.log('[Header Location Selector] V8: Data attribute:', dataAttr);
                console.log('[Header Location Selector] V8: Style tag exists:', styleTagExists);
                console.log('[Header Location Selector] V8: Inline display:', inlineDisplay);
                console.log('[Header Location Selector] V8: Computed display:', computedDisplay);
                console.log('[Header Location Selector] V8: Computed flexDirection:', computedFlexDir);
                console.log('[Header Location Selector] V8: Container Y:', containerRect.y);
                console.log('[Header Location Selector] V8: Saved item bottom:', savedItemRect ? savedItemRect.bottom : 'N/A');
                console.log('[Header Location Selector] V8: Vertical gap:', savedItemRect ? containerRect.top - savedItemRect.bottom : 'N/A');
                console.log('========================================');
                
                debugLog('header-location-selector.js:2895', 'IMMEDIATE flex fix applied - FULL VERIFICATION', {
                  dataAttribute: dataAttr,
                  styleTagExists: styleTagExists,
                  styleTagId: styleId,
                  inlineStyleText: inlineStyleText,
                  inlineDisplay: inlineDisplay,
                  inlineFlexDir: inlineFlexDir,
                  computedDisplay: computedDisplay,
                  computedFlexDir: computedFlexDir,
                  targetDropdownClass: targetDropdown.className,
                  targetDropdownId: targetDropdown.id || 'none',
                  targetDropdownRect: {
                    x: dropdownRect.x,
                    y: dropdownRect.y,
                    width: dropdownRect.width,
                    height: dropdownRect.height,
                    top: dropdownRect.top,
                    left: dropdownRect.left,
                    right: dropdownRect.right,
                    bottom: dropdownRect.bottom
                  },
                  containerRect: {
                    x: containerRect.x,
                    y: containerRect.y,
                    width: containerRect.width,
                    height: containerRect.height,
                    top: containerRect.top,
                    left: containerRect.left,
                    right: containerRect.right,
                    bottom: containerRect.bottom
                  },
                  savedItemRect: savedItemRect ? {
                    x: savedItemRect.x,
                    y: savedItemRect.y,
                    width: savedItemRect.width,
                    height: savedItemRect.height,
                    top: savedItemRect.top,
                    left: savedItemRect.left,
                    right: savedItemRect.right,
                    bottom: savedItemRect.bottom
                  } : null,
                  verticalGap: savedItemRect ? containerRect.top - savedItemRect.bottom : null,
                  matchingCSSRules: matchingRules,
                  cssRuleError: cssRuleError,
                  allComputedStyles: {
                    display: parentComputed.display,
                    flexDirection: parentComputed.flexDirection,
                    alignItems: parentComputed.alignItems,
                    flexWrap: parentComputed.flexWrap,
                    position: parentComputed.position
                  }
                }, 'F');
                console.log('[Header Location Selector] V8: IMMEDIATE - Forced dropdown to use flex column layout');
                console.log('[Header Location Selector] V8: IMMEDIATE - Inline style cssText:', inlineStyleText);
                console.log('[Header Location Selector] V8: IMMEDIATE - Inline style display:', inlineDisplay, 'flexDirection:', inlineFlexDir);
                console.log('[Header Location Selector] V8: IMMEDIATE - Computed style display:', computedDisplay, 'flexDirection:', computedFlexDir);
                
                // Force order on saved-address-item and address-input-container to ensure proper stacking
                if (targetItem) {
                  targetItem.style.setProperty('order', '1', 'important');
                }
                addressInputContainer.style.setProperty('order', '2', 'important');
                debugLog('header-location-selector.js:2861', 'Flex order set', {
                  savedItemOrder: targetItem ? window.getComputedStyle(targetItem).order : 'N/A',
                  containerOrder: window.getComputedStyle(addressInputContainer).order,
                  savedItemRect: targetItem ? targetItem.getBoundingClientRect() : null,
                  containerRect: addressInputContainer.getBoundingClientRect(),
                  verticalGap: targetItem ? addressInputContainer.getBoundingClientRect().top - targetItem.getBoundingClientRect().bottom : null
                }, 'F');
                console.log('[Header Location Selector] V8: IMMEDIATE - Set flex order (saved-address-item: 1, address-input-container: 2)');
                
                // #region agent log
                var childrenAfter = Array.from(targetDropdown.children);
                var containerIndex = childrenAfter.indexOf(addressInputContainer);
                var savedItemIndex = childrenAfter.indexOf(targetItem);
                var computed = window.getComputedStyle(addressInputContainer);
                var parentComputed = addressInputContainer.parentNode ? window.getComputedStyle(addressInputContainer.parentNode) : null;
                var rect = addressInputContainer.getBoundingClientRect();
                var parentRect = addressInputContainer.parentNode ? addressInputContainer.parentNode.getBoundingClientRect() : null;
                var savedItemRect = targetItem ? targetItem.getBoundingClientRect() : null;
                var savedItemComputed = targetItem ? window.getComputedStyle(targetItem) : null;
                var allPositioningStyles = {
                  position: computed.position,
                  top: computed.top,
                  left: computed.left,
                  right: computed.right,
                  bottom: computed.bottom,
                  transform: computed.transform,
                  translate: computed.translate,
                  margin: computed.margin,
                  marginTop: computed.marginTop,
                  marginLeft: computed.marginLeft,
                  marginRight: computed.marginRight,
                  marginBottom: computed.marginBottom,
                  padding: computed.padding,
                  width: computed.width,
                  height: computed.height,
                  display: computed.display,
                  float: computed.float,
                  clear: computed.clear,
                  zIndex: computed.zIndex,
                  boxSizing: computed.boxSizing,
                  verticalAlign: computed.verticalAlign
                };
                var parentPositioningStyles = parentComputed ? {
                  position: parentComputed.position,
                  display: parentComputed.display,
                  flexDirection: parentComputed.flexDirection,
                  alignItems: parentComputed.alignItems,
                  justifyContent: parentComputed.justifyContent,
                  gridTemplateColumns: parentComputed.gridTemplateColumns,
                  gridTemplateRows: parentComputed.gridTemplateRows
                } : null;
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2588',message:'AFTER insertBefore - FULL CSS analysis',data:{containerIndex:containerIndex,savedItemIndex:savedItemIndex,isAfterSaved:containerIndex===savedItemIndex+1,childrenOrder:childrenAfter.map(function(c,i){return i+':'+(c.className||c.tagName);}),rect:{x:rect.x,y:rect.y,width:rect.width,height:rect.height,top:rect.top,left:rect.left,right:rect.right,bottom:rect.bottom},parentRect:parentRect?{x:parentRect.x,y:parentRect.y,width:parentRect.width,height:parentRect.height,top:parentRect.top,left:parentRect.left}:null,savedItemRect:savedItemRect?{x:savedItemRect.x,y:savedItemRect.y,width:savedItemRect.width,height:savedItemRect.height,top:savedItemRect.top,bottom:savedItemRect.bottom,left:savedItemRect.left,right:savedItemRect.right}:null,verticalGap:savedItemRect?rect.top-savedItemRect.bottom:null,computedStyles:allPositioningStyles,parentComputedStyles:parentPositioningStyles,inlineStyle:addressInputContainer.style.cssText},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                // #endregion
                console.log('[Header Location Selector] V7: After insert - addressInputContainer.parentNode:', addressInputContainer.parentNode);
                console.log('[Header Location Selector] V7: After insert - addressInputContainer is child #', containerIndex);
                console.log('[Header Location Selector] V7: After insert - savedAddressItem is child #', savedItemIndex);
                console.log('[Header Location Selector] V8: After insert - Container is right after savedAddressItem?', containerIndex === savedItemIndex + 1);
                console.log('[Header Location Selector] V8: After insert - targetDropdown children after:', childrenAfter.map(function(c) { return c.className || c.tagName; }));
                console.log('[Header Location Selector] V8: After insert - Container getBoundingClientRect:', addressInputContainer.getBoundingClientRect());
                console.log('[Header Location Selector] V8: After insert - savedAddressItem getBoundingClientRect:', savedItemRect);
                if (savedItemRect) {
                  var gap = rect.top - savedItemRect.bottom;
                  console.log('[Header Location Selector] V8: Vertical gap between savedAddressItem bottom and container top:', gap, 'px');
                  // #region agent log
//                   fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2886',message:'Vertical gap analysis',data:{verticalGap:gap,savedItemRect:{top:savedItemRect.top,bottom:savedItemRect.bottom,height:savedItemRect.height,y:savedItemRect.y},containerRect:{top:rect.top,bottom:rect.bottom,height:rect.height,y:rect.y},parentRect:{top:parentRect?.top||null,bottom:parentRect?.bottom||null,height:parentRect?.height||null,y:parentRect?.y||null},savedItemComputedOrder:savedItemComputed?.order||'auto',containerComputedOrder:computed.order||'auto',elementsBetween:childrenAfter.slice(savedItemIndex+1,containerIndex).map(function(c,i){var r=c.getBoundingClientRect();return{className:c.className||c.tagName,index:savedItemIndex+1+i,rect:{top:r.top,bottom:r.bottom,height:r.height,y:r.y}};})},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'E'})}).catch(()=>{});
                  // #endregion
                  if (gap > 10) {
                    console.warn('[Header Location Selector] V8: ⚠⚠⚠ WARNING - Large gap detected! Container is', gap, 'px below savedAddressItem');
                  } else if (gap < -5) {
                    console.warn('[Header Location Selector] V8: ⚠⚠⚠ WARNING - Container overlaps savedAddressItem by', Math.abs(gap), 'px');
                  } else {
                    console.log('[Header Location Selector] V8: ✓✓✓ Container is properly positioned right below savedAddressItem');
                  }
                } else {
                  // #region agent log
//                   fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2894',message:'savedItemRect is NULL',data:{targetItemExists:!!targetItem,targetItemClass:targetItem?.className||'null',containerIndex:containerIndex,savedItemIndex:savedItemIndex},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'E'})}).catch(()=>{});
                  // #endregion
                  console.warn('[Header Location Selector] V8: ⚠⚠⚠ savedItemRect is NULL - cannot calculate vertical gap');
                }
                var finalComputed = window.getComputedStyle(addressInputContainer);
                console.log('[Header Location Selector] V7: After insert - FULL computed styles:', {
                  position: finalComputed.position,
                  top: finalComputed.top,
                  left: finalComputed.left,
                  right: finalComputed.right,
                  bottom: finalComputed.bottom,
                  transform: finalComputed.transform,
                  margin: finalComputed.margin,
                  width: finalComputed.width,
                  height: finalComputed.height,
                  display: finalComputed.display,
                  float: finalComputed.float,
                  zIndex: finalComputed.zIndex
                });
                console.log('[Header Location Selector] V7: After insert - getBoundingClientRect:', addressInputContainer.getBoundingClientRect());
                console.log('[Header Location Selector] V7: After insert - Parent getBoundingClientRect:', addressInputContainer.parentNode ? addressInputContainer.parentNode.getBoundingClientRect() : 'no parent');
                console.log('[Header Location Selector] V7: After insert - Parent computed display:', addressInputContainer.parentNode ? window.getComputedStyle(addressInputContainer.parentNode).display : 'no parent');
                console.log('[Header Location Selector] V7: After insert - Parent computed flexDirection:', addressInputContainer.parentNode ? window.getComputedStyle(addressInputContainer.parentNode).flexDirection : 'no parent');
                
                // Check styles again after a short delay to see if something is changing them
                setTimeout(function() {
                  var delayedComputed = window.getComputedStyle(addressInputContainer);
                  var delayedRect = addressInputContainer.getBoundingClientRect();
                  // #region agent log
//                   fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2625',message:'DELAYED CHECK - styles after 100ms',data:{position:delayedComputed.position,left:delayedComputed.left,top:delayedComputed.top,transform:delayedComputed.transform,rect:{x:delayedRect.x,y:delayedRect.y,width:delayedRect.width,height:delayedRect.height,top:delayedRect.top,left:delayedRect.left},inlineStyle:addressInputContainer.style.cssText},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                  // #endregion
                  console.log('[Header Location Selector] V7: DELAYED CHECK (100ms) - position:', delayedComputed.position, 'left:', delayedComputed.left, 'top:', delayedComputed.top, 'transform:', delayedComputed.transform);
                  console.log('[Header Location Selector] V7: DELAYED CHECK (100ms) - rect:', delayedRect);
                  if (delayedComputed.position !== 'static' || delayedComputed.left !== 'auto' || delayedComputed.top !== 'auto' || delayedComputed.transform !== 'none') {
                    console.warn('[Header Location Selector] V7: WARNING - Styles changed after insertion! Re-applying...');
                    addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                  }
                }, 100);
                
                // Also check after 500ms
                setTimeout(function() {
                  var delayedComputed = window.getComputedStyle(addressInputContainer);
                  var delayedRect = addressInputContainer.getBoundingClientRect();
                  // #region agent log
//                   fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2635',message:'DELAYED CHECK - styles after 500ms',data:{position:delayedComputed.position,left:delayedComputed.left,top:delayedComputed.top,transform:delayedComputed.transform,rect:{x:delayedRect.x,y:delayedRect.y,width:delayedRect.width,height:delayedRect.height,top:delayedRect.top,left:delayedRect.left},inlineStyle:addressInputContainer.style.cssText},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                  // #endregion
                  console.log('[Header Location Selector] V7: DELAYED CHECK (500ms) - position:', delayedComputed.position, 'left:', delayedComputed.left, 'top:', delayedComputed.top, 'transform:', delayedComputed.transform);
                  console.log('[Header Location Selector] V7: DELAYED CHECK (500ms) - rect:', delayedRect);
                }, 500);
                
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2462',message:'AFTER insertBefore',data:{parentNode:addressInputContainer.parentNode?.className||'null',parentTag:addressInputContainer.parentNode?.tagName||'null',isInDropdown:addressInputContainer.parentNode?.classList.contains('store-selection-dropdown')||false,childIndex:Array.from(addressInputContainer.parentNode?.children||[]).indexOf(addressInputContainer),rect:JSON.stringify(addressInputContainer.getBoundingClientRect())},timestamp:Date.now(),sessionId:'debug-session',runId:'run2',hypothesisId:'B'})}).catch(()=>{});
                // #endregion
                
                // Log all CSS rules that might be affecting this element
                var allStylesheets = Array.from(document.styleSheets);
                var matchingRules = [];
                try {
                  allStylesheets.forEach(function(sheet) {
                    try {
                      var rules = sheet.cssRules || sheet.rules || [];
                      Array.from(rules).forEach(function(rule) {
                        if (rule.selectorText && (rule.selectorText.includes('.address-input-container') || rule.selectorText.includes('address-input'))) {
                          matchingRules.push({
                            selector: rule.selectorText,
                            cssText: rule.cssText,
                            style: rule.style ? Object.fromEntries(Array.from(rule.style).map(function(prop) { return [prop, rule.style[prop]]; })) : null
                          });
                        }
                      });
                    } catch(e) {
                      // Cross-origin stylesheet, skip
                    }
                  });
                } catch(e) {
                  console.log('[Header Location Selector] Error reading stylesheets:', e);
                }
                console.log('[Header Location Selector] V7: Found', matchingRules.length, 'CSS rules matching address-input-container');
                if (matchingRules.length > 0) {
                  console.log('[Header Location Selector] V7: Matching CSS rules:', matchingRules);
                }
                
                // FORCE re-apply styles immediately after insertion to override any theme CSS
                // Also ensure parent dropdown uses column layout for proper stacking
                setTimeout(function() {
                  addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                  
                  // Force dropdown to use column layout
                  if (targetDropdown) {
                    targetDropdown.style.setProperty('display', 'flex', 'important');
                    targetDropdown.style.setProperty('flex-direction', 'column', 'important');
                    targetDropdown.style.setProperty('align-items', 'stretch', 'important');
                    targetDropdown.style.setProperty('flex-wrap', 'nowrap', 'important');
                    console.log('[Header Location Selector] V8: Forced dropdown to use column layout');
                    
                    // Force order on saved-address-item and address-input-container to ensure proper stacking
                    if (targetItem) {
                      targetItem.style.setProperty('order', '1', 'important');
                      var savedItemOrderAfter = window.getComputedStyle(targetItem).order;
                      console.log('[Header Location Selector] V8: Set saved-address-item order to 1, computed:', savedItemOrderAfter);
                    }
                    addressInputContainer.style.setProperty('order', '2', 'important');
                    var containerOrderAfter = window.getComputedStyle(addressInputContainer).order;
                    console.log('[Header Location Selector] V8: Set address-input-container order to 2, computed:', containerOrderAfter);
                    // #region agent log
//                     fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2991',message:'Flex order applied',data:{savedItemOrder:targetItem?window.getComputedStyle(targetItem).order:'N/A',containerOrder:window.getComputedStyle(addressInputContainer).order,dropdownFlexDirection:targetDropdown?window.getComputedStyle(targetDropdown).flexDirection:'N/A',dropdownDisplay:targetDropdown?window.getComputedStyle(targetDropdown).display:'N/A',allChildrenOrder:Array.from(targetDropdown?.children||[]).map(function(c){return{className:c.className||c.tagName,order:window.getComputedStyle(c).order};})},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'E'})}).catch(()=>{});
                    // #endregion
                    console.log('[Header Location Selector] V8: Set flex order on items (saved-address-item: 1, address-input-container: 2)');
                  }
                  
                  console.log('[Header Location Selector] V8: Re-applied styles after 10ms');
                }, 10);
                
                // IMMEDIATE CHECK: Verify it's in the right place
                setTimeout(function() {
                  var parent = addressInputContainer.parentNode;
                  var computedStyle = window.getComputedStyle(addressInputContainer);
                  
                  // #region agent log
//                   fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2460',message:'50ms after insert - computed styles',data:{position:computedStyle.position,top:computedStyle.top,left:computedStyle.left,transform:computedStyle.transform,zIndex:computedStyle.zIndex,parentClass:parent?.className||'null'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
                  // #endregion
                  
                  console.log('[Header Location Selector] IMMEDIATE CHECK (50ms after insert):');
                  console.log('[Header Location Selector] Parent:', parent);
                  console.log('[Header Location Selector] Parent className:', parent ? parent.className : 'null');
                  console.log('[Header Location Selector] Computed position:', computedStyle.position);
                  console.log('[Header Location Selector] Computed top:', computedStyle.top);
                  console.log('[Header Location Selector] Computed left:', computedStyle.left);
                  
                  // If it's in the wrong place, move it immediately
                  if (!parent || !parent.classList.contains('store-selection-dropdown')) {
                    console.log('[Header Location Selector] ⚠⚠⚠ IMMEDIATE FIX: Container in wrong parent! Moving...');
                    var correctDropdown = document.querySelector('.store-selection-dropdown');
                    var correctSavedItem = correctDropdown ? correctDropdown.querySelector('.saved-address-item') : null;
                    if (correctDropdown && correctSavedItem) {
                      correctDropdown.insertBefore(addressInputContainer, correctSavedItem.nextSibling);
                      console.log('[Header Location Selector] ✓ Moved to correct location');
                    }
                  }
                  
                  // Force positioning again
                  addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                }, 50);
                
                // Double-check it's in the dropdown and not body
                if (addressInputContainer.parentNode === document.body) {
                  console.log('[Header Location Selector] ⚠⚠⚠ ERROR: addressInputContainer was appended to body! Moving to dropdown...');
                  targetDropdown.insertBefore(addressInputContainer, targetItem.nextSibling);
                }
                
                // Force style again after insertion to prevent any CSS from overriding
                addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                
                console.log('[Header Location Selector] ✓✓✓ SUCCESS: Inserted address input after savedAddressItem');
                console.log('[Header Location Selector] addressInputContainer.parentNode:', addressInputContainer.parentNode);
                console.log('[Header Location Selector] addressInputContainer.parentNode.className:', addressInputContainer.parentNode ? addressInputContainer.parentNode.className : 'null');
                console.log('[Header Location Selector] addressInputContainer.style AFTER insert:', addressInputContainer.style.cssText);
                console.log('[Header Location Selector] addressInputContainer computed style position:', window.getComputedStyle(addressInputContainer).position);
                console.log('[Header Location Selector] addressInputContainer is now child #', Array.from(addressInputContainer.parentNode.children).indexOf(addressInputContainer));
                console.log('[Header Location Selector] All dropdown children:', Array.from(addressInputContainer.parentNode.children).map(function(c, i) { 
                  return i + ': ' + (c.className || c.tagName || 'unknown'); 
                }));
                
                // Add a visible border to confirm it's the right element - use setProperty for !important
                addressInputContainer.style.setProperty('border', '5px solid red', 'important');
                addressInputContainer.style.setProperty('background-color', 'yellow', 'important');
                addressInputContainer.style.setProperty('outline', '5px solid blue', 'important');
                addressInputContainer.setAttribute('data-debug-marked', 'true');
                console.log('[Header Location Selector] ⚠⚠⚠ ADDED RED BORDER, YELLOW BACKGROUND, AND BLUE OUTLINE TO ADDRESS INPUT CONTAINER FOR DEBUGGING');
                console.log('[Header Location Selector] addressInputContainer element:', addressInputContainer);
                console.log('[Header Location Selector] addressInputContainer.outerHTML:', addressInputContainer.outerHTML.substring(0, 200));
                
                // Log the actual visual position
                setTimeout(function() {
                  var rect = addressInputContainer.getBoundingClientRect();
                  console.log('[Header Location Selector] ⚠⚠⚠ VISUAL POSITION CHECK:');
                  console.log('[Header Location Selector] getBoundingClientRect():', rect);
                  console.log('[Header Location Selector] Top:', rect.top, 'Left:', rect.left, 'Width:', rect.width, 'Height:', rect.height);
                  console.log('[Header Location Selector] Parent dropdown rect:', targetDropdown.getBoundingClientRect());
                  console.log('[Header Location Selector] savedAddressItem rect:', targetItem.getBoundingClientRect());
                }, 100);
                
                // Set up a continuous monitor to ensure it stays in the right place
                var monitorInterval = setInterval(function() {
                  if (!addressInputContainer || !addressInputContainer.parentNode) {
                    clearInterval(monitorInterval);
                    return;
                  }
                  
                  var parent = addressInputContainer.parentNode;
                  var computedStyle = window.getComputedStyle(addressInputContainer);
                  
                  // Check if it's in the wrong place
                  if (!parent.classList.contains('store-selection-dropdown')) {
                    console.log('[Header Location Selector] ⚠⚠⚠ MONITOR: Container moved to wrong parent! Moving back...');
                    var dropdown = document.querySelector('.store-selection-dropdown');
                    var savedItem = dropdown ? dropdown.querySelector('.saved-address-item') : null;
                    if (dropdown && savedItem) {
                      dropdown.insertBefore(addressInputContainer, savedItem.nextSibling);
                      addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                    }
                  }
                  
                  // Check if positioning is wrong
                  if (computedStyle.position === 'fixed' || computedStyle.position === 'absolute') {
                    console.log('[Header Location Selector] ⚠⚠⚠ MONITOR: Container has fixed/absolute positioning! Fixing...');
                    addressInputContainer.style.cssText = 'padding: 10px 16px !important; border-bottom: 1px solid #e0e0e0 !important; display: block !important; position: static !important; top: auto !important; left: auto !important; right: auto !important; bottom: auto !important; transform: none !important; z-index: auto !important; width: 100% !important; max-width: 100% !important; margin: 0 !important; float: none !important; clear: both !important;';
                  }
                }, 100); // Check every 100ms
                
                // Stop monitoring after 5 seconds
                setTimeout(function() {
                  clearInterval(monitorInterval);
                  console.log('[Header Location Selector] Stopped monitoring address input container');
                }, 5000);
              } else {
                console.log('[Header Location Selector] ⚠⚠⚠ ERROR: Could not find targetItem or targetDropdown!');
                console.log('[Header Location Selector] targetItem:', targetItem);
                console.log('[Header Location Selector] targetDropdown:', targetDropdown);
                // Last resort: append to dropdown if we found it
                if (targetDropdown) {
                  targetDropdown.appendChild(addressInputContainer);
                  console.log('[Header Location Selector] Appended to dropdown as fallback');
                } else {
                  console.log('[Header Location Selector] ⚠⚠⚠ Could not find dropdown at all!');
                }
              }
            } else if (zipCodeItem && zipCodeItem.parentNode) {
              // LAST RESORT: Check one more time for savedAddressItem before replacing
              var lastChanceDropdown = zipCodeItem.closest('.store-selection-dropdown');
              var lastChanceSavedItem = lastChanceDropdown ? lastChanceDropdown.querySelector('.saved-address-item') : null;
              if (lastChanceSavedItem) {
                console.warn('[Header Location Selector] V7: LAST CHANCE - Found savedAddressItem, inserting after it instead of replacing!');
                lastChanceDropdown.insertBefore(addressInputContainer, lastChanceSavedItem.nextSibling);
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2913',message:'LAST CHANCE - inserted after savedAddressItem',data:{foundSavedItem:!!lastChanceSavedItem},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                // #endregion
              } else {
                console.warn('[Header Location Selector] V7: WARNING - Replacing zipCodeItem (NOT inserting after saved)');
                console.warn('[Header Location Selector] V7: insertAfterSaved:', insertAfterSaved, 'savedItemInDOM:', !!savedItemInDOM, 'lastChanceSavedItem:', !!lastChanceSavedItem);
                console.warn('[Header Location Selector] V7: Dropdown children:', zipCodeItem.parentNode ? Array.from(zipCodeItem.parentNode.children).map(function(c) { return c.className || c.tagName; }) : 'no parent');
                // #region agent log
//                 fetch('http://127.0.0.1:7242/ingest/5ef50ec5-028f-456b-b73a-ea9b763e7bbb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'header-location-selector.js:2916',message:'REPLACING zipCodeItem (NOT inserting after saved)',data:{zipCodeItemParent:zipCodeItem.parentNode?.className||'null',insertAfterSaved:insertAfterSaved,foundSavedItemInDOM:!!savedItemInDOM,lastChanceFound:!!lastChanceSavedItem,dropdownChildren:zipCodeItem.parentNode?Array.from(zipCodeItem.parentNode.children).map(function(c){return c.className||c.tagName;}):[]},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
                // #endregion
                zipCodeItem.parentNode.replaceChild(addressInputContainer, zipCodeItem);
              }
            }
          }

          // Load Google Places Autocomplete using Places API (New) REST API (only if addressInput exists)
          // Google Maps API key - can be overridden via window.GOOGLE_MAPS_API_KEY if needed
          var googleMapsApiKey = window.GOOGLE_MAPS_API_KEY || 'AIzaSyBoix1DjhRIIMPTnGLTYugjXCocpGqhF4g';

          var initAutocomplete = function() {
            if (!addressInput) {
              return; // Skip if addressInput doesn't exist (init-only mode)
            }
            if (!googleMapsApiKey) {
              console.warn('Google Maps API key not configured. Address autocomplete disabled.');
              addressInput.placeholder = 'Enter full address (street, city, state, zip)';
              return;
            }
            
            // Debounce function for autocomplete requests
            var debounceTimer = null;
            var lastQuery = '';
            
            addressInput.addEventListener('input', function() {
              var query = addressInput.value.trim();
              
              // Clear previous timer
              if (debounceTimer) {
                clearTimeout(debounceTimer);
              }
              
              // Don't make request if query is too short or unchanged
              if (query.length < 3 || query === lastQuery) {
                return;
              }
              
              lastQuery = query;
              
              // Debounce the request
              debounceTimer = setTimeout(function() {
                fetchAutocompleteSuggestions(query);
              }, 300);
            });
            
            // Handle selection from dropdown
            addressInput.addEventListener('keydown', function(e) {
              var suggestionsList = document.getElementById('places-autocomplete-suggestions');
              if (!suggestionsList) return;
              
              var activeItem = suggestionsList.querySelector('.suggestion-item.active');
              
              if (e.key === 'ArrowDown') {
                e.preventDefault();
                var nextItem = activeItem ? activeItem.nextElementSibling : suggestionsList.querySelector('.suggestion-item');
                if (nextItem) {
                  if (activeItem) activeItem.classList.remove('active');
                  nextItem.classList.add('active');
                }
              } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                var prevItem = activeItem ? activeItem.previousElementSibling : null;
                if (prevItem) {
                  activeItem.classList.remove('active');
                  prevItem.classList.add('active');
                } else if (activeItem) {
                  activeItem.classList.remove('active');
                }
              } else if (e.key === 'Enter' && activeItem) {
                e.preventDefault();
                activeItem.click();
              } else if (e.key === 'Escape') {
                hideSuggestions();
              }
            });
          }
          
          function fetchAutocompleteSuggestions(query) {
            if (!query || query.length < 3) {
              hideSuggestions();
              return;
            }
            
            // Use Places API (New) REST endpoint
            var url = 'https://places.googleapis.com/v1/places:autocomplete';
            
            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Goog-Api-Key': googleMapsApiKey,
                'X-Goog-FieldMask': 'suggestions.placePrediction.placeId,suggestions.placePrediction.text'
              },
              body: JSON.stringify({
                input: query,
                includedRegionCodes: ['us'],
                includedPrimaryTypes: ['street_address', 'premise', 'subpremise'],
                languageCode: 'en'
              })
            })
            .then(function(response) {
              if (!response.ok) {
                throw new Error('Places API request failed');
              }
              return response.json();
            })
            .then(function(data) {
              if (data.suggestions && data.suggestions.length > 0) {
                showSuggestions(data.suggestions, query);
              } else {
                hideSuggestions();
              }
            })
            .catch(function(error) {
              console.warn('Places Autocomplete error:', error);
              hideSuggestions();
            });
          }
          
          function showSuggestions(suggestions, query) {
            // Remove existing suggestions
            hideSuggestions();
            
            // Create suggestions container
            var suggestionsList = document.createElement('div');
            suggestionsList.id = 'places-autocomplete-suggestions';
            // Style will be set in showSuggestions function based on positioning
            
            // Add each suggestion
            suggestions.forEach(function(suggestion, index) {
              if (suggestion.placePrediction) {
                var item = document.createElement('div');
                item.className = 'suggestion-item';
                item.style.cssText = 'padding: 12px 16px; cursor: pointer; font-size: 14px; border-bottom: 1px solid #f0f0f0; min-height: 48px; display: flex; align-items: center;';
                item.textContent = suggestion.placePrediction.text.text;
                
                item.addEventListener('mouseenter', function() {
                  suggestionsList.querySelectorAll('.suggestion-item').forEach(function(i) {
                    i.classList.remove('active');
                  });
                  this.classList.add('active');
                });
                
                item.addEventListener('click', function() {
                  selectPlace(suggestion.placePrediction.placeId, suggestion.placePrediction.text.text);
                });
                
                suggestionsList.appendChild(item);
              }
            });
            
            // Position suggestions below input - use fixed positioning to avoid clipping by parent container
            var inputRect = addressInput.getBoundingClientRect();
            
            // Use fixed positioning so it's not clipped by parent overflow
            suggestionsList.style.cssText = 'position: fixed; top: ' + (inputRect.bottom) + 'px; left: ' + inputRect.left + 'px; width: ' + inputRect.width + 'px; background: white; border: 1px solid #d0d0d0; border-radius: 0 0 3px 3px; max-height: 300px; overflow-y: auto; z-index: 100002; box-shadow: 0 2px 4px rgba(0,0,0,0.1);';
            
            // Append to body so it's not clipped by parent container's overflow
            document.body.appendChild(suggestionsList);
          }
          
          function hideSuggestions() {
            var suggestionsList = document.getElementById('places-autocomplete-suggestions');
            if (suggestionsList) {
              suggestionsList.remove();
            }
          }
          
          // Store performSearch function reference so it can be called from selectPlace
          var performSearchRef = null;
          
          function selectPlace(placeId, text) {
            addressInput.value = text;
            hideSuggestions();
            
            console.log('selectPlace called with placeId:', placeId, 'text:', text);
            
            // Get place details first to get coordinates from Places API
            getPlaceDetails(placeId).then(function(placeData) {
              console.log('Place details received:', placeData);
              
              // Try to get coordinates from place data first
              // Places API (New) returns location as { latitude: X, longitude: Y }
              var deliveryCoords = null;
              if (placeData && placeData.location) {
                var lat = placeData.location.latitude || placeData.location.lat;
                var lng = placeData.location.longitude || placeData.location.lng;
                if (lat && lng) {
                  var formattedAddress = placeData.formattedAddress || text;
                  deliveryCoords = {
                    lat: lat,
                    lng: lng,
                    formatted: formattedAddress
                  };
                  console.log('Using coordinates from place details:', deliveryCoords);
                  
                  // Save address to localStorage
                  try {
                    var savedAddress = {
                      address: formattedAddress,
                      placeId: placeId,
                      coordinates: {
                        lat: lat,
                        lng: lng
                      },
                      timestamp: Date.now()
                    };
                    localStorage.setItem('savedDeliveryAddress', JSON.stringify(savedAddress));
                    console.log('Saved delivery address to localStorage:', savedAddress);
                  } catch(e) {
                    console.warn('Could not save address to localStorage:', e);
                  }
                  
                  // Wait for inventoryInfo to be available
                  console.log('About to call waitForInventoryInfo, function exists:', typeof waitForInventoryInfo);
                  try {
                    if (typeof waitForInventoryInfo === 'function') {
                      waitForInventoryInfo(function() {
                        console.log('inventoryInfo is now available, showing modal');
                        showStoreSelectionModal(deliveryCoords, text);
                      });
                    } else {
                      console.error('waitForInventoryInfo is not a function!', typeof waitForInventoryInfo);
                      // Fallback: try to show modal directly
                      setTimeout(function() {
                        showStoreSelectionModal(deliveryCoords, text);
                      }, 1000);
                    }
                  } catch (e) {
                    console.error('Error calling waitForInventoryInfo:', e);
                    // Fallback: try to show modal directly
                    setTimeout(function() {
                      showStoreSelectionModal(deliveryCoords, text);
                    }, 1000);
                  }
                  return;
                }
              }
              
              // Fallback to geocoding
              console.log('No coordinates in place data, geocoding address...');
              geocodeAddress(text).then(function(coords) {
                console.log('Geocoded coordinates:', coords);
                
                // Save address to localStorage
                try {
                  var savedAddress = {
                    address: text,
                    placeId: null,
                    coordinates: coords ? {
                      lat: coords.lat,
                      lng: coords.lng
                    } : null,
                    timestamp: Date.now()
                  };
                  localStorage.setItem('savedDeliveryAddress', JSON.stringify(savedAddress));
                  console.log('Saved delivery address to localStorage:', savedAddress);
                } catch(e) {
                  console.warn('Could not save address to localStorage:', e);
                }
                
                try {
                  if (typeof waitForInventoryInfo === 'function') {
                    waitForInventoryInfo(function() {
                      console.log('inventoryInfo is now available, showing modal');
                      showStoreSelectionModal(coords, text);
                    });
                  } else {
                    setTimeout(function() {
                      showStoreSelectionModal(coords, text);
                    }, 1000);
                  }
                } catch (e) {
                  console.error('Error calling waitForInventoryInfo:', e);
                  setTimeout(function() {
                    showStoreSelectionModal(coords, text);
                  }, 1000);
                }
              }).catch(function(error) {
                console.warn('Geocoding error:', error);
                try {
                  if (typeof waitForInventoryInfo === 'function') {
                    waitForInventoryInfo(function() {
                      console.log('inventoryInfo is now available, showing modal (no coords)');
                      showStoreSelectionModal(null, text);
                    });
                  } else {
                    setTimeout(function() {
                      showStoreSelectionModal(null, text);
                    }, 1000);
                  }
                } catch (e) {
                  console.error('Error calling waitForInventoryInfo:', e);
                  setTimeout(function() {
                    showStoreSelectionModal(null, text);
                  }, 1000);
                }
              });
            }).catch(function(error) {
              console.warn('Place details error:', error);
              // Try to geocode the address text directly
              geocodeAddress(text).then(function(deliveryCoords) {
                console.log('Geocoded coordinates (fallback):', deliveryCoords);
                try {
                  if (typeof waitForInventoryInfo === 'function') {
                    waitForInventoryInfo(function() {
                      console.log('inventoryInfo is now available, showing modal (fallback)');
                      showStoreSelectionModal(deliveryCoords, text);
                    });
                  } else {
                    setTimeout(function() {
                      showStoreSelectionModal(deliveryCoords, text);
                    }, 1000);
                  }
                } catch (e) {
                  console.error('Error calling waitForInventoryInfo:', e);
                  setTimeout(function() {
                    showStoreSelectionModal(deliveryCoords, text);
                  }, 1000);
                }
              }).catch(function(err) {
                console.warn('Geocoding error:', err);
                try {
                  if (typeof waitForInventoryInfo === 'function') {
                    waitForInventoryInfo(function() {
                      console.log('inventoryInfo is now available, showing modal (fallback, no coords)');
                      showStoreSelectionModal(null, text);
                    });
                  } else {
                    setTimeout(function() {
                      showStoreSelectionModal(null, text);
                    }, 1000);
                  }
                } catch (e) {
                  console.error('Error calling waitForInventoryInfo:', e);
                  setTimeout(function() {
                    showStoreSelectionModal(null, text);
                  }, 1000);
                }
              });
            });
          }
          
          // Wait for inventoryInfo to be available
          function waitForInventoryInfo(callback, maxAttempts) {
            console.log('waitForInventoryInfo function called');
            maxAttempts = maxAttempts || 50; // Try for up to 5 seconds (50 * 100ms)
            var attempts = 0;
            
            function check() {
              attempts++;
              console.log('Waiting for inventoryInfo, attempt', attempts, 'of', maxAttempts);
              console.log('window.inventoryInfo:', window.inventoryInfo);
              console.log('window.inventoryInfo exists?', !!window.inventoryInfo);
              console.log('window.inventoryInfo.locationSettings exists?', !!(window.inventoryInfo && window.inventoryInfo.locationSettings));
              console.log('window.inventoryInfo.locationSettings.locations exists?', !!(window.inventoryInfo && window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.locations));
              
              try {
                var hasLocations = window.inventoryInfo && window.inventoryInfo.locationSettings && (window.inventoryInfo.locationSettings.locations || window.inventoryInfo.locationSettings.details);
                
                if (hasLocations) {
                  console.log('inventoryInfo found! Locations available.');
                  if (typeof callback === 'function') {
                    callback();
                  } else {
                    console.error('waitForInventoryInfo callback is not a function!', typeof callback);
                  }
                } else if (attempts >= maxAttempts) {
                  console.warn('inventoryInfo not found after', maxAttempts, 'attempts, proceeding anyway');
                  if (typeof callback === 'function') {
                    callback();
                  } else {
                    console.error('waitForInventoryInfo callback is not a function!', typeof callback);
                  }
                } else {
                  setTimeout(check, 100);
                }
              } catch (e) {
                console.error('Error in waitForInventoryInfo check:', e);
                // Still try to call callback after max attempts
                if (attempts >= maxAttempts && typeof callback === 'function') {
                  callback();
                }
              }
            }
            
            check();
          }
          
          // Store reference for saved address handler
          waitForInventoryInfoRef = waitForInventoryInfo;
          
          function showStoreSelectionModal(deliveryCoords, addressText) {
            console.log('showStoreSelectionModal CALLED with deliveryCoords:', deliveryCoords, 'addressText:', addressText);
            
            // Validate and normalize coordinates
            if (deliveryCoords && deliveryCoords.lat && deliveryCoords.lng) {
              // Ensure coordinates are numbers
              deliveryCoords.lat = parseFloat(deliveryCoords.lat);
              deliveryCoords.lng = parseFloat(deliveryCoords.lng);
              
              // Validate coordinates
              if (isNaN(deliveryCoords.lat) || isNaN(deliveryCoords.lng)) {
                console.error('Invalid coordinates in deliveryCoords:', deliveryCoords);
                deliveryCoords = null;
              } else {
                console.log('Validated coordinates - lat:', deliveryCoords.lat, 'lng:', deliveryCoords.lng, 'types:', typeof deliveryCoords.lat, typeof deliveryCoords.lng);
              }
            } else {
              console.warn('No delivery coordinates provided or coordinates are missing');
            }
            
            // Remove existing modal if any
            var existingModal = document.getElementById('store-selection-modal');
            if (existingModal) {
              existingModal.remove();
            }
            
            // Use the stored button element from showLocationDropdown, or find it if not available
            var localDeliveryBtn = storedButtonElement || buttonElement;
            
            // If still not found, search for it
            if (!localDeliveryBtn) {
              localDeliveryBtn = document.querySelector('.header-method-btn[data-method="local_delivery"], .mobile-method-btn[data-method="local_delivery"]');
            }
            
            console.log('[Store Selection Modal] Using button for positioning:', localDeliveryBtn);
            
            // Create modal overlay (transparent background, just for click-outside-to-close)
            var overlay = document.createElement('div');
            overlay.id = 'store-selection-modal-overlay';
            overlay.style.cssText = 'position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; background: rgba(0,0,0,0.3) !important; z-index: 100003 !important; margin: 0 !important; padding: 0 !important; box-sizing: border-box !important;';
            
            // Create modal - will position after finding button
            var modal = document.createElement('div');
            modal.id = 'store-selection-modal';
            modal.style.cssText = 'background: white !important; border-radius: 8px !important; padding: 0 !important; max-width: 600px !important; width: 90% !important; max-height: 80vh !important; overflow-y: auto !important; box-shadow: 0 4px 20px rgba(0,0,0,0.3) !important; position: fixed !important; margin: 0 !important; z-index: 100004 !important;';
            
            // Modal header
            var header = document.createElement('div');
            header.style.cssText = 'padding: 20px; border-bottom: 1px solid #e0e0e0; position: sticky; top: 0; background: white; z-index: 1;';
            
            var title = document.createElement('h2');
            title.textContent = 'Select Your Store';
            title.style.cssText = 'margin: 0 0 8px 0; font-size: 20px; font-weight: 600; color: #293149;';
            
            var addressDisplay = document.createElement('div');
            addressDisplay.textContent = 'Delivery Address: ' + addressText;
            addressDisplay.style.cssText = 'font-size: 14px; color: #666; margin-bottom: 0;';
            
            var closeBtn = document.createElement('button');
            closeBtn.innerHTML = '×';
            closeBtn.style.cssText = 'position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 28px; color: #999; cursor: pointer; width: 30px; height: 30px; line-height: 1; padding: 0;';
            closeBtn.onclick = function() {
              overlay.remove();
            };
            
            header.appendChild(title);
            header.appendChild(addressDisplay);
            header.appendChild(closeBtn);
            
            // Modal body
            var body = document.createElement('div');
            body.style.cssText = 'padding: 20px;';
            
            // Get all locations - try multiple ways to access inventoryInfo
            var inventoryInfoRef = window.inventoryInfo;
            // Create local reference for use in nested functions
            var inventoryInfo = inventoryInfoRef || window.inventoryInfo;
            console.log('showStoreSelectionModal - Debugging InventoryInfo Structure:');
            if (inventoryInfoRef) {
              if (inventoryInfoRef.settings && inventoryInfoRef.settings.stockLocationRules) {
                 console.log('StockLocationRules Full:', JSON.stringify(inventoryInfoRef.settings.stockLocationRules));
              }
              
              // Check for global Zapiet object (common for store pickup apps)
              if (window.Zapiet) console.log('Found window.Zapiet:', window.Zapiet);
              if (window.ZapietCachedSettings) console.log('Found window.ZapietCachedSettings:', window.ZapietCachedSettings);
              
              // Try to find where location details might be
              // Look for any property that is an array of objects with 'name' or 'address'
              function findLocations(obj, depth) {
                if (depth > 3) return;
                for (var key in obj) {
                  if (Array.isArray(obj[key]) && obj[key].length > 0) {
                    if (obj[key][0] && (obj[key][0].name || obj[key][0].address1 || obj[key][0].company)) {
                      console.log('Potential locations found at key:', key, 'Value:', obj[key]);
                    }
                  } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                    findLocations(obj[key], depth + 1);
                  }
                }
              }
              // findLocations(inventoryInfoRef, 0); // Caution: might be recursive loop
            }
            
            console.log('showStoreSelectionModal - inventoryInfoRef:', inventoryInfoRef);
            console.log('showStoreSelectionModal - inventoryInfoRef.locationSettings:', inventoryInfoRef && inventoryInfoRef.locationSettings);
            console.log('showStoreSelectionModal - inventoryInfoRef.locationSettings.locations:', inventoryInfoRef && inventoryInfoRef.locationSettings && inventoryInfoRef.locationSettings.locations);
            
            var allLocations = [];
            
            // Location ID to details mapping (from Shopify API)
            var locationIdToDetails = {
              "42639884424": {
                "name": "Wilsonville Pet Supply",
                "address1": "8406 SW Main St. #200",
                "address2": "",
                "city": "Wilsonville",
                "province": "Oregon",
                "state": "Oregon",
                "zip": "97070",
                "postalCode": "97070",
                "country": "US",
                "phone": "+15036829812",
                "latitude": null,
                "longitude": null
              },
              "43460657288": {
                "name": "Newberg Location (Critter Cabana)",
                "address1": "516 E First St",
                "address2": "",
                "city": "Newberg",
                "province": "Oregon",
                "state": "Oregon",
                "zip": "97132",
                "postalCode": "97132",
                "country": "US",
                "phone": "+15035372570",
                "latitude": null,
                "longitude": null
              },
              "83963379929": {
                "name": "Salem Pet Supply (North)",
                "address1": "3185 Market St NE",
                "address2": "",
                "city": "Salem",
                "province": "Oregon",
                "state": "Oregon",
                "zip": "97301",
                "postalCode": "97301",
                "country": "US",
                "phone": "+15039907455",
                "latitude": null,
                "longitude": null
              },
              "83963445465": {
                "name": "South Salem Pet Supply",
                "address1": "4695 Commercial St SE",
                "address2": "",
                "city": "Salem",
                "province": "Oregon",
                "state": "Oregon",
                "zip": "97302",
                "postalCode": "97302",
                "country": "US",
                "phone": "+15035850553",
                "latitude": null,
                "longitude": null
              },
              "85743730905": {
                "name": "Gresham Pet Supply",
                "address1": "1152 Northwest Civic Drive",
                "address2": "",
                "city": "Gresham",
                "province": "Oregon",
                "state": "Oregon",
                "zip": "97030",
                "postalCode": "97030",
                "country": "US",
                "phone": "+15036661518",
                "latitude": null,
                "longitude": null
              },
              "83963281625": {
                "name": "Tigard Pet Supply",
                "address1": "16200 SW Pacific Hwy",
                "address2": "Suite W-W2",
                "city": "Tigard",
                "province": "Oregon",
                "state": "Oregon",
                "zip": "97224",
                "postalCode": "97224",
                "country": "US",
                "phone": "+15033392426",
                "latitude": null,
                "longitude": null
              }
            };
            
            // Backward compatibility: name mapping
            var locationIdToName = {};
            for (var id in locationIdToDetails) {
              locationIdToName[id] = locationIdToDetails[id].name;
            }
            
            // Try multiple ways to get locations
            var locationsArray = null;
            if (inventoryInfoRef && inventoryInfoRef.locationSettings && inventoryInfoRef.locationSettings.locations) {
              locationsArray = inventoryInfoRef.locationSettings.locations;
            } else if (inventoryInfoRef && inventoryInfoRef.locationSettings && inventoryInfoRef.locationSettings.details) {
              locationsArray = inventoryInfoRef.locationSettings.details;
            } else if (inventoryInfoRef && inventoryInfoRef.locations) {
              locationsArray = inventoryInfoRef.locations;
            }
            
            console.log('showStoreSelectionModal - locationsArray found:', locationsArray);
            
            if (locationsArray && Array.isArray(locationsArray) && locationsArray.length > 0) {
              var onlineId = inventoryInfoRef && inventoryInfoRef.settings && inventoryInfoRef.settings.onlineLocation;
              console.log('showStoreSelectionModal - onlineLocation ID:', onlineId);
              console.log('showStoreSelectionModal - first location sample:', JSON.stringify(locationsArray[0]));
              
              // If locations only have IDs, try to enrich them with API calls or fetch from Shopify
              if (locationsArray[0] && locationsArray[0].id && !locationsArray[0].name) {
                console.log('Locations only have IDs, attempting to fetch details...');
                
                // Try API method first
                if (inventoryInfoRef.api && inventoryInfoRef.api.getSelectedLocationInfo) {
                  try {
                    var testId = locationsArray[0].id;
                    var testInfo = inventoryInfoRef.api.getSelectedLocationInfo(testId);
                    console.log('API getSelectedLocationInfo(' + testId + ') result:', testInfo);
                  } catch(e) {
                    console.log('Error calling getSelectedLocationInfo:', e);
                  }
                }
                
                // Try fetching from Shopify Storefront API
                // Note: This might require authentication, but worth trying
                var shopDomain = inventoryInfoRef.shop && inventoryInfoRef.shop.shopifyDomain;
                if (shopDomain) {
                  console.log('Attempting to fetch locations from Shopify API for domain:', shopDomain);
                  // We'll implement async fetch below if API doesn't work
                }
              }
              
              // Enrich locations with full details from mapping if missing
              locationsArray = locationsArray.map(function(loc) {
                if (loc && loc.id) {
                  var details = locationIdToDetails[loc.id] || locationIdToDetails[String(loc.id)];
                  if (details) {
                    // Merge details into location object
                    if (!loc.name) loc.name = details.name;
                    if (!loc.locationName) loc.locationName = details.name;
                    if (!loc.address1) loc.address1 = details.address1;
                    if (!loc.address2 && details.address2) loc.address2 = details.address2;
                    if (!loc.city) loc.city = details.city;
                    if (!loc.province) loc.province = details.province;
                    if (!loc.state) loc.state = details.state;
                    if (!loc.zip) loc.zip = details.zip;
                    if (!loc.postalCode) loc.postalCode = details.postalCode;
                    if (!loc.country) loc.country = details.country;
                    if (!loc.phone) loc.phone = details.phone;
                    // Note: latitude/longitude are null in Shopify, will be geocoded
                  }
                }
                return loc;
              });
              
              // Fetch location addresses from Shopify API
              // Try to fetch location details for all locations that don't have addresses
              var locationsNeedingAddresses = locationsArray.filter(function(loc) {
                return loc && loc.id && !loc.address1 && !loc.latitude;
              });
              
              if (locationsNeedingAddresses.length > 0) {
                console.log('Fetching addresses for', locationsNeedingAddresses.length, 'locations from Shopify...');
                
                // Fetch location details from Shopify API
                // Note: This requires a backend proxy endpoint since Locations API needs Admin access
                // For now, we'll try to fetch from a proxy endpoint if available
                var shopDomain = inventoryInfoRef.shop && inventoryInfoRef.shop.shopifyDomain;
                if (shopDomain) {
                  // Try fetching from a backend proxy endpoint
                  // Format: /api/shopify/locations?ids=83963379929,83963445465,...
                  var locationIds = locationsNeedingAddresses.map(function(loc) { return loc.id; }).join(',');
                  
                  // Check if we have a proxy endpoint available
                  // If not, we'll use hardcoded addresses as fallback
                  fetch('/api/shopify/locations?ids=' + locationIds)
                    .then(function(response) {
                      if (response.ok) {
                        return response.json();
                      }
                      throw new Error('Failed to fetch locations');
                    })
                    .then(function(locationData) {
                      // Enrich locations with fetched data
                      if (locationData && locationData.locations) {
                        locationData.locations.forEach(function(fetchedLoc) {
                          var existingLoc = locationsArray.find(function(loc) {
                            return loc.id == fetchedLoc.id || loc.id == fetchedLoc.location_id;
                          });
                          if (existingLoc) {
                            // Merge fetched data
                            if (fetchedLoc.name) existingLoc.name = fetchedLoc.name;
                            if (fetchedLoc.address1) existingLoc.address1 = fetchedLoc.address1;
                            if (fetchedLoc.address2) existingLoc.address2 = fetchedLoc.address2;
                            if (fetchedLoc.city) existingLoc.city = fetchedLoc.city;
                            if (fetchedLoc.province) existingLoc.province = fetchedLoc.province;
                            if (fetchedLoc.zip) existingLoc.zip = fetchedLoc.zip;
                            if (fetchedLoc.latitude) existingLoc.latitude = fetchedLoc.latitude;
                            if (fetchedLoc.longitude) existingLoc.longitude = fetchedLoc.longitude;
                          }
                        });
                        // Re-render the modal with updated location data
                        console.log('Location addresses fetched successfully');
                      }
                    })
                    .catch(function(error) {
                      console.log('Could not fetch locations from API proxy:', error.message);
                      console.log('Using hardcoded location names only');
                    });
                }
              }
              
              console.log('showStoreSelectionModal - all locations before filter:', locationsArray);
              
              allLocations = locationsArray.filter(function(loc) {
                if (!loc || !loc.id) {
                  console.log('showStoreSelectionModal - skipping location (no id):', loc);
                  return false;
                }
                var isOnline = String(loc.id) === String(onlineId);
                var locName = loc.name || loc.locationName || locationIdToName[loc.id] || ('Location ' + loc.id);
                console.log('showStoreSelectionModal - checking location:', locName, 'ID:', loc.id, 'isOnline:', isOnline);
                return !isOnline;
              });
              
              console.log('showStoreSelectionModal - physical locations after filter:', allLocations.length, allLocations);
            } else {
              console.warn('showStoreSelectionModal - inventoryInfo or locations not available:', {
                hasInventoryInfo: !!inventoryInfo,
                hasWindowInventoryInfo: !!window.inventoryInfo,
                hasLocationSettings: !!(inventoryInfo && inventoryInfo.locationSettings),
                hasLocations: !!(inventoryInfo && inventoryInfo.locationSettings && inventoryInfo.locationSettings.locations),
                locationsArray: locationsArray,
                locationsArrayLength: locationsArray ? locationsArray.length : 0
              });
            }
            
            if (allLocations.length === 0) {
              console.warn('showStoreSelectionModal - No physical locations found!');
              var noStores = document.createElement('div');
              noStores.style.cssText = 'text-align: center; padding: 40px 20px; color: #666;';
              noStores.textContent = 'No physical store locations available.';
              body.appendChild(noStores);
              
              // Add debug info
              var debugInfo = document.createElement('div');
              debugInfo.style.cssText = 'text-align: center; padding: 20px; font-size: 12px; color: #999; border-top: 1px solid #e0e0e0;';
              debugInfo.innerHTML = 'Debug: inventoryInfo=' + (inventoryInfoRef ? 'exists' : 'null') + '<br>' +
                                    'locationSettings=' + (inventoryInfoRef && inventoryInfoRef.locationSettings ? 'exists' : 'null') + '<br>' +
                                    'locations=' + (inventoryInfoRef && inventoryInfoRef.locationSettings && inventoryInfoRef.locationSettings.locations ? inventoryInfoRef.locationSettings.locations.length + ' found' : 'null');
              body.appendChild(debugInfo);
            } else {
              // Check if we have delivery coordinates
              if (deliveryCoords && deliveryCoords.lat && deliveryCoords.lng) {
                // Calculate distances for all stores
                var storePromises = allLocations.map(function(loc) {
                  return getStoreCoordinates(loc).then(function(storeCoords) {
                    var locName = loc.name || loc.locationName || ('Location ' + loc.id);
                    if (!storeCoords || !storeCoords.lat || !storeCoords.lng) {
                      console.warn('No store coordinates available for:', locName);
                      return { location: loc, distance: Infinity, withinRange: false };
                    }
                    // Ensure all coordinates are numbers
                    var deliveryLat = parseFloat(deliveryCoords.lat);
                    var deliveryLng = parseFloat(deliveryCoords.lng);
                    var storeLat = parseFloat(storeCoords.lat);
                    var storeLng = parseFloat(storeCoords.lng);
                    
                    console.log('Calculating distance - Delivery:', deliveryLat, deliveryLng, 'Store:', storeLat, storeLng);
                    
                    if (isNaN(deliveryLat) || isNaN(deliveryLng) || isNaN(storeLat) || isNaN(storeLng)) {
                      console.error('Invalid coordinates for distance calculation:', {
                        delivery: { lat: deliveryLat, lng: deliveryLng },
                        store: { lat: storeLat, lng: storeLng }
                      });
                      return { location: loc, distance: Infinity, withinRange: false };
                    }
                    
                    var distance = calculateDistance(
                      deliveryLat,
                      deliveryLng,
                      storeLat,
                      storeLng
                    );
                    console.log('Distance from', addressText, 'to', locName, ':', distance, 'miles');
                    return {
                      location: loc,
                      distance: distance,
                      withinRange: distance <= 3
                    };
                  }).catch(function(error) {
                    var locName = loc.name || loc.locationName || ('Location ' + loc.id);
                    console.warn('Error getting coordinates for', locName, ':', error.message || error);
                    return { location: loc, distance: Infinity, withinRange: false };
                  });
                });
                
                Promise.all(storePromises).then(function(results) {
                console.log('All store distance results:', results);
                
                // Sort by distance (closest first)
                results.sort(function(a, b) {
                  if (a.withinRange && !b.withinRange) return -1;
                  if (!a.withinRange && b.withinRange) return 1;
                  return a.distance - b.distance;
                });
                
                var storesInRange = results.filter(function(r) { return r.withinRange && r.distance !== Infinity; });
                console.log('Stores in range (<= 3 miles):', storesInRange.length, storesInRange);
                console.log('Total stores:', results.length);
                
                // Show ALL stores with checkmarks for those in range (for debugging)
                results.forEach(function(result) {
                  var locName = result.location.name || result.location.locationName || ('Location ' + result.location.id);
                  console.log('Processing store:', locName, 'Distance:', result.distance, 'Within range:', result.withinRange);
                    var storeItem = document.createElement('div');
                    storeItem.style.cssText = 'padding: 16px; border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 12px; cursor: pointer; transition: all 0.2s;';
                    
                    var storeContent = document.createElement('div');
                    storeContent.style.cssText = 'display: flex; align-items: flex-start; gap: 12px;';
                    
                    // Checkmark or X icon
                    var icon = document.createElement('div');
                    icon.style.cssText = 'flex-shrink: 0; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-top: 2px;';
                    if (result.withinRange) {
                      icon.innerHTML = '✓';
                      icon.style.cssText += 'color: #298029; font-size: 18px; font-weight: bold;';
                    } else {
                      icon.innerHTML = '✗';
                      icon.style.cssText += 'color: #d32f2f; font-size: 18px; font-weight: bold;';
                    }
                    
                    // Store info
                    var storeInfo = document.createElement('div');
                    storeInfo.style.cssText = 'flex: 1;';
                    
                    var storeName = document.createElement('div');
                    storeName.textContent = result.location.name || ('Location ' + result.location.id);
                    storeName.style.cssText = 'font-weight: 500; font-size: 16px; color: #293149; margin-bottom: 4px;';
                    
                    var storeAddress = document.createElement('div');
                    var addressParts = [];
                    if (result.location.address1) addressParts.push(result.location.address1);
                    if (result.location.city) addressParts.push(result.location.city);
                    if (result.location.province || result.location.state) addressParts.push(result.location.province || result.location.state);
                    if (result.location.zip || result.location.postalCode) addressParts.push(result.location.zip || result.location.postalCode);
                    storeAddress.textContent = addressParts.join(', ');
                    storeAddress.style.cssText = 'font-size: 13px; color: #666; margin-bottom: 4px;';
                    
                    var distanceInfo = document.createElement('div');
                    if (result.distance === Infinity || isNaN(result.distance)) {
                      distanceInfo.textContent = 'Distance unavailable';
                      distanceInfo.style.cssText = 'font-size: 12px; color: #999; font-style: italic;';
                    } else if (result.withinRange) {
                      distanceInfo.textContent = result.distance.toFixed(2) + ' miles away - Within delivery range (✓)';
                      distanceInfo.style.cssText = 'font-size: 12px; color: #298029; font-weight: 500;';
                    } else {
                      distanceInfo.textContent = result.distance.toFixed(2) + ' miles away - Outside delivery range (3 mile limit)';
                      distanceInfo.style.cssText = 'font-size: 12px; color: #d32f2f;';
                    }
                    
                    storeInfo.appendChild(storeName);
                    storeInfo.appendChild(storeAddress);
                    storeInfo.appendChild(distanceInfo);
                    
                    storeContent.appendChild(icon);
                    storeContent.appendChild(storeInfo);
                    
                    storeItem.appendChild(storeContent);
                    
                    // Make all stores clickable for debugging, but visually indicate range
                    if (result.withinRange) {
                      storeItem.onmouseover = function() {
                        this.style.backgroundColor = '#f0f8f0';
                        this.style.borderColor = '#298029';
                      };
                      storeItem.onmouseout = function() {
                        this.style.backgroundColor = 'white';
                        this.style.borderColor = '#e0e0e0';
                      };
                    } else {
                      storeItem.onmouseover = function() {
                        this.style.backgroundColor = '#fff5f5';
                        this.style.borderColor = '#d32f2f';
                      };
                      storeItem.onmouseout = function() {
                        this.style.backgroundColor = 'white';
                        this.style.borderColor = '#e0e0e0';
                      };
                    }
                    
                    // Allow clicking any store for debugging
                    storeItem.onclick = function(e) {
                      e.preventDefault();
                      e.stopPropagation();
                      var locIdNum = typeof result.location.id === 'string' ? parseInt(result.location.id, 10) : result.location.id;
                      var locName = result.location.name || result.location.locationName || ('Location ' + result.location.id);
                      console.log('Clicking store:', locName, 'ID:', locIdNum, 'Distance:', result.distance, 'Within range:', result.withinRange);
                      if (!isNaN(locIdNum) && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                        storeItem.style.opacity = '0.6';
                        storeItem.style.cursor = 'wait';
                        
                        inventoryInfo.api.selectLocation(locIdNum).then(function() {
                          console.log('Successfully selected location:', locName);
                          overlay.remove();
                          if (dropdown && dropdown.parentNode) {
                            dropdown.remove();
                          }
                          if (result.location && result.location.id) {
                            if (typeof window.updateHeaderText === 'function') {
                              window.updateHeaderText(locName);
                            }
                            var locationTextEl = document.querySelector('.location-picker-text');
                            var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                            if (locationTextEl) locationTextEl.textContent = locName;
                            if (locationTextElMobile) {
                              locationTextElMobile.textContent = locName;
                              locationTextElMobile.style.display = 'inline-block';
                            }
                          }
                          setTimeout(function() {
                            if (typeof updateWidgetDisplay === 'function') {
                              updateWidgetDisplay();
                            }
                          }, 300);
                        }).catch(function(error) {
                          console.warn('Error selecting location:', error);
                          
                          // Handle 422 (Out of Stock) as a soft success for UI purposes
                          // Allow the user to select the store even if items are OOS there
                          if (error && (error.status === 422 || (error.message && error.message.indexOf('sold out') !== -1))) {
                            console.log('Location selection failed due to stock (422), forcing UI update anyway');
                            // Store forced ID for updateWidgetDisplay
                            window.forcedLocationId = locIdNum;
                            
                            overlay.remove();
                            if (dropdown && dropdown.parentNode) {
                              dropdown.remove();
                            }
                            
                            // Update header text forcefully
                            if (typeof window.updateHeaderText === 'function') {
                              window.updateHeaderText(locName);
                            }
                            var locationTextEl = document.querySelector('.location-picker-text');
                            var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                            if (locationTextEl) locationTextEl.textContent = locName;
                            if (locationTextElMobile) {
                              locationTextElMobile.textContent = locName;
                              locationTextElMobile.style.display = 'inline-block';
                            }
                            
                            // Force widget update
                            setTimeout(function() {
                              if (typeof updateWidgetDisplay === 'function') {
                                updateWidgetDisplay();
                              }
                            }, 300);
                            
                            // Optionally notify user (non-blocking)
                            // alert('Note: Some items in your cart may not be available at this location.');
                          } else {
                            storeItem.style.opacity = '1';
                            storeItem.style.cursor = 'pointer';
                          }
                        });
                      } else {
                        console.warn('Invalid location ID or API not available:', locIdNum, inventoryInfo);
                      }
                    };
                    
                    body.appendChild(storeItem);
                  });
                  
                  // If no stores in range, show shipping option at the bottom
                  if (storesInRange.length === 0) {
                    var shippingDiv = document.createElement('div');
                    shippingDiv.style.cssText = 'margin-top: 20px; padding-top: 20px; border-top: 2px solid #e0e0e0; text-align: center;';
                    
                    var shippingMsg = document.createElement('div');
                    shippingMsg.style.cssText = 'font-size: 16px; color: #666; margin-bottom: 16px; font-weight: 500;';
                    shippingMsg.textContent = 'No stores within delivery range (3 miles).';
                    
                    var shippingSubMsg = document.createElement('div');
                    shippingSubMsg.style.cssText = 'font-size: 14px; color: #999; margin-bottom: 20px;';
                    shippingSubMsg.textContent = 'You can continue with shipping to have your order delivered.';
                    
                    var shippingBtn = document.createElement('button');
                    shippingBtn.textContent = 'Continue with Shipping';
                    shippingBtn.style.cssText = 'padding: 12px 24px; background: #298029; color: white; border: none; border-radius: 4px; font-size: 14px; font-weight: 500; cursor: pointer;';
                    shippingBtn.onmouseover = function() {
                      this.style.backgroundColor = '#1f6f1f';
                    };
                    shippingBtn.onmouseout = function() {
                      this.style.backgroundColor = '#298029';
                    };
                    shippingBtn.onclick = function() {
                      // Select online warehouse
                      var onlineId = inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocation;
                      if (onlineId && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                        shippingBtn.disabled = true;
                        shippingBtn.textContent = 'Selecting...';
                        inventoryInfo.api.selectLocation(onlineId).then(function() {
                          overlay.remove();
                          if (dropdown && dropdown.parentNode) {
                            dropdown.remove();
                          }
                          if (typeof window.updateHeaderText === 'function') {
                            var onlineLabel = inventoryInfo.settings.onlineLocationLabel || 'Online Warehouse';
                            window.updateHeaderText(onlineLabel);
                          }
                          setTimeout(function() {
                            if (typeof updateWidgetDisplay === 'function') {
                              updateWidgetDisplay();
                            }
                          }, 300);
                        }).catch(function(error) {
                          console.warn('Error selecting online location:', error);
                          shippingBtn.disabled = false;
                          shippingBtn.textContent = 'Continue with Shipping';
                        });
                      } else {
                        overlay.remove();
                        if (dropdown && dropdown.parentNode) {
                          dropdown.remove();
                        }
                      }
                    };
                    
                    shippingDiv.appendChild(shippingMsg);
                    shippingDiv.appendChild(shippingSubMsg);
                    shippingDiv.appendChild(shippingBtn);
                    body.appendChild(shippingDiv);
                  }
                }).catch(function(error) {
                  console.warn('Error calculating distances:', error);
                  // Show error message
                  var errorDiv = document.createElement('div');
                  errorDiv.style.cssText = 'text-align: center; padding: 40px 20px; color: #d32f2f;';
                  errorDiv.textContent = 'Error calculating distances. Please try again.';
                  body.appendChild(errorDiv);
                });
              } else {
                // No delivery coordinates - show all stores without distance info
                allLocations.forEach(function(loc) {
                  var storeItem = document.createElement('div');
                  storeItem.style.cssText = 'padding: 16px; border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 12px; cursor: pointer;';
                  
                  var storeContent = document.createElement('div');
                  storeContent.style.cssText = 'display: flex; align-items: flex-start; gap: 12px;';
                  
                  var storeInfo = document.createElement('div');
                  storeInfo.style.cssText = 'flex: 1;';
                  
                  var storeName = document.createElement('div');
                  storeName.textContent = loc.name || ('Location ' + loc.id);
                  storeName.style.cssText = 'font-weight: 500; font-size: 16px; color: #293149; margin-bottom: 4px;';
                  
                  var storeAddress = document.createElement('div');
                  var addressParts = [];
                  if (loc.address1) addressParts.push(loc.address1);
                  if (loc.city) addressParts.push(loc.city);
                  if (loc.province || loc.state) addressParts.push(loc.province || loc.state);
                  if (loc.zip || loc.postalCode) addressParts.push(loc.zip || loc.postalCode);
                  storeAddress.textContent = addressParts.join(', ');
                  storeAddress.style.cssText = 'font-size: 13px; color: #666;';
                  
                  storeInfo.appendChild(storeName);
                  storeInfo.appendChild(storeAddress);
                  storeContent.appendChild(storeInfo);
                  storeItem.appendChild(storeContent);
                  
                  storeItem.onmouseover = function() {
                    this.style.backgroundColor = '#f0f8f0';
                    this.style.borderColor = '#298029';
                  };
                  storeItem.onmouseout = function() {
                    this.style.backgroundColor = 'white';
                    this.style.borderColor = '#e0e0e0';
                  };
                  storeItem.onclick = function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var locIdNum = typeof loc.id === 'string' ? parseInt(loc.id, 10) : loc.id;
                    if (!isNaN(locIdNum) && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                      storeItem.style.opacity = '0.6';
                      storeItem.style.cursor = 'wait';
                      
                      inventoryInfo.api.selectLocation(locIdNum).then(function() {
                        overlay.remove();
                        if (dropdown && dropdown.parentNode) {
                          dropdown.remove();
                        }
                        if (loc && loc.name) {
                          if (typeof window.updateHeaderText === 'function') {
                            window.updateHeaderText(loc.name);
                          }
                          var locationTextEl = document.querySelector('.location-picker-text');
                          var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                          if (locationTextEl) locationTextEl.textContent = loc.name;
                          if (locationTextElMobile) {
                            locationTextElMobile.textContent = loc.name;
                            locationTextElMobile.style.display = 'inline-block';
                          }
                        }
                        setTimeout(function() {
                          if (typeof updateWidgetDisplay === 'function') {
                            updateWidgetDisplay();
                          }
                        }, 300);
                      }).catch(function(error) {
                        console.warn('Error selecting location:', error);
                        storeItem.style.opacity = '1';
                        storeItem.style.cursor = 'pointer';
                      });
                    }
                  };
                  
                  body.appendChild(storeItem);
                });
              }
            }
            
            modal.appendChild(header);
            modal.appendChild(body);
            overlay.appendChild(modal);
            document.body.appendChild(overlay);
            
            // Position modal below Local Delivery button
            function positionModal() {
              // Use the stored button element first (from showLocationDropdown)
              var btn = localDeliveryBtn;
              
              // If not available, try multiple selectors to find the Local Delivery button
              if (!btn) {
                btn = document.querySelector('.header-method-btn[data-method="local_delivery"]') ||
                       document.querySelector('.mobile-method-btn[data-method="local_delivery"]') ||
                       document.querySelector('.header-method-btn.active[data-method="local_delivery"]') ||
                       document.querySelector('.mobile-method-btn.active[data-method="local_delivery"]') ||
                       document.querySelector('.header-method-btn[data-active="true"][data-method="local_delivery"]') ||
                       document.querySelector('.mobile-method-btn[data-active="true"][data-method="local_delivery"]') ||
                       Array.from(document.querySelectorAll('.header-method-btn, .mobile-method-btn')).find(function(b) {
                         var method = b.getAttribute('data-method');
                         var text = (b.textContent || '').toLowerCase();
                         return method === 'local_delivery' || text.includes('local delivery');
                       });
                
                // If still not found, try finding by current method
                if (!btn && window.currentMethod === 'local_delivery') {
                  btn = document.querySelector('.header-method-btn[data-method="' + window.currentMethod + '"]') ||
                        document.querySelector('.mobile-method-btn[data-method="' + window.currentMethod + '"]');
                }
              }
              
              if (btn) {
                var rect = btn.getBoundingClientRect();
                console.log('[Store Selection Modal] Button found:', btn, 'at position:', {
                  top: rect.top,
                  bottom: rect.bottom,
                  left: rect.left,
                  right: rect.right,
                  width: rect.width,
                  height: rect.height
                });
                
                // Get actual modal dimensions (wait for it to render)
                var modalElement = document.getElementById('store-selection-modal');
                if (!modalElement) {
                  console.log('[Store Selection Modal] Modal element not found yet');
                  return;
                }
                
                // Force a reflow to get accurate dimensions
                modalElement.style.visibility = 'hidden';
                modalElement.style.display = 'block';
                var modalWidth = Math.min(600, window.innerWidth - 40);
                var modalHeight = modalElement.offsetHeight || Math.min(window.innerHeight * 0.8, 600);
                modalElement.style.visibility = 'visible';
                
                // Position modal below button with 10px gap
                // Since modal is position: fixed, use getBoundingClientRect values directly (relative to viewport)
                var top = rect.bottom + 10;
                
                // Try to align modal's left edge with button's left edge first
                var left = rect.left;
                
                // If modal would extend off right edge, try aligning right edges instead
                if (left + modalWidth > window.innerWidth - 20) {
                  // Align modal's right edge with button's right edge
                  left = rect.right - modalWidth;
                  
                  // If that would push it off left edge, center it on the button
                  if (left < 20) {
                    var buttonCenter = rect.left + (rect.width / 2);
                    left = buttonCenter - (modalWidth / 2);
                    
                    // Ensure it doesn't go off either edge
                    if (left < 20) {
                      left = 20;
                    }
                    if (left + modalWidth > window.innerWidth - 20) {
                      left = window.innerWidth - modalWidth - 20;
                    }
                  }
                }
                
                // Final safety check - ensure modal doesn't go off left edge
                if (left < 20) {
                  left = 20;
                }
                
                // If modal would go off bottom, position above button instead
                if (top + modalHeight > window.innerHeight - 20) {
                  top = rect.top - modalHeight - 10;
                  if (top < 20) {
                    top = 20; // Fallback to top if still doesn't fit
                    modalElement.style.maxHeight = (window.innerHeight - 40) + 'px';
                  }
                }
                
                console.log('[Store Selection Modal] Positioning modal:', {
                  top: top,
                  left: left,
                  modalWidth: modalWidth,
                  modalHeight: modalHeight,
                  windowWidth: window.innerWidth,
                  windowHeight: window.innerHeight,
                  buttonRect: {
                    top: rect.top,
                    bottom: rect.bottom,
                    left: rect.left,
                    right: rect.right,
                    width: rect.width,
                    height: rect.height
                  },
                  buttonElement: btn,
                  buttonText: btn.textContent,
                  buttonMethod: btn.getAttribute('data-method')
                });
                
                modalElement.style.top = top + 'px';
                modalElement.style.left = left + 'px';
                modalElement.style.transform = 'none';
                modalElement.style.maxWidth = modalWidth + 'px';
              } else {
                // Fallback: center if button not found
                console.log('[Store Selection Modal] Button not found, trying all buttons:', 
                  Array.from(document.querySelectorAll('.header-method-btn, .mobile-method-btn')).map(function(b) {
                    return {text: b.textContent, dataMethod: b.getAttribute('data-method')};
                  }));
                var modalElement = document.getElementById('store-selection-modal');
                if (modalElement) {
                  modalElement.style.top = '50%';
                  modalElement.style.left = '50%';
                  modalElement.style.transform = 'translate(-50%, -50%)';
                }
              }
            }
            
            // Position using requestAnimationFrame for better timing
            function schedulePosition() {
              requestAnimationFrame(function() {
                positionModal();
                // Also try after a short delay to account for any async rendering
                setTimeout(function() {
                  requestAnimationFrame(positionModal);
                }, 50);
              });
            }
            
            // Position immediately and multiple times to account for layout shifts
            // More aggressive retries when called from "Change" button
            schedulePosition();
            setTimeout(schedulePosition, 10);
            setTimeout(schedulePosition, 50);
            setTimeout(schedulePosition, 100);
            setTimeout(schedulePosition, 200);
            setTimeout(schedulePosition, 300);
            setTimeout(schedulePosition, 500);
            setTimeout(schedulePosition, 1000);
            
            // Reposition on window resize
            var resizeHandler = function() {
              schedulePosition();
            };
            window.addEventListener('resize', resizeHandler);
            
            // Reposition on scroll (in case button moves)
            var scrollHandler = function() {
              schedulePosition();
            };
            window.addEventListener('scroll', scrollHandler, true);
            
            // Clean up event listeners when modal is removed
            var originalRemove = overlay.remove;
            overlay.remove = function() {
              window.removeEventListener('resize', resizeHandler);
              window.removeEventListener('scroll', scrollHandler, true);
              originalRemove.call(this);
            };
            
            // Use ResizeObserver to detect when modal is fully rendered
            if (window.ResizeObserver) {
              var resizeObserver = new ResizeObserver(function() {
                schedulePosition();
              });
              var modalElement = document.getElementById('store-selection-modal');
              if (modalElement) {
                resizeObserver.observe(modalElement);
                // Clean up observer when modal is removed
                var originalRemove2 = overlay.remove;
                overlay.remove = function() {
                  resizeObserver.disconnect();
                  originalRemove2.call(this);
                };
              }
            }
            
            // Use MutationObserver to watch for button appearing in DOM (in case it's added dynamically)
            var buttonObserver = new MutationObserver(function() {
              // Check if button is now available
              var btn = document.querySelector('.header-method-btn[data-method="local_delivery"]') ||
                       document.querySelector('.mobile-method-btn[data-method="local_delivery"]');
              if (btn) {
                schedulePosition();
                // Disconnect after finding button (we have other retries)
                setTimeout(function() {
                  buttonObserver.disconnect();
                }, 2000);
              }
            });
            
            // Observe the document body for button additions
            if (document.body) {
              try {
                buttonObserver.observe(document.body, {
                  childList: true,
                  subtree: true,
                  attributes: true,
                  attributeFilter: ['data-method', 'data-active', 'class']
                });
                // Disconnect after 5 seconds to avoid memory leaks
                setTimeout(function() {
                  buttonObserver.disconnect();
                }, 5000);
                
                // Clean up observer when modal is removed
                var originalRemove3 = overlay.remove;
                overlay.remove = function() {
                  buttonObserver.disconnect();
                  originalRemove3.call(this);
                };
              } catch(e) {
                console.warn('[Store Selection Modal] Could not set up button observer:', e);
              }
            }
            
            // Close on overlay click
            overlay.onclick = function(e) {
              if (e.target === overlay) {
                overlay.remove();
              }
            };
            
            // Close on Escape key
            var escapeHandler = function(e) {
              if (e.key === 'Escape') {
                overlay.remove();
                document.removeEventListener('keydown', escapeHandler);
              }
            };
            document.addEventListener('keydown', escapeHandler);
            }
            
            // Start trying to show modal
            // tryShowModal();
          
          function getPlaceDetails(placeId) {
            return new Promise(function(resolve, reject) {
              var url = 'https://places.googleapis.com/v1/places/' + placeId;
              
              fetch(url, {
                method: 'GET',
                headers: {
                  'X-Goog-Api-Key': googleMapsApiKey,
                  'X-Goog-FieldMask': 'location,formattedAddress'
                }
              })
              .then(function(response) {
                if (!response.ok) {
                  throw new Error('Place details request failed');
                }
                return response.json();
              })
              .then(function(data) {
                // Address selected, ready to search
                addressSearchBtn.disabled = false;
                addressSearchBtn.style.opacity = '1';
                resolve(data);
              })
              .catch(function(error) {
                console.warn('Place details error:', error);
                // Still enable search button even if details fail
                addressSearchBtn.disabled = false;
                addressSearchBtn.style.opacity = '1';
                reject(error);
              });
            });
          }
          
          // Initialize autocomplete (only if addressInput exists)
          if (addressInput) {
            initAutocomplete();
            
            // Focus on input
            setTimeout(function() {
              addressInput.focus();
            }, 50);
          }
          
          // Calculate distance between two coordinates using Haversine formula
          function calculateDistance(lat1, lon1, lat2, lon2) {
            var R = 3959; // Earth's radius in miles
            var dLat = (lat2 - lat1) * Math.PI / 180;
            var dLon = (lon2 - lon1) * Math.PI / 180;
            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                    Math.sin(dLon/2) * Math.sin(dLon/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c; // Distance in miles
          }
          
          // Geocode an address to get coordinates using Geocoding API REST endpoint
          function geocodeAddress(address) {
            return new Promise(function(resolve, reject) {
              var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(address) + '&key=' + googleMapsApiKey;
              
              fetch(url)
                .then(function(response) {
                  if (!response.ok) {
                    throw new Error('Geocoding request failed');
                  }
                  return response.json();
                })
                .then(function(data) {
                  if (data.status === 'OK' && data.results && data.results[0] && data.results[0].geometry && data.results[0].geometry.location) {
                    resolve({
                      lat: data.results[0].geometry.location.lat,
                      lng: data.results[0].geometry.location.lng,
                      formatted: data.results[0].formatted_address
                    });
                  } else {
                    reject(new Error('Geocoding failed: ' + (data.status || 'Unknown error')));
                  }
                })
                .catch(function(error) {
                  reject(new Error('Geocoding failed: ' + error.message));
                });
            });
          }
          
          // Get store coordinates (from location data or geocode store address)
          function getStoreCoordinates(location) {
            // Check if location has coordinates
            if (location.latitude && location.longitude) {
              return Promise.resolve({
                lat: parseFloat(location.latitude),
                lng: parseFloat(location.longitude)
              });
            }
            
            // If not, geocode the store address
            var address = '';
            if (location.address1) address += location.address1;
            if (location.city) address += (address ? ', ' : '') + location.city;
            if (location.province || location.state) address += (address ? ', ' : '') + (location.province || location.state);
            if (location.zip || location.postalCode) address += (address ? ' ' : '') + (location.zip || location.postalCode);
            
            if (address) {
              return geocodeAddress(address);
            }
            
            // Location only has ID, no address/coordinates available
            var locationId = location.id || location.locationId || 'unknown';
            return Promise.reject(new Error('Location ' + locationId + ' has no address or coordinates available'));
          }
          
          // Handle search - calculate distance from address to each store
          var performSearch = function() {
            // Store reference for use in selectPlace
            performSearchRef = performSearch;
            
            var address = addressInput.value.trim();
            if (!address) {
              var errorMsg = document.createElement('div');
              errorMsg.className = 'address-error-message';
              errorMsg.style.cssText = 'padding: 8px 16px; font-size: 12px; color: #d32f2f; text-align: center;';
              errorMsg.textContent = 'Please enter a delivery address';
              addressInputContainer.parentNode.insertBefore(errorMsg, addressInputContainer.nextSibling);
              setTimeout(function() {
                if (errorMsg.parentNode) errorMsg.remove();
              }, 3000);
              return;
            }
            
            // Disable search button
            addressSearchBtn.disabled = true;
            addressSearchBtn.style.opacity = '0.6';
            addressSearchBtn.textContent = 'Searching...';
            
            // Remove existing location items and messages
            var existingItems = dropdown.querySelectorAll('.store-dropdown-item:not(.address-input-container), .address-error-message, .address-success-message, .address-no-results, .address-searching-message');
            existingItems.forEach(function(item) {
              item.remove();
            });
            
            // Show searching message
            var message = document.createElement('div');
            message.className = 'address-searching-message';
            message.style.cssText = 'padding: 12px 16px; font-size: 13px; color: #666; text-align: center; font-style: italic;';
            message.textContent = 'Finding nearby stores...';
            addressInputContainer.parentNode.insertBefore(message, addressInputContainer.nextSibling);
            
            // Geocode the entered address to get coordinates
            geocodeAddress(address).then(function(deliveryCoords) {
              message.textContent = 'Calculating distances to stores...';
              
              // Check distance to each store location
              var locationPromises = locations.map(function(loc) {
                return getStoreCoordinates(loc).then(function(storeCoords) {
                  var distance = calculateDistance(
                    deliveryCoords.lat,
                    deliveryCoords.lng,
                    storeCoords.lat,
                    storeCoords.lng
                  );
                  return {
                    location: loc,
                    distance: distance,
                    withinRange: distance <= 3 // 3 miles
                  };
                }).catch(function() {
                  // If we can't get coordinates, exclude from results
                  return { location: loc, distance: Infinity, withinRange: false };
                });
              });
              
              return Promise.all(locationPromises);
            }).then(function(results) {
              message.remove();
              addressSearchBtn.disabled = false;
              addressSearchBtn.style.opacity = '1';
              addressSearchBtn.textContent = 'Search';
              
              // Filter to stores within 3 miles
              var matchingLocs = results
                .filter(function(r) { return r.withinRange; })
                .sort(function(a, b) { return a.distance - b.distance; }) // Sort by distance
                .map(function(r) { 
                  r.location.distance = r.distance; // Store distance for display
                  return r.location; 
                });
              
              matchingLocations = matchingLocs;
              
              if (matchingLocations.length === 0) {
                // No stores found within 3 miles
                var noResults = document.createElement('div');
                noResults.className = 'address-no-results';
                noResults.style.cssText = 'padding: 16px; font-size: 13px; color: #d32f2f; text-align: center; border-top: 1px solid #e0e0e0;';
                noResults.innerHTML = '<div style="font-weight: 500; margin-bottom: 8px;">No stores within delivery range</div><div style="font-size: 12px; color: #666; margin-bottom: 8px;">We do not currently offer delivery to this address (within 3 miles of our stores).</div><div style="font-size: 12px; color: #666;">Please select a store location manually from the list below, or contact us for more information.</div>';
                addressInputContainer.parentNode.insertBefore(noResults, addressInputContainer.nextSibling);
                
                // Show all locations below the "no stores found" message
                locations.forEach(function(loc) {
                  var menuItem = document.createElement('div');
                  menuItem.className = 'store-dropdown-item';
                  menuItem.style.cssText = 'padding: 8px 16px; cursor: pointer; font-size: 13px; color: #666; white-space: nowrap; opacity: 0.7;';
                  menuItem.textContent = loc.name || ('Location ' + loc.id);
                  menuItem.title = 'This location may not deliver to your zip code';
                  menuItem.onmouseover = function() {
                    this.style.backgroundColor = '#f5f5f5';
                    this.style.opacity = '1';
                  };
                  menuItem.onmouseout = function() {
                    this.style.backgroundColor = 'transparent';
                    this.style.opacity = '0.7';
                  };
                  menuItem.onclick = function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var locIdNum = typeof loc.id === 'string' ? parseInt(loc.id, 10) : loc.id;
                    if (!isNaN(locIdNum) && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                      inventoryInfo.api.selectLocation(locIdNum).then(function() {
                        dropdown.remove();
                        if (loc && loc.name) {
                          if (typeof window.updateHeaderText === 'function') {
                            window.updateHeaderText(loc.name);
                          }
                          var locationTextEl = document.querySelector('.location-picker-text');
                          var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                          if (locationTextEl) locationTextEl.textContent = loc.name;
                          if (locationTextElMobile) {
                            locationTextElMobile.textContent = loc.name;
                            locationTextElMobile.style.display = 'inline-block';
                          }
                        }
                        setTimeout(function() {
                          if (typeof updateWidgetDisplay === 'function') {
                            updateWidgetDisplay();
                          }
                        }, 300);
                      }).catch(function() {
                        dropdown.remove();
                      });
                    }
                  };
                  dropdown.insertBefore(menuItem, dropdown.lastElementChild);
                });
              } else {
                // Show matching locations with distances
                var successMsg = document.createElement('div');
                successMsg.className = 'address-success-message';
                successMsg.style.cssText = 'padding: 10px 16px; font-size: 12px; color: #298029; text-align: center; border-top: 1px solid #e0e0e0; font-weight: 500; background: #f0f8f0;';
                successMsg.textContent = '✓ ' + matchingLocations.length + ' store' + (matchingLocations.length > 1 ? 's' : '') + ' within 3 miles';
                addressInputContainer.parentNode.insertBefore(successMsg, addressInputContainer.nextSibling);
                
                matchingLocations.forEach(function(loc) {
                  var menuItem = document.createElement('div');
                  menuItem.className = 'store-dropdown-item';
                  var distanceText = loc.distance ? loc.distance.toFixed(1) + ' mi away' : '';
                  menuItem.style.cssText = 'padding: 12px 16px; cursor: pointer; font-size: 14px; color: #293149; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f0f0f0;';
                  
                  var storeInfo = document.createElement('div');
                  storeInfo.style.cssText = 'flex: 1;';
                  
                  var storeName = document.createElement('div');
                  storeName.textContent = loc.name || ('Location ' + loc.id);
                  storeName.style.cssText = 'font-weight: 500; margin-bottom: 4px; color: #293149;';
                  
                  var storeAddress = document.createElement('div');
                  var addressParts = [];
                  if (loc.address1) addressParts.push(loc.address1);
                  if (loc.city) addressParts.push(loc.city);
                  if (loc.province || loc.state) addressParts.push(loc.province || loc.state);
                  if (loc.zip || loc.postalCode) addressParts.push(loc.zip || loc.postalCode);
                  storeAddress.textContent = addressParts.join(', ');
                  storeAddress.style.cssText = 'font-size: 12px; color: #666;';
                  
                  storeInfo.appendChild(storeName);
                  storeInfo.appendChild(storeAddress);
                  
                  var distanceSpan = document.createElement('span');
                  distanceSpan.textContent = distanceText;
                  distanceSpan.style.cssText = 'font-size: 12px; color: #298029; font-weight: 500; margin-left: 12px; white-space: nowrap;';
                  
                  menuItem.appendChild(storeInfo);
                  menuItem.appendChild(distanceSpan);
                  menuItem.onmouseover = function() {
                    this.style.backgroundColor = '#f0f8f0';
                    this.style.cursor = 'pointer';
                  };
                  menuItem.onmouseout = function() {
                    this.style.backgroundColor = 'transparent';
                  };
                  menuItem.onclick = function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var locIdNum = typeof loc.id === 'string' ? parseInt(loc.id, 10) : loc.id;
                    if (!isNaN(locIdNum) && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                      // Show loading state
                      menuItem.style.opacity = '0.6';
                      menuItem.style.cursor = 'wait';
                      
                      inventoryInfo.api.selectLocation(locIdNum).then(function() {
                        dropdown.remove();
                        if (loc && loc.name) {
                          if (typeof window.updateHeaderText === 'function') {
                            window.updateHeaderText(loc.name);
                          }
                          var locationTextEl = document.querySelector('.location-picker-text');
                          var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                          if (locationTextEl) locationTextEl.textContent = loc.name;
                          if (locationTextElMobile) {
                            locationTextElMobile.textContent = loc.name;
                            locationTextElMobile.style.display = 'inline-block';
                          }
                        }
                        setTimeout(function() {
                          if (typeof updateWidgetDisplay === 'function') {
                            updateWidgetDisplay();
                          }
                        }, 300);
                      }).catch(function(error) {
                        console.warn('Error selecting location:', error);
                        menuItem.style.opacity = '1';
                        menuItem.style.cursor = 'pointer';
                        dropdown.remove();
                      });
                    }
                  };
                  dropdown.insertBefore(menuItem, dropdown.lastElementChild);
                });
              }
            }).catch(function(error) {
              console.warn('Search or geocoding failed:', error);
              message.remove();
              addressSearchBtn.disabled = false;
              addressSearchBtn.style.opacity = '1';
              addressSearchBtn.textContent = 'Search';
              
              // On error, show error message
              var errorMsg = document.createElement('div');
              errorMsg.className = 'address-error-message';
              errorMsg.style.cssText = 'padding: 12px 16px; font-size: 12px; color: #d32f2f; text-align: center; border-top: 1px solid #e0e0e0;';
              errorMsg.textContent = 'Unable to verify address. Please select a store location manually from the list below.';
              addressInputContainer.parentNode.insertBefore(errorMsg, addressInputContainer.nextSibling);
              
              // Show all locations below the error message
              locations.forEach(function(loc) {
                var menuItem = document.createElement('div');
                menuItem.className = 'store-dropdown-item';
                menuItem.style.cssText = 'padding: 8px 16px; cursor: pointer; font-size: 13px; color: #293149; white-space: nowrap;';
                menuItem.textContent = loc.name || ('Location ' + loc.id);
                menuItem.onmouseover = function() {
                  this.style.backgroundColor = '#f0f8f0';
                };
                menuItem.onmouseout = function() {
                  this.style.backgroundColor = 'transparent';
                };
                menuItem.onclick = function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  var locIdNum = typeof loc.id === 'string' ? parseInt(loc.id, 10) : loc.id;
                  if (!isNaN(locIdNum) && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                    inventoryInfo.api.selectLocation(locIdNum).then(function() {
                      dropdown.remove();
                      if (loc && loc.name) {
                        if (typeof window.updateHeaderText === 'function') {
                          window.updateHeaderText(loc.name);
                        }
                        var locationTextEl = document.querySelector('.location-picker-text');
                        var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                        if (locationTextEl) locationTextEl.textContent = loc.name;
                        if (locationTextElMobile) {
                          locationTextElMobile.textContent = loc.name;
                          locationTextElMobile.style.display = 'inline-block';
                        }
                      }
                      setTimeout(function() {
                        if (typeof updateWidgetDisplay === 'function') {
                          updateWidgetDisplay();
                        }
                      }, 300);
                    }).catch(function() {
                      dropdown.remove();
                    });
                  }
                };
                dropdown.insertBefore(menuItem, dropdown.lastElementChild);
              });
            });
          };
          
          // Store reference for saved address handler
          showStoreSelectionModalRef = showStoreSelectionModal;
          
          // Only set up button handlers if elements exist (not in init-only mode)
          if (addressSearchBtn) {
            addressSearchBtn.onclick = function(e) {
              e.preventDefault();
              e.stopPropagation();
              performSearch();
            };
          }
          
          if (addressInput) {
            addressInput.onkeypress = function(e) {
              if (e.key === 'Enter') {
                e.preventDefault();
                performSearch();
              }
            };
          }
        
        // Add divider if there are locations
        if (locations.length > 0) {
          var divider = document.createElement('div');
          divider.style.cssText = 'height: 1px; background: #e0e0e0; margin: 4px 0;';
          dropdown.appendChild(divider);
        }
        
        // Add each location as a menu item
        locations.forEach(function(loc) {
          var menuItem = document.createElement('div');
          menuItem.className = 'store-dropdown-item';
          menuItem.style.cssText = 'padding: 8px 16px; cursor: pointer; font-size: 13px; color: #293149; white-space: nowrap;';
          menuItem.textContent = loc.name || ('Location ' + loc.id);
          menuItem.onmouseover = function() {
            this.style.backgroundColor = '#f0f8f0';
          };
          menuItem.onmouseout = function() {
            this.style.backgroundColor = 'transparent';
          };
          menuItem.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            var locIdNum = typeof loc.id === 'string' ? parseInt(loc.id, 10) : loc.id;
            if (!isNaN(locIdNum) && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
              inventoryInfo.api.selectLocation(locIdNum).then(function() {
                dropdown.remove();
                // Update header text
                if (loc && loc.name) {
                  if (typeof window.updateHeaderText === 'function') {
                    window.updateHeaderText(loc.name);
                  }
                  // Also update location text elements directly
                  var locationTextEl = document.querySelector('.location-picker-text');
                  var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                  if (locationTextEl) locationTextEl.textContent = loc.name;
                  if (locationTextElMobile) {
                    locationTextElMobile.textContent = loc.name;
                    locationTextElMobile.style.display = 'inline-block';
                  }
                }
                // Update widget display
                setTimeout(function() {
                  updateWidgetDisplay();
                }, 300);
              }).catch(function() {
                dropdown.remove();
              });
            }
          };
          dropdown.appendChild(menuItem);
        });
        };
        
        // Append to body (fixed positioning) or button parent (absolute positioning)
        if (buttonRect) {
          document.body.appendChild(dropdown);
        } else if (buttonElement && buttonElement.parentElement) {
          buttonElement.parentElement.style.position = 'relative';
          buttonElement.parentElement.appendChild(dropdown);
        } else {
          document.body.appendChild(dropdown);
        }
        
        // Close dropdown when clicking outside
        var clickOutsideHandler = function(e) {
          if (!dropdown.contains(e.target) && e.target !== buttonElement && !buttonElement.contains(e.target)) {
            dropdown.remove();
            document.removeEventListener('click', clickOutsideHandler);
            document.removeEventListener('keydown', escapeHandler);
          }
        };
        
        // Close on escape key
        var escapeHandler = function(e) {
          if (e.key === 'Escape') {
            dropdown.remove();
            document.removeEventListener('click', clickOutsideHandler);
            document.removeEventListener('keydown', escapeHandler);
          }
        };
        
        // Add event listeners after a short delay to avoid immediate close
        setTimeout(function() {
          document.addEventListener('click', clickOutsideHandler);
          document.addEventListener('keydown', escapeHandler);
        }, 100);
        
        // Force dropdown to be visible
        setTimeout(function() {
          if (dropdown && dropdown.parentNode) {
            dropdown.style.display = 'block';
            dropdown.style.visibility = 'visible';
            dropdown.style.opacity = '1';
            dropdown.style.pointerEvents = 'auto';
          }
        }, 50);
      }
      
      // Make function globally accessible
      window.showLocationDropdown = showLocationDropdown;
      
      // Global flag to prevent multiple simultaneous calls to updateWidgetDisplay
      window.isUpdatingWidgetDisplay = false;
      
      function updateWidgetDisplay() {
        // Prevent excessive calls
        if (window.isUpdatingWidgetDisplay) {
          return;
        }
        
        // Debounce to prevent rapid successive calls
        if (updateWidgetDisplay.debounceTimer) {
          clearTimeout(updateWidgetDisplay.debounceTimer);
        }
        
        updateWidgetDisplay.debounceTimer = setTimeout(function() {
          updateWidgetDisplay.debounceTimer = null;
          window.isUpdatingWidgetDisplay = true;
          
          // OLD WIDGET DISABLED - Now just trigger custom widget update
          // Trigger custom availability widget to update
          if (window.customAvailabilityWidget && typeof window.customAvailabilityWidget.render === 'function') {
            console.log('[Header Location Selector] Triggering custom widget update');
            window.customAvailabilityWidget.render();
          } else {
            // Widget not ready yet - retry after a short delay
            // This handles the case where header-location-selector.js loads before custom-availability-widget.js
            if (!window._widgetUpdateRetries) {
              window._widgetUpdateRetries = 0;
            }
            if (window._widgetUpdateRetries < 10) {
              window._widgetUpdateRetries++;
              setTimeout(function() {
                updateWidgetDisplay();
              }, 200);
            } else {
              console.warn('[Header Location Selector] Custom widget not available after retries');
              // Try to initialize it manually as a last resort
              if (window.customAvailabilityWidget && typeof window.customAvailabilityWidget.init === 'function') {
                window.customAvailabilityWidget.init();
                setTimeout(function() {
                  if (window.customAvailabilityWidget && typeof window.customAvailabilityWidget.render === 'function') {
                    window.customAvailabilityWidget.render();
                  }
                }, 100);
              }
            }
          }
          
          // Reset flag after a delay
          setTimeout(function() {
            window.isUpdatingWidgetDisplay = false;
          }, 1000);
        }, 300); // Debounce 300ms
        return;
        
        // OLD CODE BELOW - DISABLED
        // Prevent multiple simultaneous calls
        if (window.isUpdatingWidgetDisplay) {
          return;
        }
        
        // Execute immediately - don't queue for widget display updates
        if (!availabilityWidget) {
          availabilityWidget = document.getElementById('inventory-info-app') || 
                               document.querySelector('.iia-container');
        }
        
        if (!availabilityWidget) return;
        
        // Use state manager only to prevent concurrent executions, not to queue
        // But don't block if it's been updating for too long (might be stuck)
        if (StateManager.isUpdating) {
          var updateStartTime = StateManager.updateStartTime || Date.now();
          var timeSinceUpdate = Date.now() - updateStartTime;
          // If stuck for more than 2 seconds, reset and continue
          if (timeSinceUpdate > 2000) {
            StateManager.isUpdating = false;
          } else {
            // If already updating, skip this call to prevent excessive updates
            return;
          }
        }
        
        window.isUpdatingWidgetDisplay = true;
        StateManager.isUpdating = true;
        StateManager.updateStartTime = Date.now();
        try {
          
          // Remove previous mode classes
          availabilityWidget.classList.remove('shipping-mode-shipping', 'shipping-mode-local');
          document.body.classList.remove('shipping-mode-shipping', 'shipping-mode-local');
          
          if (currentMethod === 'shipping') {
            // Shipping: Show only Online Availability and auto-select online warehouse
            availabilityWidget.classList.add('shipping-mode-shipping');
            document.body.classList.add('shipping-mode-shipping');
            
            // Immediately and definitively set header to Online Warehouse
            var onlineLocationLabel = (inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocationLabel) 
                                      ? inventoryInfo.settings.onlineLocationLabel 
                                      : 'Online Warehouse';
            if (typeof window.updateHeaderText === 'function') {
              window.updateHeaderText(onlineLocationLabel);
            }
            
            // Function to hide physical locations and select online (with verification)
            // SIMPLIFIED: Just hide address input and let the app work normally
            function hideAndSelectOnline() {
              // Prevent recursive calls
              if (window.isHidingAndSelectingOnline) {
                return;
              }
              window.isHidingAndSelectingOnline = true;
              
              // Prevent geocoding initialization when in shipping mode
              // Hide the address input to prevent Google Maps Geocoder errors
              // Do this BEFORE the app tries to initialize geocoding
              var addressInput = availabilityWidget.querySelector('#iia-address-input, .iia-address-input');
              if (addressInput) {
                addressInput.style.setProperty('display', 'none', 'important');
                addressInput.style.setProperty('visibility', 'hidden', 'important');
                addressInput.style.setProperty('opacity', '0', 'important');
                addressInput.setAttribute('disabled', 'disabled');
                addressInput.removeAttribute('autocomplete');
                addressInput.removeAttribute('placeholder');
                // Remove event listeners that might trigger geocoding
                var newInput = addressInput.cloneNode(true);
                addressInput.parentNode.replaceChild(newInput, addressInput);
              }
              
              // Hide the geo section that contains the address input
              var geoSection = availabilityWidget.querySelector('.iia-geo');
              if (geoSection) {
                geoSection.style.setProperty('display', 'none', 'important');
                geoSection.style.setProperty('visibility', 'hidden', 'important');
                geoSection.style.setProperty('opacity', '0', 'important');
                geoSection.style.setProperty('height', '0', 'important');
                geoSection.style.setProperty('overflow', 'hidden', 'important');
              }
              
              // Prevent the app from creating the geocoding input
              // Override the app's geo.createInput method temporarily
              if (window.inventoryInfo && window.inventoryInfo.geo && window.inventoryInfo.geo.createInput) {
                var originalCreateInput = window.inventoryInfo.geo.createInput;
                window.inventoryInfo.geo.createInput = function() {
                  // Don't create input when in shipping mode
                  if (currentMethod === 'shipping') {
                    return;
                  }
                  return originalCreateInput.apply(this, arguments);
                };
              }
              
              // Also prevent Google Maps Geocoder initialization more aggressively
              if (window.google && window.google.maps) {
                var originalGeocoder = window.google.maps.Geocoder;
                if (originalGeocoder) {
                  window.google.maps.Geocoder = function() {
                    if (currentMethod === 'shipping') {
                      // Return a mock object to prevent errors
                      return {
                        geocode: function() {},
                        reverseGeocode: function() {}
                      };
                    }
                    return new originalGeocoder();
                  };
                }
              }
              
              // Override google.maps.places.Autocomplete if it exists
              if (window.google && window.google.maps && window.google.maps.places) {
                var originalAutocomplete = window.google.maps.places.Autocomplete;
                if (originalAutocomplete) {
                  window.google.maps.places.Autocomplete = function() {
                    if (currentMethod === 'shipping') {
                      // Return a mock object to prevent errors
                      return {
                        addListener: function() {},
                        getPlace: function() { return {}; },
                        setBounds: function() {},
                        setComponentRestrictions: function() {}
                      };
                    }
                    return new originalAutocomplete.apply(this, arguments);
                  };
                }
              }
              
              // First, ensure widget details container is expanded/visible
              var detailsContainer = availabilityWidget.querySelector('.iia-details-container');
              if (detailsContainer) {
                // Force visibility with !important via style attribute
                detailsContainer.style.setProperty('display', 'block', 'important');
                detailsContainer.style.setProperty('visibility', 'visible', 'important');
                detailsContainer.style.setProperty('opacity', '1', 'important');
                detailsContainer.style.setProperty('max-height', 'none', 'important');
                detailsContainer.style.setProperty('height', 'auto', 'important');
                
                // Also check if there's a collapsible section that needs to be expanded
                var header = availabilityWidget.querySelector('.iia-header-container, .iia-header');
                if (header && header.classList.contains('iia-clickable')) {
                  // Widget might be collapsed - try to expand it
                  var chevron = availabilityWidget.querySelector('.iia-chevron');
                  if (chevron && chevron.classList.contains('iia-chevron-down')) {
                    // Widget is collapsed, click to expand
                    setTimeout(function() {
                      try {
                        header.click();
                      } catch(e) {}
                    }, 100);
                  }
                }
              }
              
              // Hide physical locations
              hidePhysicalLocations();
              
              // Wait a bit for widget to expand and items to be processed, then select online
              setTimeout(function() {
                selectOnlineWarehouse();
                
                // Ensure header stays as Online Warehouse
                if (typeof window.updateHeaderText === 'function') {
                  window.updateHeaderText(onlineLocationLabel);
                }
                
                // Also ensure any online availability text/elements are visible
                var allOnlineElements = availabilityWidget.querySelectorAll('*');
                for (var i = 0; i < allOnlineElements.length; i++) {
                  var el = allOnlineElements[i];
                  var elText = el.textContent.toLowerCase();
                  if (elText.indexOf('online availability') !== -1 || 
                      elText.indexOf('online warehouse') !== -1 ||
                      (onlineLocationLabel && elText.indexOf(onlineLocationLabel.toLowerCase()) !== -1)) {
                    // Found online availability text - ensure it and its parents are visible
                    el.style.setProperty('display', 'block', 'important');
                    el.style.setProperty('visibility', 'visible', 'important');
                    el.style.setProperty('opacity', '1', 'important');
                    
                    var parent = el.parentElement;
                    while (parent && parent !== availabilityWidget) {
                      parent.style.setProperty('display', 'block', 'important');
                      parent.style.setProperty('visibility', 'visible', 'important');
                      parent.style.setProperty('opacity', '1', 'important');
                      parent = parent.parentElement;
                    }
                  }
                }
                
                // Reset flag after processing
                setTimeout(function() {
                  window.isHidingAndSelectingOnline = false;
                }, 1000);
                
                // Verify selection worked after a delay
                setTimeout(function() {
                  if (currentMethod === 'shipping') {
                    var widget = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
                    if (widget) {
                      var checkedRadio = widget.querySelector('input[type="radio"]:checked');
                      if (checkedRadio) {
                        var checkedItem = checkedRadio.closest('.iia-list-item');
                        if (checkedItem) {
                          var itemText = checkedItem.textContent.toLowerCase();
                          var isOnline = itemText.indexOf('online') !== -1 ||
                                         itemText.indexOf('warehouse') !== -1 ||
                                         itemText.indexOf(onlineLocationLabel.toLowerCase()) !== -1;
                          if (!isOnline) {
                            // Selection didn't work, try again (but don't loop)
                            if (!window.isHidingAndSelectingOnline) {
                              selectOnlineWarehouse();
                            }
                          } else {
                            // Found online item, ensure it's visible with !important
                            checkedItem.style.setProperty('display', 'flex', 'important');
                            checkedItem.style.setProperty('visibility', 'visible', 'important');
                            checkedItem.style.setProperty('opacity', '1', 'important');
                          }
                        }
                      } else {
                        // No radio selected - might mean online availability doesn't use a radio
                        // Check if there's online availability shown as text/inventory display
                        var onlineText = widget.textContent.toLowerCase();
                        if (onlineText.indexOf('online availability') !== -1 || 
                            onlineText.indexOf('online warehouse') !== -1) {
                          // Online availability is shown, just not as a selectable item
                          // This is fine - the app might show it differently
                          console.log('[Widget Display] Online availability detected but not as selectable item');
                        } else {
                          // Try again to select online (but don't loop)
                          if (!window.isHidingAndSelectingOnline) {
                            selectOnlineWarehouse();
                          }
                        }
                      }
                    }
                  }
                }, 1000);
              }, 300);
            }
            
            // TEMPORARILY DISABLED: Let the app initialize the widget first
            // We'll only intervene after the app has had time to populate it
            
            // Disconnect any existing observer to let the app work freely
            if (window.shippingModeObserver) {
              window.shippingModeObserver.disconnect();
              window.shippingModeObserver = null;
            }
            
            // Only prevent geocoding initialization - let everything else work normally
            // Override the app's geo.createInput method to prevent geocoding
            if (window.inventoryInfo && window.inventoryInfo.geo && window.inventoryInfo.geo.createInput) {
              var originalCreateInput = window.inventoryInfo.geo.createInput;
              window.inventoryInfo.geo.createInput = function() {
                // Don't create input when in shipping mode
                if (currentMethod === 'shipping') {
                  return;
                }
                return originalCreateInput.apply(this, arguments);
              };
            }
            
            // Wait for the app to fully initialize, then intervene
            // Give it plenty of time (3 seconds) to populate the widget
            setTimeout(function() {
              if (currentMethod === 'shipping') {
                // Now hide the address input and geo section
                var addressInput = availabilityWidget.querySelector('#iia-address-input, .iia-address-input');
                if (addressInput) {
                  addressInput.style.setProperty('display', 'none', 'important');
                  addressInput.style.setProperty('visibility', 'hidden', 'important');
                  addressInput.style.setProperty('opacity', '0', 'important');
                  addressInput.setAttribute('disabled', 'disabled');
                }
                
                var geoSection = availabilityWidget.querySelector('.iia-geo');
                if (geoSection) {
                  geoSection.style.setProperty('display', 'none', 'important');
                  geoSection.style.setProperty('visibility', 'hidden', 'important');
                  geoSection.style.setProperty('opacity', '0', 'important');
                  geoSection.style.setProperty('height', '0', 'important');
                  geoSection.style.setProperty('overflow', 'hidden', 'important');
                }
                
                // Now try to hide physical locations and show online
                hidePhysicalLocations();
                selectOnlineWarehouse();
              }
            }, 3000);
            
            // Also try after even more time to ensure widget is fully loaded
            setTimeout(function() {
              if (currentMethod === 'shipping') {
                hidePhysicalLocations();
                selectOnlineWarehouse();
              }
            }, 5000);
          } else {
            // Stop observing when not in shipping mode
            if (window.shippingModeObserver) {
              window.shippingModeObserver.disconnect();
            }
            // Local Delivery or Pickup: Show all locations
            availabilityWidget.classList.add('shipping-mode-local');
            document.body.classList.add('shipping-mode-local');
            // OLD WIDGET DISABLED - showAllLocations() call removed
            // showAllLocations();
            // availabilityWidget.style.display = 'block';
            // availabilityWidget.style.visibility = 'visible';
            // availabilityWidget.style.opacity = '1';
            
            // Force selection if we have a forced location ID (due to 422 error handling)
            if (window.forcedLocationId) {
              try {
                // Find the radio button for this location
                var forcedRadio = availabilityWidget.querySelector('input[value="' + window.forcedLocationId + '"]');
                if (forcedRadio) {
                  forcedRadio.checked = true;
                  // Also try to check it visually by finding parent
                  var parentItem = forcedRadio.closest('.iia-list-item');
                  if (parentItem) {
                    // Remove selected class from others
                    var allItems = availabilityWidget.querySelectorAll('.iia-list-item');
                    allItems.forEach(function(itm) {
                      itm.classList.remove('iia-selected-location');
                    });
                    parentItem.classList.add('iia-selected-location');
                  }
                }
              } catch(e) {
                console.warn('Error applying forced selection:', e);
              }
            }
            
            // Don't automatically show dropdown here - let button click handler do it
          }
        } catch(e) {
          // Silently handle errors
        } finally {
          StateManager.isUpdating = false;
          StateManager.updateStartTime = null;
          window.isUpdatingWidgetDisplay = false;
          // Safety timeout to always reset after 3 seconds
          setTimeout(function() {
            StateManager.isUpdating = false;
            StateManager.updateStartTime = null;
            window.isUpdatingWidgetDisplay = false;
          }, 3000);
        }
      }
      
      // Centralized header update function - prevents toggling
      // Make it globally accessible
      window.updateHeaderText = function(locationName) {
        // Check if we're in shipping mode - if so, always use Online Warehouse
        var shippingModeActive = document.body.classList.contains('shipping-mode-shipping') ||
                               window.currentMethod === 'shipping';
        if (shippingModeActive) {
          var onlineLocationLabel = (inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocationLabel) 
                                    ? inventoryInfo.settings.onlineLocationLabel 
                                    : 'Online Warehouse';
          locationName = onlineLocationLabel;
        }
        
        if (!locationName) return;
        var locationTextEl = document.querySelector('.location-picker-text');
        var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
        if (locationTextEl && locationTextEl.textContent !== locationName) {
          locationTextEl.textContent = locationName;
        }
        if (locationTextElMobile && locationTextElMobile.textContent !== locationName) {
          locationTextElMobile.textContent = locationName;
          locationTextElMobile.style.display = 'inline-block';
        }
      };
      
      function selectOnlineWarehouse() {
        // OLD WIDGET DISABLED - No-op function
        return;
        
        // OLD CODE BELOW - DISABLED
        // Use StateManager to prevent concurrent executions
        StateManager.queueUpdate(function() {
          if (!availabilityWidget) {
            availabilityWidget = document.getElementById('inventory-info-app') || 
                                 document.querySelector('.iia-container');
          }
          
          if (!availabilityWidget) {
            StateManager.debounce('retrySelect', selectOnlineWarehouse, 500);
            return;
          }
          
          try {
            // Step 1: Try to get online location ID from app settings first
            var onlineLocationId = null;
            if (inventoryInfo && inventoryInfo.settings) {
              // Check if onlineLocation is an ID (could be number, string, or true)
              if (inventoryInfo.settings.onlineLocation) {
                if (typeof inventoryInfo.settings.onlineLocation === 'number') {
                  onlineLocationId = inventoryInfo.settings.onlineLocation;
                } else if (typeof inventoryInfo.settings.onlineLocation === 'string') {
                  // Try to parse as number
                  var parsed = parseInt(inventoryInfo.settings.onlineLocation, 10);
                  if (!isNaN(parsed)) {
                    onlineLocationId = parsed;
                  }
                }
              }
              
              // Also check locationSettings for online location
              if (!onlineLocationId && inventoryInfo.locationSettings) {
                if (inventoryInfo.locationSettings.details && Array.isArray(inventoryInfo.locationSettings.details)) {
                  for (var i = 0; i < inventoryInfo.locationSettings.details.length; i++) {
                    var detail = inventoryInfo.locationSettings.details[i];
                    if (detail && (detail.online === true || detail.isOnline === true || detail.type === 'online')) {
                      onlineLocationId = detail.id;
                      break;
                    }
                  }
                }
                if (!onlineLocationId && inventoryInfo.locationSettings.locations && Array.isArray(inventoryInfo.locationSettings.locations)) {
                  for (var j = 0; j < inventoryInfo.locationSettings.locations.length; j++) {
                    var loc = inventoryInfo.locationSettings.locations[j];
                    if (loc && (loc.online === true || loc.isOnline === true || loc.type === 'online')) {
                      onlineLocationId = loc.id;
                      break;
                    }
                  }
                }
              }
            }
            
            var onlineLocationLabel = (inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocationLabel) 
                                      ? inventoryInfo.settings.onlineLocationLabel.toLowerCase() 
                                      : 'online warehouse';
            var listItems = availabilityWidget.querySelectorAll('.iia-list-item');
            var onlineItem = null;
            var radio = null;
            
            // Step 2: Find the online location item in the DOM
            listItems.forEach(function(item) {
              var itemText = item.textContent.toLowerCase();
              var locationText = null;
              try {
                var loc1 = item.querySelector('.iia-location');
                var loc2 = item.querySelector('.iia-title-text');
                var loc3 = item.querySelector('.iia-title');
                var loc4 = item.querySelector('.iia-location-name');
                var loc5 = item.querySelector('[class*="location"]');
                locationText = loc1 || loc2 || loc3 || loc4 || loc5;
              } catch(e) {
                locationText = null;
              }
              var locationTextContent = locationText ? locationText.textContent.toLowerCase() : '';
              
              // Check if this is the online location
              var isOnline = false;
              if (itemText && (itemText.indexOf('online') !== -1 || itemText.indexOf('warehouse') !== -1)) {
                isOnline = true;
              }
              if (!isOnline && onlineLocationLabel && itemText && itemText.indexOf(onlineLocationLabel) !== -1) {
                isOnline = true;
              }
              if (!isOnline && itemText && itemText.indexOf('online availability') !== -1) {
                isOnline = true;
              }
              if (!isOnline && locationTextContent) {
                if (locationTextContent.indexOf('online') !== -1 || locationTextContent.indexOf('warehouse') !== -1) {
                  isOnline = true;
                } else if (onlineLocationLabel && locationTextContent.indexOf(onlineLocationLabel) !== -1) {
                  isOnline = true;
                }
              }
              if (!isOnline && item.classList.contains('iia-online')) {
                isOnline = true;
              }
              if (!isOnline && item.hasAttribute('data-online-location')) {
                isOnline = true;
              }
              
              if (isOnline && !onlineItem) {
                onlineItem = item;
                radio = item.querySelector('input[type="radio"]');
              }
              
              // If we don't have location ID yet, try to get it from the item
              if (!onlineLocationId && onlineItem) {
                // Try various data attributes
                onlineLocationId = item.getAttribute('data-location-id') || 
                                 item.getAttribute('data-id') ||
                                 item.getAttribute('data-location') ||
                                 item.getAttribute('data-locationid');
                
                // Try child elements
                var idElement = item.querySelector('[data-location-id], [data-id], [data-location], [data-locationid]');
                if (idElement && !onlineLocationId) {
                  onlineLocationId = idElement.getAttribute('data-location-id') || 
                                    idElement.getAttribute('data-id') ||
                                    idElement.getAttribute('data-location') ||
                                    idElement.getAttribute('data-locationid');
                }
                
                // Also try to get from radio button value or name
                if (radio) {
                  if (radio.value && !onlineLocationId) {
                    var radioVal = parseInt(radio.value, 10);
                    if (!isNaN(radioVal)) {
                      onlineLocationId = radioVal;
                    }
                  }
                  if (radio.name && !onlineLocationId) {
                    // Sometimes the name contains the ID
                    var nameMatch = radio.name.match(/(\d+)/);
                    if (nameMatch) {
                      onlineLocationId = parseInt(nameMatch[1], 10);
                    }
                  }
                }
              }
            });
            
            // Step 3: Select the online location
            if (onlineItem && radio) {
              // Method 1: Use API if we have location ID (most reliable)
              if (onlineLocationId && inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                // Convert to number if it's a string
                var locationIdNum = typeof onlineLocationId === 'string' ? parseInt(onlineLocationId, 10) : onlineLocationId;
                if (!isNaN(locationIdNum)) {
                  // Call API immediately and with delays
                  try {
                    if (inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                      inventoryInfo.api.selectLocation(locationIdNum);
                    }
                  } catch(e) {}
                  
                  // Also try with delays to ensure it sticks
                  setTimeout(function() {
                    try {
                      if (inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                        inventoryInfo.api.selectLocation(locationIdNum);
                      }
                    } catch(e) {}
                  }, 200);
                  setTimeout(function() {
                    try {
                      if (inventoryInfo && inventoryInfo.api && inventoryInfo.api.selectLocation) {
                        inventoryInfo.api.selectLocation(locationIdNum);
                      }
                    } catch(e) {}
                  }, 1000);
                }
              }
              
              // Method 2: Click the radio button (fallback/backup)
              // Use a more reliable approach - check if already selected first
              if (!radio.checked) {
                // Uncheck all other radios first
                var allRadios = availabilityWidget.querySelectorAll('input[type="radio"]');
                allRadios.forEach(function(r) {
                  if (r !== radio) {
                    r.checked = false;
                    r.removeAttribute('checked');
                  }
                });
                
                // Set this radio as checked
                radio.checked = true;
                radio.setAttribute('checked', 'checked');
                
                // Create proper events
                var changeEvent = new Event('change', { bubbles: true, cancelable: true });
                var inputEvent = new Event('input', { bubbles: true, cancelable: true });
                var clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
                
                // Dispatch events immediately
                try {
                  radio.dispatchEvent(inputEvent);
                  radio.dispatchEvent(changeEvent);
                  radio.dispatchEvent(clickEvent);
                  radio.click();
                } catch(e) {}
                
                // Also try with delays
                setTimeout(function() {
                  try {
                    radio.dispatchEvent(changeEvent);
                    radio.click();
                  } catch(e) {}
                }, 100);
                
                // Also try clicking the label or parent
                setTimeout(function() {
                  try {
                    var label = onlineItem.querySelector('label');
                    if (label) {
                      label.click();
                    } else {
                      onlineItem.click();
                    }
                  } catch(e) {}
                }, 150);
              } else {
                // Already checked, but verify it's still checked after a moment
                setTimeout(function() {
                  if (!radio.checked && currentMethod === 'shipping') {
                    radio.checked = true;
                    radio.setAttribute('checked', 'checked');
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }, 500);
              }
              
              // Verify selection worked
              setTimeout(function() {
                if (currentMethod === 'shipping' && radio && !radio.checked) {
                  // Selection didn't stick, try again
                  radio.checked = true;
                  radio.setAttribute('checked', 'checked');
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                  radio.click();
                }
              }, 800);
            } else if (!onlineItem) {
              // If not found, retry with debouncing
              StateManager.debounce('retrySelect', selectOnlineWarehouse, 500);
            }
          } catch(e) {
            // Silently fail
          }
        }, 'normal');
      }
      
      // Global flag to prevent multiple simultaneous calls
      window.isHidingPhysicalLocations = false;
      
      function hidePhysicalLocations() {
        // OLD WIDGET DISABLED - No-op function
        return;
        
        // OLD CODE BELOW - DISABLED
        // Prevent multiple simultaneous calls
        if (window.isHidingPhysicalLocations) {
          return;
        }
        window.isHidingPhysicalLocations = true;
        
        try {
          if (!availabilityWidget) {
            window.isHidingPhysicalLocations = false;
            return;
          }
          var listItems = availabilityWidget.querySelectorAll('.iia-list-item');
          var onlineLocationLabel = 'online warehouse';
          if (inventoryInfo && inventoryInfo.settings && inventoryInfo.settings.onlineLocationLabel) {
            onlineLocationLabel = inventoryInfo.settings.onlineLocationLabel.toLowerCase();
          }
          var foundOnlineItem = null;
          var foundLocationId = null;
          
          // Try to get online location ID from settings first
          if (inventoryInfo && inventoryInfo.settings) {
            var settings = inventoryInfo.settings;
            if (settings.onlineLocation) {
              var onlineLoc = settings.onlineLocation;
              var isNumber = typeof onlineLoc === 'number';
              var isString = typeof onlineLoc === 'string';
              var isValidString = isString && onlineLoc !== 'true';
              if (isNumber || isValidString) {
                foundLocationId = onlineLoc;
              }
            }
          }
          
          // Also check for "Online Availability" text which the app might use
          var allText = '';
          var hasOnlineAvailability = false;
          if (availabilityWidget && availabilityWidget.textContent) {
            allText = availabilityWidget.textContent.toLowerCase();
            if (allText.indexOf('online availability') !== -1) {
              hasOnlineAvailability = true;
            } else if (onlineLocationLabel && allText.indexOf(onlineLocationLabel) !== -1) {
              hasOnlineAvailability = true;
            }
          }
          
          listItems.forEach(function(item) {
            // Get all possible text from the item
            var itemText = item.textContent.toLowerCase();
            var locationText = null;
            try {
              var loc1 = item.querySelector('.iia-location');
              var loc2 = item.querySelector('.iia-title-text');
              var loc3 = item.querySelector('.iia-title');
              var loc4 = item.querySelector('.iia-location-name');
              locationText = loc1 || loc2 || loc3 || loc4;
            } catch(e) {
              locationText = null;
            }
            var locationTextContent = locationText ? locationText.textContent.toLowerCase() : '';
            var addressText = item.querySelector('.iia-address');
            var addressContent = addressText ? addressText.textContent.toLowerCase() : '';
            
            // Try to get location ID from data attributes
            var itemLocationId = item.getAttribute('data-location-id') || 
                                item.getAttribute('data-id');
            var locationIdElement = null;
            try {
              locationIdElement = item.querySelector('[data-location-id]') || null;
            } catch(e) {
              locationIdElement = null;
            }
            if (locationIdElement && !itemLocationId) {
              itemLocationId = locationIdElement.getAttribute('data-location-id');
            }
            
            // More comprehensive check for online location
            var isOnline = false;
            if (itemText) {
              if (itemText.indexOf('online') !== -1 || itemText.indexOf('warehouse') !== -1 || itemText.indexOf('online availability') !== -1) {
                isOnline = true;
              } else if (onlineLocationLabel && itemText.indexOf(onlineLocationLabel) !== -1) {
                isOnline = true;
              }
            }
            if (!isOnline && locationTextContent) {
              if (locationTextContent.indexOf('online') !== -1 || locationTextContent.indexOf('warehouse') !== -1) {
                isOnline = true;
              } else if (onlineLocationLabel && locationTextContent.indexOf(onlineLocationLabel) !== -1) {
                isOnline = true;
              }
            }
            if (!isOnline && addressContent && addressContent.indexOf('online') !== -1) {
              isOnline = true;
            }
            if (!isOnline && item.classList.contains('iia-online')) {
              isOnline = true;
            }
            if (!isOnline && item.hasAttribute('data-online-location')) {
              isOnline = true;
            }
            if (!isOnline && item.querySelector('[class*="online"]')) {
              isOnline = true;
            }
            if (!isOnline && item.querySelector('[data-online-location]')) {
              isOnline = true;
            }
            if (!isOnline && itemLocationId && foundLocationId && String(itemLocationId) === String(foundLocationId)) {
              isOnline = true;
            }
            
            if (isOnline) {
              // If we found a location ID from the DOM, use it
              if (itemLocationId && !foundLocationId) {
                foundLocationId = itemLocationId;
                // Try API selection with this ID
                if (inventoryInfo.api && inventoryInfo.api.selectLocation) {
                  setTimeout(function() {
                    try {
                      inventoryInfo.api.selectLocation(itemLocationId);
                    } catch(e) {}
                  }, 100);
                }
              }
              item.style.setProperty('display', 'flex', 'important');
              item.style.setProperty('visibility', 'visible', 'important');
              item.style.setProperty('opacity', '1', 'important');
              foundOnlineItem = item;
              
              // Immediately try to select it - multiple methods
              var radio = item.querySelector('input[type="radio"]');
              if (radio) {
                // Force selection
                radio.checked = true;
                radio.setAttribute('checked', 'checked');
                
                // Trigger all possible events
                var events = ['change', 'click', 'input', 'mousedown', 'mouseup'];
                events.forEach(function(eventType) {
                  try {
                    radio.dispatchEvent(new Event(eventType, { bubbles: true, cancelable: true }));
                  } catch(e) {}
                });
                
                // Direct click
                try {
                  radio.click();
                } catch(e) {}
                
                // Also try clicking the parent item
                try {
                  item.click();
                } catch(e) {}
              }
            } else {
              // Hide physical locations
              item.style.setProperty('display', 'none', 'important');
              item.style.setProperty('visibility', 'hidden', 'important');
              item.style.setProperty('opacity', '0', 'important');
            }
          });
          
          // If we found the online item, ensure it's selected with multiple retries
          if (foundOnlineItem) {
            var retryCount = 0;
            var maxRetries = 5;
            function ensureSelected() {
              retryCount++;
              var radio = foundOnlineItem.querySelector('input[type="radio"]');
              if (radio) {
                if (!radio.checked) {
                  radio.checked = true;
                  radio.setAttribute('checked', 'checked');
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                  radio.dispatchEvent(new Event('click', { bubbles: true }));
                  radio.click();
                }
                if (retryCount < maxRetries) {
                  setTimeout(ensureSelected, 200);
                }
              }
            }
            setTimeout(ensureSelected, 50);
            setTimeout(ensureSelected, 200);
            setTimeout(ensureSelected, 500);
          } else {
            // No online item found in list items - the app might render "Online Availability" differently
            // The app's "Online Availability" feature might show aggregated inventory without a location item
            // OR it might be rendered as a special section that's not a .iia-list-item
            
            console.log('[Widget Display] No online item found in list items, showing all locations as aggregated inventory');
            
            // FALLBACK: If no online item is found, show ALL locations
            // This is because "Online Availability" might be aggregating from all locations
            // So showing all locations gives the user the total available inventory
            
            // Ensure main widget container is visible
            if (availabilityWidget) {
              availabilityWidget.style.setProperty('display', 'block', 'important');
              availabilityWidget.style.setProperty('visibility', 'visible', 'important');
              availabilityWidget.style.setProperty('opacity', '1', 'important');
              
              // Also ensure inner containers are visible
              var innerContainers = availabilityWidget.querySelectorAll('.iia-geo-list, .iia-details-container, .iia-locations-container');
              innerContainers.forEach(function(cnt) {
                cnt.style.setProperty('display', 'block', 'important');
                cnt.style.setProperty('visibility', 'visible', 'important');
                cnt.style.setProperty('opacity', '1', 'important');
                cnt.style.setProperty('height', 'auto', 'important');
                cnt.style.setProperty('max-height', 'none', 'important');
              });
            }

            listItems.forEach(function(item) {
              item.style.setProperty('display', 'flex', 'important');
              item.style.setProperty('visibility', 'visible', 'important');
              item.style.setProperty('opacity', '1', 'important');
            });
            
            // Method 1: Check if there's a special online availability section or text
            var onlineSection = availabilityWidget.querySelector('[class*="online"], [id*="online"], [data-online], [class*="availability"]');
            if (onlineSection) {
              onlineSection.style.setProperty('display', 'block', 'important');
              onlineSection.style.setProperty('visibility', 'visible', 'important');
              onlineSection.style.setProperty('opacity', '1', 'important');
            }
            
            // Method 2: Check if online availability is shown as text/div outside list items
            var allElements = availabilityWidget.querySelectorAll('div, span, p');
            for (var i = 0; i < allElements.length; i++) {
              var el = allElements[i];
              var elText = el.textContent.toLowerCase();
              if (elText.indexOf('online availability') !== -1 || 
                  elText.indexOf('online warehouse') !== -1 ||
                  (onlineLocationLabel && elText.indexOf(onlineLocationLabel) !== -1)) {
                // Found online availability text - ensure it's visible
                el.style.setProperty('display', 'block', 'important');
                el.style.setProperty('visibility', 'visible', 'important');
                el.style.setProperty('opacity', '1', 'important');
                
                // Also show parent containers
                var parent = el.parentElement;
                while (parent && parent !== availabilityWidget) {
                  parent.style.setProperty('display', 'block', 'important');
                  parent.style.setProperty('visibility', 'visible', 'important');
                  parent.style.setProperty('opacity', '1', 'important');
                  parent = parent.parentElement;
                }
              }
            }
            
            // Method 3: Try to select online location via API to trigger app's display
            if (inventoryInfo && inventoryInfo.api) {
              // Try to get online location ID from settings
              var onlineId = null;
              if (inventoryInfo.settings && inventoryInfo.settings.onlineLocation) {
                onlineId = inventoryInfo.settings.onlineLocation;
                if (typeof onlineId === 'string' && onlineId !== 'true') {
                  onlineId = parseInt(onlineId, 10);
                } else if (onlineId === 'true' || onlineId === true) {
                  // If onlineLocation is true, the app might use a special ID or method
                  // Try to find it in locationSettings
                  if (inventoryInfo.locationSettings && inventoryInfo.locationSettings.details) {
                    for (var k = 0; k < inventoryInfo.locationSettings.details.length; k++) {
                      var detail = inventoryInfo.locationSettings.details[k];
                      if (detail && (detail.online === true || detail.isOnline === true || detail.type === 'online')) {
                        onlineId = detail.id;
                        break;
                      }
                    }
                  }
                }
              }
              
              // Also check locationSettings for online location
              if (!onlineId && inventoryInfo.locationSettings) {
                if (inventoryInfo.locationSettings.details && Array.isArray(inventoryInfo.locationSettings.details)) {
                  for (var m = 0; m < inventoryInfo.locationSettings.details.length; m++) {
                    var locDetail = inventoryInfo.locationSettings.details[m];
                    if (locDetail && (locDetail.online === true || locDetail.isOnline === true || locDetail.type === 'online')) {
                      onlineId = locDetail.id;
                      break;
                    }
                  }
                }
              }
              
              if (onlineId && !isNaN(onlineId) && inventoryInfo.api.selectLocation) {
                // Try once with a delay to ensure it works (removed multiple calls to prevent excessive updates)
                // Temporarily set flag to prevent cart updates during this selection
                var wasSwitching = window.isSwitchingToShipping;
                window.isSwitchingToShipping = true;
                setTimeout(function() {
                  try {
                    inventoryInfo.api.selectLocation(onlineId);
                    // Reset flag after a short delay
                    setTimeout(function() {
                      window.isSwitchingToShipping = wasSwitching;
                    }, 500);
                  } catch(e) {
                    window.isSwitchingToShipping = wasSwitching;
                  }
                }, 200);
              } else if (inventoryInfo.api.showOnlineAvailability) {
                // If the app has a specific method to show online availability
                try {
                  inventoryInfo.api.showOnlineAvailability();
                } catch(e) {}
              }
            }
            
            // Reset flag after processing
            setTimeout(function() {
              window.isHidingPhysicalLocations = false;
            }, 500);
            
            // Method 4: If the app uses "Online Availability" as a feature (not a location),
            // check if there's a way to enable it via settings or API
            if (inventoryInfo && inventoryInfo.settings) {
              // Check if "showOnlineAvailability" setting exists and is enabled
              if (inventoryInfo.settings.showOnlineAvailability !== false) {
                // The app should show online availability - try to trigger it
                // Wait for widget to render and check again
                setTimeout(function() {
                  var listItems = availabilityWidget.querySelectorAll('.iia-list-item');
                  var foundOnline = false;
                  listItems.forEach(function(item) {
                    var itemText = item.textContent.toLowerCase();
                    if (itemText.indexOf('online') !== -1 || itemText.indexOf('warehouse') !== -1 || 
                        itemText.indexOf('availability') !== -1) {
                      foundOnline = true;
                      item.style.setProperty('display', 'flex', 'important');
                      item.style.setProperty('visibility', 'visible', 'important');
                      item.style.setProperty('opacity', '1', 'important');
                    }
                  });
                  
                  if (!foundOnline && listItems.length === 0) {
                    // No items at all - the app might be rendering online availability differently
                    // Check if there's inventory text or quantity display
                    var inventoryText = availabilityWidget.textContent.toLowerCase();
                    if (inventoryText.indexOf('available') !== -1 || inventoryText.match(/\d+\s*(available|in stock)/i)) {
                      // There's inventory info - ensure the widget is visible
                      availabilityWidget.style.setProperty('display', 'block', 'important');
                      availabilityWidget.style.setProperty('visibility', 'visible', 'important');
                      availabilityWidget.style.setProperty('opacity', '1', 'important');
                    }
                  }
                }, 2000);
              }
            }
            
            // Method 4: If the app uses "Online Availability" as a feature (not a location),
            // we might need to ensure the widget shows aggregated inventory
            // Check if there's inventory quantity text that represents online availability
            var qtyElements = availabilityWidget.querySelectorAll('[class*="qty"], [class*="quantity"], [class*="available"]');
            for (var j = 0; j < qtyElements.length; j++) {
              var qtyEl = qtyElements[j];
              var qtyText = qtyEl.textContent.toLowerCase();
              // If this quantity element is visible and shows inventory, ensure its parent is visible
              if (qtyText.indexOf('available') !== -1 || qtyText.match(/\d+/)) {
                var qtyParent = qtyEl.closest('.iia-list-item, .iia-location-info, div');
                if (qtyParent && qtyParent.textContent.toLowerCase().indexOf('online') === -1) {
                  // This might be online availability shown differently - check parent structure
                  var grandParent = qtyParent.parentElement;
                  if (grandParent && grandParent.textContent.toLowerCase().indexOf('online') !== -1) {
                    grandParent.style.display = 'block';
                    grandParent.style.visibility = 'visible';
                    grandParent.style.opacity = '1';
                  }
                }
              }
            }
          }
        } catch(e) {
          console.error('hidePhysicalLocations error:', e);
        }
      }
      
      function showAllLocations() {
        // OLD WIDGET DISABLED - No-op function
        return;
        
        // OLD CODE BELOW - DISABLED
        if (!availabilityWidget) return;
        var listItems = availabilityWidget.querySelectorAll('.iia-list-item');
        listItems.forEach(function(item) {
          item.style.display = 'flex';
          item.style.visibility = 'visible';
          item.style.opacity = '1';
        });
      }
      
      function ensureLocationSelected() {
        if (inventoryInfo && inventoryInfo.api) {
          try {
            if (inventoryInfo.api.getSelectedLocationId) {
              var locId = inventoryInfo.api.getSelectedLocationId();
              if (locId && typeof locId.then === 'function') {
                locId.then(function(id) {
                  if (!id && inventoryInfo.api.showLocationPicker) {
                    setTimeout(function() {
                      inventoryInfo.api.showLocationPicker();
                    }, 500);
                  }
                }).catch(function() {});
              } else if (!locId && inventoryInfo.api.showLocationPicker) {
                setTimeout(function() {
                  inventoryInfo.api.showLocationPicker();
                }, 500);
              }
            }
          } catch(e) {}
        }
      }
      
      var lastSavedMethod = null;
      var savePreferenceTimeout = null;
      function savePreference() {
        // Throttle storage access to prevent tracking prevention errors
        if (savePreferenceTimeout) {
          clearTimeout(savePreferenceTimeout);
        }
        
        // Only save if method actually changed
        if (lastSavedMethod === currentMethod) {
          return;
        }
        
        savePreferenceTimeout = setTimeout(function() {
          // Use StorageManager to prevent repeated access attempts
          var StorageManager = window.StorageManager || {};
          if (StorageManager.setLocalStorage) {
            StorageManager.setLocalStorage('shippingMethod', currentMethod);
          }
          if (StorageManager.setSessionStorage) {
            StorageManager.setSessionStorage('shippingMethod', currentMethod);
          }
          lastSavedMethod = currentMethod;
          
          var event = new CustomEvent('shippingMethodChanged', {
            detail: { method: currentMethod }
          });
          document.dispatchEvent(event);
          updateCartAttributes();
        }, 500); // Delay to reduce frequency
      }
      
      function updateCartAttributes() {
        try {
          // Don't update cart if we're switching to shipping or already in shipping mode (prevents excessive updates)
          if (isSwitchingToShipping || window.isSwitchingToShipping || currentMethod === 'shipping') {
            return;
          }
          
          if (typeof fetch !== 'undefined') {
            var fulfillmentType = currentMethod === 'shipping' ? 'ship' : 
                                 (currentMethod === 'local_delivery' ? 'delivery' : 'pickup');
            
            var attributes = {
              '_shipping_method': currentMethod,
              '_preferred_fulfillment': fulfillmentType
            };
            
            // Add location info if physical location is selected
            if (currentMethod !== 'shipping' && window.inventoryInfo && window.inventoryInfo.api) {
              var locPromise = window.inventoryInfo.api.getSelectedLocation();
              if (locPromise && typeof locPromise.then === 'function') {
                // Location API returns a promise, handle it asynchronously
                locPromise.then(function(loc) {
                  if (loc && loc.id) {
                    attributes['_selected_location_id'] = String(loc.id);
                    attributes['_selected_location_name'] = loc.name || '';
                    
                    fetch('/cart/update.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ attributes: attributes })
                    }).catch(function(err) {
                      console.warn('[Cart] Failed to update cart with location:', err);
                    });
                  } else {
                    // No location selected, still update with method
                    fetch('/cart/update.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ attributes: attributes })
                    }).catch(function() {});
                  }
                }).catch(function(err) {
                  console.warn('[Cart] Error getting selected location:', err);
                  // Fallback: update cart without location info
                  fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: attributes })
                  }).catch(function() {});
                });
                return; // Exit early, will update after promise resolves
              } else {
                // Synchronous location ID (if API returns directly)
                var locId = window.inventoryInfo.api.getSelectedLocationId ? 
                           window.inventoryInfo.api.getSelectedLocationId() : null;
                if (locId) {
                  attributes['_selected_location_id'] = String(locId);
                  // Try to get location name
                  if (window.inventoryInfo.locationSettings && window.inventoryInfo.locationSettings.locations) {
                    var locations = window.inventoryInfo.locationSettings.locations;
                    for (var i = 0; i < locations.length; i++) {
                      if (locations[i].id == locId || String(locations[i].id) === String(locId)) {
                        attributes['_selected_location_name'] = locations[i].name || '';
                        break;
                      }
                    }
                  }
                }
              }
            } else if (currentMethod === 'shipping') {
              // Clear location info when switching to shipping
              attributes['_selected_location_id'] = '';
              attributes['_selected_location_name'] = '';
            }
            
            // Update cart immediately
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: attributes })
            }).catch(function(err) {
              console.warn('[Cart] Failed to update cart attributes:', err);
            });
          }
        } catch(e) {
          console.warn('[Cart] Error updating cart attributes:', e);
        }
      }
      
      // Listen for location changes
      if (inventoryInfo && inventoryInfo.api) {
        document.addEventListener('locationChanged', function() {
          // Don't update if switching to shipping or already in shipping mode
          if (currentMethod !== 'shipping' && !isSwitchingToShipping && !window.isSwitchingToShipping) {
            updateWidgetDisplay();
            // Update cart attributes with new location
            setTimeout(updateCartAttributes, 300);
          }
        });
        document.addEventListener('locationSelected', function() {
          // Don't update if switching to shipping or already in shipping mode
          if (currentMethod !== 'shipping' && !isSwitchingToShipping && !window.isSwitchingToShipping) {
            updateWidgetDisplay();
            // Update cart attributes with new location
            setTimeout(updateCartAttributes, 300);
          }
        });
        document.addEventListener('inventoryInfo:locationChanged', function() {
          // Don't update if switching to shipping or already in shipping mode
          if (currentMethod !== 'shipping' && !isSwitchingToShipping && !window.isSwitchingToShipping) {
            updateWidgetDisplay();
            // Update cart attributes with new location
            setTimeout(updateCartAttributes, 300);
          }
        });
      }
      
      // DISABLED: Watch for widget changes
      // This was causing infinite loops because it triggers on our custom widget's innerHTML changes
      // The custom widget handles its own updates via event listeners, so we don't need to observe DOM changes
      // var widgetObserver = new MutationObserver(function(mutations) {
      //   var shouldUpdate = false;
      //   mutations.forEach(function(mutation) {
      //     // Skip if mutation is from our custom widget
      //     if (mutation.target && mutation.target.closest && mutation.target.closest('#custom-availability-widget')) {
      //       return; // Skip mutations from our own widget
      //     }
      //     if (mutation.addedNodes.length > 0 || mutation.type === 'attributes') {
      //       shouldUpdate = true;
      //     }
      //   });
      //   if (shouldUpdate) {
      //     if (!availabilityWidget) {
      //       availabilityWidget = document.getElementById('inventory-info-app') || 
      //                            document.querySelector('.iia-container');
      //     }
      //     if (availabilityWidget) {
      //       var now = Date.now();
      //       if (!widgetObserver.lastUpdate || (now - widgetObserver.lastUpdate) >= 500) {
      //         widgetObserver.lastUpdate = now;
      //         setTimeout(updateWidgetDisplay, 100);
      //       }
      //     }
      //   }
      // });
      // 
      // if (document.body && document.body.nodeType === 1) {
      //   try {
      //     widgetObserver.observe(document.body, {
      //       childList: true,
      //       subtree: true,
      //       attributes: true,
      //       attributeFilter: ['class', 'style']
      //     });
      //   } catch(e) {
      //     // Silently fail if observation fails
      //   }
      // }
      
      // Initialize
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHeaderMethodSelector);
      } else {
        initHeaderMethodSelector();
      }
      
      setTimeout(initHeaderMethodSelector, 1000);
      setTimeout(initHeaderMethodSelector, 3000);
      
      // Export function globally
      window.enforceShippingOnlyForOnlineWarehouse = enforceShippingOnlyForOnlineWarehouse;
      
      // Function to ensure inventory widget appears in right column
      function ensureWidgetInRightColumn() {
        // OLD WIDGET DISABLED - No-op function
        return;
        
        // OLD CODE BELOW - DISABLED
        // Only run on product pages
        var rightColumn = document.querySelector('.tt-product-single-aside');
        if (!rightColumn) {
          return;
        }
        
        // Try multiple selectors to find the widget, including searching in Shopify app sections
        var widgetContainer = document.getElementById('inventory-info-app') || 
                              document.querySelector('.iia-container') ||
                              document.querySelector('[id*="inventory-info"]') ||
                              document.querySelector('[class*="iia-container"]');
        
        // If not found, search in Shopify app sections
        if (!widgetContainer) {
          var appSections = document.querySelectorAll('.shopify-section[class*="apps"], .shopify-section[class*="app"]');
          for (var i = 0; i < appSections.length; i++) {
            var found = appSections[i].querySelector('#inventory-info-app, .iia-container, [id*="inventory-info"], [class*="iia-container"]');
            if (found) {
              widgetContainer = found;
              break;
            }
          }
        }
        
        if (!rightColumn) {
          console.log('[Inventory Widget] Right column (.tt-product-single-aside) not found');
          return;
        }
        
        if (!widgetContainer) {
          console.log('[Inventory Widget] Widget container not found yet');
          return;
        }
        
        console.log('[Inventory Widget] Found widget:', widgetContainer.id || widgetContainer.className);
        var widgetSection = widgetContainer.closest('.shopify-section');
        console.log('[Inventory Widget] Widget location:', widgetSection ? 'In Shopify section (' + (widgetSection.id || widgetSection.className) + ')' : 'Standalone');
        
        // Check if widget is already in the right column
        var isInRightColumn = rightColumn.contains(widgetContainer) || 
                              widgetContainer.closest('.tt-product-single-aside') === rightColumn;
        
        if (isInRightColumn) {
          console.log('[Inventory Widget] Widget is already in right column');
        } else {
          console.log('[Inventory Widget] Widget is NOT in right column, moving it...');
          
          // Check if there's a placeholder div in the right column
          var placeholder = rightColumn.querySelector('#inventory-info-app.iia-container, .iia-container#inventory-info-app');
          
          // If widget is in a separate Shopify section, we need to move it
          var widgetSection = widgetContainer.closest('.shopify-section');
          var rightColumnSection = rightColumn.closest('.shopify-section');
          
          if (widgetSection && widgetSection !== rightColumnSection) {
            console.log('[Inventory Widget] Widget is in separate Shopify section, moving content...');
            console.log('[Inventory Widget] Widget section ID:', widgetSection.id || 'no-id');
            
            // If there's a placeholder, move widget content into it
            if (placeholder && placeholder !== widgetContainer) {
              console.log('[Inventory Widget] Moving widget content into placeholder div');
              // Copy all children from widget to placeholder
              while (widgetContainer.firstChild) {
                placeholder.appendChild(widgetContainer.firstChild);
              }
              // Copy attributes
              if (widgetContainer.id && !placeholder.id) {
                placeholder.id = widgetContainer.id;
              }
              if (widgetContainer.className) {
                placeholder.className = widgetContainer.className + ' ' + (placeholder.className || '');
              }
              // Copy data attributes
              if (widgetContainer.dataset) {
                for (var key in widgetContainer.dataset) {
                  if (widgetContainer.dataset.hasOwnProperty(key)) {
                    placeholder.setAttribute('data-' + key, widgetContainer.dataset[key]);
                  }
                }
              }
            } else {
              // Move the widget container itself (detach from section)
              console.log('[Inventory Widget] Moving widget container to right column');
              // Clone the widget to preserve it
              var clonedWidget = widgetContainer.cloneNode(true);
              rightColumn.insertBefore(clonedWidget, rightColumn.firstChild);
              // Remove original widget
              widgetContainer.remove();
              widgetContainer = clonedWidget; // Update reference
            }
          } else {
            // Widget is not in a section, just move it
            console.log('[Inventory Widget] Moving widget to right column');
            if (placeholder && placeholder !== widgetContainer) {
              // Move content into placeholder
              console.log('[Inventory Widget] Moving widget content into placeholder');
              while (widgetContainer.firstChild) {
                placeholder.appendChild(widgetContainer.firstChild);
              }
              // Copy attributes
              if (widgetContainer.id && !placeholder.id) {
                placeholder.id = widgetContainer.id;
              }
              if (widgetContainer.className) {
                placeholder.className = widgetContainer.className + ' ' + (placeholder.className || '');
              }
            } else {
              rightColumn.insertBefore(widgetContainer, rightColumn.firstChild);
            }
          }
          
          // Verify widget is now in right column
          var verifyWidget = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
          if (verifyWidget && rightColumn.contains(verifyWidget)) {
            console.log('[Inventory Widget] Successfully moved widget to right column');
          } else {
            console.warn('[Inventory Widget] Widget may not be in right column after move');
          }
        }
        
        // Ensure widget is visible (check computed styles, not just inline)
        var computedStyle = window.getComputedStyle(widgetContainer);
        if (computedStyle.display === 'none' || widgetContainer.style.display === 'none') {
          widgetContainer.style.display = 'block';
          console.log('[Inventory Widget] Set display to block');
        }
        if (computedStyle.visibility === 'hidden' || widgetContainer.style.visibility === 'hidden') {
          widgetContainer.style.visibility = 'visible';
          console.log('[Inventory Widget] Set visibility to visible');
        }
        
        // Also ensure the right column itself is visible
        var rightColumnStyle = window.getComputedStyle(rightColumn);
        if (rightColumnStyle.display === 'none') {
          rightColumn.style.display = 'block';
        }
      }
      
      // Ensure widget is in right column on page load and when widget appears
      // Try multiple times with increasing delays since widget may load asynchronously
      window.addEventListener('load', function() {
        var attempts = [500, 1000, 2000, 3000, 5000];
        attempts.forEach(function(delay) {
          setTimeout(function() {
            ensureWidgetInRightColumn();
          }, delay);
        });
      });
      
      // Also try immediately if DOM is already ready
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(ensureWidgetInRightColumn, 100);
      }
      
      // Watch for widget being added to DOM
      var widgetCheckObserver = new MutationObserver(function(mutations) {
        var widgetFound = false;
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.id === 'inventory-info-app' || 
                  node.classList.contains('iia-container') ||
                  node.querySelector('#inventory-info-app, .iia-container')) {
                widgetFound = true;
              }
            }
          });
        });
        
        if (widgetFound) {
          setTimeout(ensureWidgetInRightColumn, 100);
        }
      });
      
      if (document.body) {
        widgetCheckObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      
      // Ensure online warehouse is selected when widget loads and shipping is active
      window.addEventListener('load', function() {
        setTimeout(function() {
          if (currentMethod === 'shipping') {
            selectOnlineWarehouse();
          }
          // Also check if shipping should be disabled
          enforceShippingOnlyForOnlineWarehouse();
        }, 2000);
      });
      
      // Also listen for widget content changes
      setTimeout(function() {
        var widgetContainer = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
        if (widgetContainer && widgetContainer.nodeType === 1) {
          try {
            var onlineWarehouseObserver = new MutationObserver(function() {
              if (currentMethod === 'shipping') {
                selectOnlineWarehouse();
              }
            });
            onlineWarehouseObserver.observe(widgetContainer, {
              childList: true,
              subtree: true
            });
          } catch(e) {
            // Silently fail if observation fails
          }
        }
      }, 3000);
    
    // Periodic check - run less frequently to avoid conflicts (debounced internally)
    window.addEventListener('load', function() {
      // Single periodic check (every 10 seconds) - updateLocationText is already debounced
      setTimeout(function() {
        setInterval(updateLocationText, 300000); // Check every 5 minutes (greatly reduced to prevent storage spam)
      }, 5000);
    });
    
    // Also update header when availability widget changes
    window.addEventListener('load', function() {
      setTimeout(function() {
        var widgetContainer = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
        if (widgetContainer && widgetContainer.nodeType === 1) {
          try {
            var headerObserver = new MutationObserver(function() {
              // Use debounced update to prevent rapid-fire changes
              updateLocationText(); // Already debounced internally (200ms)
            });
            headerObserver.observe(widgetContainer, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['class', 'data-selected']
            });
          } catch(e) {
            // Silently fail if observation fails
          }
        }
      }, 3000);
    });
    
    // Ensure header stays visible - check if it exists and is visible
    function ensureHeaderVisible() {
      var header = document.querySelector('header');
      if (!header) {
        console.log('Header not found in DOM');
        return;
      }
      
      var headerStyle = window.getComputedStyle(header);
      
      // Make sure header is visible
      if (headerStyle.display === 'none') {
        header.style.display = '';
      }
      if (headerStyle.visibility === 'hidden') {
        header.style.visibility = '';
      }
      if (headerStyle.opacity === '0') {
        header.style.opacity = '';
      }
      
      // Set z-index only if header has a position
      var position = headerStyle.position;
      if (position !== 'static') {
        header.style.zIndex = '100000';
      }
      
      // Check for overlay that might be covering header
      var overlays = document.querySelectorAll('body > div[style*="position: fixed"], body > div[style*="position:absolute"]');
      overlays.forEach(function(overlay) {
        var overlayStyle = window.getComputedStyle(overlay);
        if (parseInt(overlayStyle.zIndex) > 1000 && overlay.classList.contains('iia')) {
          overlay.style.zIndex = '99999';
        }
      });
    }
    
    // Run immediately and periodically
    ensureHeaderVisible();
    setTimeout(ensureHeaderVisible, 500);
    setTimeout(ensureHeaderVisible, 2000);
    // Only run periodically after page loads, and less frequently
    window.addEventListener('load', function() {
      setTimeout(function() {
        setInterval(ensureHeaderVisible, 30000); // Every 30 seconds
      }, 5000);
    });
    
    // Hook into location picker opening
    // Note: showLocationPicker is already hooked above with ensureHeaderVisible included
    // Just ensure the hook is applied
    hookShowLocationPicker();
    
    // Remove any mobile location icons from header (they should only be in the menu)
    function removeMobileLocationIconFromHeader() {
      if (window.innerWidth <= 1024) {
        var mobileLocationIcon = document.querySelector('.tt-mobile-parent-location');
        if (mobileLocationIcon) {
          // Check if it's in the header (not in a dropdown menu)
          var parent = mobileLocationIcon.parentElement;
          if (parent && !parent.closest('.tt-dropdown-menu')) {
            console.log('Removing mobile location icon from header');
            mobileLocationIcon.remove();
          }
        }
      }
    }
    
    // Remove on load and periodically
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(removeMobileLocationIconFromHeader, 100);
        setTimeout(removeMobileLocationIconFromHeader, 1000);
        setTimeout(removeMobileLocationIconFromHeader, 3000);
      });
    } else {
      setTimeout(removeMobileLocationIconFromHeader, 100);
      setTimeout(removeMobileLocationIconFromHeader, 1000);
      setTimeout(removeMobileLocationIconFromHeader, 3000);
    }
    // Throttle resize handler
    var resizeTimeout2;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout2);
      resizeTimeout2 = setTimeout(removeMobileLocationIconFromHeader, 500);
    });
    
    // Hide policy links from header (they're now in footer)
    function hidePolicyLinksFromHeader() {
      var header = document.querySelector('header');
      if (header) {
        var links = header.querySelectorAll('a');
        links.forEach(function(link) {
          var text = link.textContent.trim();
          var href = link.getAttribute('href') || '';
          if (text === 'Return Policy' || text === 'Shipping Policy' || text === 'FAQ' || text === 'Your privacy choices' ||
              href.indexOf('return-policy') !== -1 || href.indexOf('shipping-policy') !== -1 || 
              href.indexOf('/pages/faq') !== -1 || href.indexOf('privacy') !== -1) {
            link.style.display = 'none';
          }
        });
      }
    }
    
    // Run on load only - links shouldn't change dynamically
    hidePolicyLinksFromHeader();
    setTimeout(hidePolicyLinksFromHeader, 500);
    setTimeout(hidePolicyLinksFromHeader, 2000);
    
    // Hide unwanted location popup that appears on scroll (but NOT the actual location picker)
    var hiddenPopups = new Set();
    function hideLocationPopup() {
      // Only check fixed/absolute positioned elements, not all elements - much more efficient
      var popupCandidates = document.querySelectorAll('[style*="position: fixed"], [style*="position:absolute"], .popup, .modal');
      for (var i = 0; i < popupCandidates.length; i++) {
        var el = popupCandidates[i];
        // Skip if already hidden
        if (hiddenPopups.has(el)) continue;
        // Skip mobile location icon and actual location picker
        if (el.classList.contains('tt-mobile-parent-location')) continue;
        if (el.classList.contains('iia-container') || el.classList.contains('iia-popup')) continue;
        if (el.closest('.iia-container') || el.closest('.iia-popup')) continue;
        if (el.closest('[class*="iia"]') || el.closest('[id*="iia"]')) continue;
        
        if (el.textContent && el.textContent.toLowerCase().indexOf('shop from location') !== -1) {
          var style = window.getComputedStyle(el);
          var isPopup = style.position === 'fixed' || 
                       style.position === 'absolute' ||
                       parseInt(style.zIndex) > 1000;
          
          if (isPopup && el.offsetParent !== null) {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
            el.style.opacity = '0';
            hiddenPopups.add(el);
          }
        }
      }
    }
    
    // Throttle scroll handler - only run after page loads and with throttling
    var scrollPopupTimeout;
    window.addEventListener('load', function() {
      setTimeout(function() {
        window.addEventListener('scroll', function() {
          clearTimeout(scrollPopupTimeout);
          scrollPopupTimeout = setTimeout(hideLocationPopup, 1000); // Throttle to 1 second
        });
      }, 3000);
    });
    
    // Format phone numbers - remove +1 and format as xxx-xxx-xxxx (only in availability widget)
    function formatPhoneNumbers() {
      // Only process elements within the availability widget (iia-container)
      var availabilityContainers = document.querySelectorAll('.iia-container, [class*="iia-container"]');
      
      if (availabilityContainers.length === 0) {
        return; // No availability containers found
      }
      
      availabilityContainers.forEach(function(container) {
        // Find all elements within the container that might contain phone numbers
        var elements = container.querySelectorAll('*');
        elements.forEach(function(el) {
          // Skip script and style tags
          if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
          
          // Skip if element has children (we'll process leaf nodes)
          if (el.children.length > 0) return;
          
          var text = el.textContent || '';
          if (!text.trim()) return;
          
          // Match phone numbers with various formats
          // Pattern: +1 xxx xxx xxxx, +1xxxxxxxxxx, (xxx) xxx-xxxx, xxx-xxx-xxxx, etc.
          // But exclude patterns that look like SKUs or barcodes (e.g., all digits, no spaces/dashes)
          var phonePattern = /(\+?1[-.\s]?)?\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})/g;
          var matches = text.match(phonePattern);
          
          if (matches) {
            matches.forEach(function(match) {
              // Extract digits only
              var digits = match.replace(/\D/g, '');
              
              // Skip if it's likely a SKU or barcode (all digits, no formatting, and not starting with +1 or 1)
              // Phone numbers typically have +1 prefix or are formatted with dashes/parentheses
              var originalMatch = match.trim();
              var isLikelyPhone = originalMatch.includes('+') || 
                                  originalMatch.includes('(') || 
                                  originalMatch.includes('-') || 
                                  originalMatch.includes(' ') ||
                                  (digits.length === 11 && digits[0] === '1');
              
              if (!isLikelyPhone && digits.length === 10) {
                // Likely a SKU or barcode, skip it
                return;
              }
              
              // Remove leading 1 if present
              if (digits.length === 11 && digits[0] === '1') {
                digits = digits.substring(1);
              }
              
              // Format as xxx-xxx-xxxx if we have 10 digits
              if (digits.length === 10) {
                var formatted = digits.substring(0, 3) + '-' + digits.substring(3, 6) + '-' + digits.substring(6);
                
                // Replace in text
                var newText = text.replace(match, formatted);
                if (newText !== text) {
                  el.textContent = newText;
                }
              }
            });
          }
        });
      });
    }
    
    // Expose formatPhoneNumbers globally
    window.formatPhoneNumbers = formatPhoneNumbers;
    
    // Format addresses - break after street address, before city/state/zip
    function formatAddresses() {
      var availabilityContainers = document.querySelectorAll('.iia-container, [class*="iia-container"]');
      
      if (availabilityContainers.length === 0) {
        return;
      }
      
      availabilityContainers.forEach(function(container) {
        var addressElements = container.querySelectorAll('.iia-address');
        addressElements.forEach(function(addressEl) {
          var text = addressEl.textContent.trim();
          if (!text) return;
          
          // Check if content has changed - if so, allow re-processing
          if (addressEl.dataset.lastContent === text && addressEl.dataset.formatted === 'true') {
            return; // Skip if content hasn't changed
          }
          addressEl.dataset.lastContent = text;
          
          // Pattern: Look for "City, State" followed by optional zip
          // Examples: "Salem, Oregon 97301" or "Tigard, Oregon 97224" or "Gresham, Oregon"
          // Also handle cases where zip is already on new line
          var textWithNewlines = text.replace(/\s+/g, ' '); // Normalize whitespace first
          
          // Pattern 1: "Street City, State ZIP" - break before city
          var pattern1 = /^(.+?)\s+([A-Z][a-z]+(?:\s+\([^)]+\))?),\s*([A-Z][a-z]+)\s+(\d{5}(?:-\d{4})?)$/;
          var match1 = textWithNewlines.match(pattern1);
          
          if (match1) {
            var streetAddress = match1[1].trim();
            var city = match1[2].trim();
            var state = match1[3].trim();
            var zip = match1[4];
            addressEl.textContent = streetAddress + '\n' + city + ', ' + state + ' ' + zip;
            addressEl.dataset.formatted = 'true';
          } else {
            // Pattern 2: "Street City, State" (no zip or zip on separate line)
            var pattern2 = /^(.+?)\s+([A-Z][a-z]+(?:\s+\([^)]+\))?),\s*([A-Z][a-z]+)$/;
            var match2 = textWithNewlines.match(pattern2);
            
            if (match2) {
              var streetAddress2 = match2[1].trim();
              var city2 = match2[2].trim();
              var state2 = match2[3].trim();
              
              // Check if there's a zip code elsewhere (maybe on next line in original)
              var zipPattern = /\b(\d{5}(?:-\d{4})?)\b/;
              var zipMatch = text.match(zipPattern);
              var zipCode = zipMatch ? zipMatch[1] : '';
              
              if (zipCode) {
                addressEl.textContent = streetAddress2 + '\n' + city2 + ', ' + state2 + ' ' + zipCode;
              } else {
                addressEl.textContent = streetAddress2 + '\n' + city2 + ', ' + state2;
              }
              addressEl.dataset.formatted = 'true';
            } else {
              // Pattern 3: Try to find city/state by looking for common patterns
              // Look for "City, State" pattern anywhere
              var cityStatePattern = /([A-Z][a-z]+(?:\s+\([^)]+\))?),\s*([A-Z][a-z]+)/;
              var cityStateMatch = text.match(cityStatePattern);
              
              if (cityStateMatch) {
                var cityStateIndex = cityStateMatch.index;
                var streetAddress3 = text.substring(0, cityStateIndex).trim();
                var cityState3 = cityStateMatch[0];
                var zipPattern3 = /\b(\d{5}(?:-\d{4})?)\b/;
                var zipMatch3 = text.match(zipPattern3);
                var zipCode3 = zipMatch3 ? zipMatch3[1] : '';
                
                if (zipCode3) {
                  addressEl.textContent = streetAddress3 + '\n' + cityState3 + ' ' + zipCode3;
                } else {
                  addressEl.textContent = streetAddress3 + '\n' + cityState3;
                }
                addressEl.dataset.formatted = 'true';
              }
            }
          }
        });
      });
    }
    
    // Fix radio button layout and hide "Select this location" text
    function fixRadioButtonLayout() {
      var listItems = document.querySelectorAll('.iia-list-item, [class*="iia-container"] .iia-list-item');
      listItems.forEach(function(listItem) {
        // Make list item use flexbox with minimal spacing
        listItem.style.setProperty('display', 'flex', 'important');
        listItem.style.setProperty('flex-direction', 'row', 'important');
        listItem.style.setProperty('align-items', 'flex-start', 'important');
        listItem.style.setProperty('gap', '8px', 'important');
        listItem.style.setProperty('margin-bottom', '8px', 'important');
        listItem.style.setProperty('margin-top', '0', 'important');
        listItem.style.setProperty('padding', '0', 'important');
        
        // Fix radio button selector - ensure it's inline
        var selector = listItem.querySelector('.iia-location-selector');
        if (selector) {
          selector.style.setProperty('display', 'inline-flex', 'important');
          selector.style.setProperty('align-items', 'center', 'important');
          selector.style.setProperty('flex-shrink', '0', 'important');
          selector.style.setProperty('margin', '0', 'important');
          selector.style.setProperty('margin-right', '8px', 'important');
          selector.style.setProperty('padding', '0', 'important');
          selector.style.setProperty('width', 'auto', 'important');
          selector.style.setProperty('height', 'auto', 'important');
          
          // Fix the radio input itself
          var radioInput = selector.querySelector('input[type="radio"]');
          if (radioInput) {
            radioInput.style.setProperty('margin', '0', 'important');
            radioInput.style.setProperty('margin-top', '2px', 'important');
            radioInput.style.setProperty('vertical-align', 'top', 'important');
          }
        }
        
        // Fix location info
        var locationInfo = listItem.querySelector('.iia-location-info');
        if (locationInfo) {
          locationInfo.style.setProperty('flex', '1', 'important');
          locationInfo.style.setProperty('display', 'block', 'important');
          locationInfo.style.setProperty('margin', '0', 'important');
          locationInfo.style.setProperty('padding', '0', 'important');
        }
        
        // Hide "Select this location" elements - remove from DOM completely
        var selectContainers = listItem.querySelectorAll('.iia-select-location-container, .iia-select-location-info');
        selectContainers.forEach(function(container) {
          container.remove();
        });
        
        var selectLinks = listItem.querySelectorAll('.iia-select-this-location, a[href*="selectLocation"]');
        selectLinks.forEach(function(link) {
          if (link.parentElement) {
            link.parentElement.remove();
          } else {
            link.remove();
          }
        });
      });
    }
    
    // Fix title-text: remove dash, format as store name on line 1, quantity available on line 2
    function fixTitleTextLineBreaks() {
      var titleTexts = document.querySelectorAll('.iia-title-text, [class*="iia-container"] .iia-title-text');
      titleTexts.forEach(function(titleEl) {
        // Check if already properly formatted - look for the structure we create
        var locationEl = titleEl.querySelector('.iia-location');
        var qtyEl = titleEl.querySelector('.iia-qty');
        
        // If already formatted with our structure, check if it needs updating
        if (locationEl && qtyEl && titleEl.dataset.formatted === 'true') {
          // Check if the qty text has multiple "available" words
          var qtyText = qtyEl.textContent.trim();
          var availableCount = (qtyText.match(/\bavailable\b/gi) || []).length;
          
          // If there's more than one "available", fix it
          if (availableCount > 1) {
            // Extract just the number and add "available" once
            var numberMatch = qtyText.match(/^(\d+)/);
            if (numberMatch) {
              qtyEl.textContent = numberMatch[1] + ' available';
            } else {
              // Fallback: remove all "available" and add one
              qtyText = qtyText.replace(/\bavailable\b/gi, '').trim();
              var numMatch = qtyText.match(/(\d+)/);
              if (numMatch) {
                qtyEl.textContent = numMatch[1] + ' available';
              }
            }
          }
          return; // Already formatted, skip
        }
        
        // Check if content has changed - if so, allow re-processing
        var currentContent = titleEl.textContent.trim();
        if (titleEl.dataset.lastContent === currentContent && titleEl.dataset.formatted === 'true') {
          return; // Skip if content hasn't changed
        }
        titleEl.dataset.lastContent = currentContent;
        
        if (locationEl && qtyEl) {
          // Get the text content
          var locationText = locationEl.textContent.trim();
          var qtyText = qtyEl.textContent.trim();
          
          // Extract just the number from qtyText (remove any existing "available" text)
          var numberMatch = qtyText.match(/^(\d+)/);
          var quantity = numberMatch ? numberMatch[1] : qtyText.replace(/\D/g, '') || qtyText;
          
          // Clear the title element and rebuild with proper structure
          titleEl.innerHTML = '';
          
          // Create store name line
          var locationSpan = document.createElement('span');
          locationSpan.className = 'iia-location';
          locationSpan.textContent = locationText;
          locationSpan.style.display = 'block';
          titleEl.appendChild(locationSpan);
          
          // Create quantity available line - only add "available" once
          var qtySpan = document.createElement('span');
          qtySpan.className = 'iia-qty';
          qtySpan.textContent = quantity + ' available';
          qtySpan.style.display = 'block';
          titleEl.appendChild(qtySpan);
          
          titleEl.dataset.formatted = 'true';
        } else {
          // Fallback: parse from raw text content
          var text = titleEl.textContent.trim();
          
          // Remove any repeated "available" words first
          text = text.replace(/\bavailable\b(\s+\bavailable\b)+/gi, ' available');
          
          if (text.includes(' - ')) {
            // Remove dash and ensure line break
            var parts = text.split(' - ');
            if (parts.length === 2) {
              var locationPart = parts[0].trim();
              var qtyPart = parts[1].trim();
              
              // Extract number from qtyPart and add "available" once
              var numMatch = qtyPart.match(/^(\d+)/);
              var quantity = numMatch ? numMatch[1] : qtyPart.replace(/\D/g, '') || qtyPart;
              
              titleEl.innerHTML = '<span class="iia-location" style="display:block;">' + locationPart + '</span><span class="iia-qty" style="display:block;">' + quantity + ' available</span>';
              titleEl.dataset.formatted = 'true';
            }
          } else {
            // Try to parse location and quantity from text
            var locationMatch = text.match(/^(.+?)\s+(\d+)\s*(available.*)?$/i);
            if (locationMatch) {
              var locName = locationMatch[1].trim();
              var qtyNum = locationMatch[2];
              titleEl.innerHTML = '<span class="iia-location" style="display:block;">' + locName + '</span><span class="iia-qty" style="display:block;">' + qtyNum + ' available</span>';
              titleEl.dataset.formatted = 'true';
            }
          }
        }
      });
    }
    
    // Add "Your selected location" indicator with icon and Change link
    function addSelectedLocationIndicator() {
      // Get the currently selected location
      var selectedLocationId = null;
      var selectedLocationName = null;
      
      // Try to get selected location ID
      if (window.inventoryInfo && window.inventoryInfo.api) {
        try {
          if (window.inventoryInfo.api.getSelectedLocationId) {
            var locId = window.inventoryInfo.api.getSelectedLocationId();
            if (locId && typeof locId.then === 'function') {
              locId.then(function(id) {
                selectedLocationId = id;
                updateSelectedLocationIndicator(selectedLocationId);
              }).catch(function() {});
            } else if (locId) {
              selectedLocationId = locId;
              updateSelectedLocationIndicator(selectedLocationId);
            }
          }
          
          if (window.inventoryInfo.api.getSelectedLocation) {
            var locPromise = window.inventoryInfo.api.getSelectedLocation();
            if (locPromise && typeof locPromise.then === 'function') {
              locPromise.then(function(loc) {
                if (loc && loc.id) {
                  selectedLocationId = loc.id;
                  selectedLocationName = loc.name;
                  updateSelectedLocationIndicator(selectedLocationId, selectedLocationName);
                }
              }).catch(function() {});
            }
          }
        } catch(e) {
          // Silently handle errors
        }
      }
      
      // Also check radio buttons to see which one is checked
      setTimeout(function() {
        var checkedRadio = document.querySelector('.iia-container input[type="radio"]:checked, [class*="iia-container"] input[type="radio"]:checked');
        if (checkedRadio) {
          var listItem = checkedRadio.closest('.iia-list-item');
          if (listItem) {
            updateSelectedLocationIndicator(null, null, listItem);
          }
        }
      }, 500);
    }
    
    function updateSelectedLocationIndicator(locationId, locationName, targetListItem) {
      // Remove existing indicators
      var existingIndicators = document.querySelectorAll('.iia-selected-location-indicator');
      existingIndicators.forEach(function(ind) {
        ind.remove();
      });
      
      // Remove existing selected class
      var existingSelected = document.querySelectorAll('.iia-list-item.iia-selected-location');
      existingSelected.forEach(function(item) {
        item.classList.remove('iia-selected-location');
      });
      
      var listItem = targetListItem;
      
      // If no target provided, find it by location ID or checked radio
      if (!listItem) {
        if (locationId) {
          // Try to find by data attribute or location name
          var allListItems = document.querySelectorAll('.iia-list-item, [class*="iia-container"] .iia-list-item');
          allListItems.forEach(function(item) {
            var titleText = item.querySelector('.iia-title-text, .iia-location');
            if (titleText && locationName && titleText.textContent.includes(locationName)) {
              listItem = item;
            }
          });
        }
        
        // Fallback: find by checked radio
        if (!listItem) {
          var checkedRadio = document.querySelector('.iia-container input[type="radio"]:checked, [class*="iia-container"] input[type="radio"]:checked');
          if (checkedRadio) {
            listItem = checkedRadio.closest('.iia-list-item');
          }
        }
      }
      
      if (listItem) {
        // Add selected class
        listItem.classList.add('iia-selected-location');
        
        // Find location info container
        var locationInfo = listItem.querySelector('.iia-location-info');
        if (!locationInfo) {
          locationInfo = listItem.querySelector('.iia-title-text');
        }
        if (!locationInfo) {
          locationInfo = listItem;
        }
        
        // Check if indicator already exists
        if (locationInfo.querySelector('.iia-selected-location-indicator')) {
          return;
        }
        
        // Create indicator element
        var indicator = document.createElement('div');
        indicator.className = 'iia-selected-location-indicator';
        
        // Add house/store icon SVG
        var iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>';
        indicator.innerHTML = iconSvg;
        
        // Add "Your selected location" text
        var textSpan = document.createElement('span');
        textSpan.textContent = 'Your selected location';
        indicator.appendChild(textSpan);
        
        // Add "Change" link
        var changeLink = document.createElement('a');
        changeLink.className = 'iia-change-link';
        changeLink.textContent = 'Change';
        changeLink.href = 'javascript:void(0)';
        
        // Add unique ID for debugging
        changeLink.id = 'iia-change-link-' + Date.now();
        console.log('[Change Link Creation] Created Change link with ID:', changeLink.id);
        console.log('[Change Link Creation] Change link element:', changeLink);
        
        // Add global click listener to catch ANY click on elements with "Change" text
        if (!window._changeLinkClickMonitor) {
          window._changeLinkClickMonitor = true;
          document.addEventListener('click', function(e) {
            var target = e.target;
            if (target && (target.textContent === 'Change' || target.textContent.trim() === 'Change' || target.className.includes('change') || target.id.includes('change'))) {
              console.log('[Global Change Monitor] ========================================');
              console.log('[Global Change Monitor] CLICKED ON ELEMENT WITH "Change"');
              console.log('[Global Change Monitor] Target:', target);
              console.log('[Global Change Monitor] Target tag:', target.tagName);
              console.log('[Global Change Monitor] Target class:', target.className);
              console.log('[Global Change Monitor] Target ID:', target.id);
              console.log('[Global Change Monitor] Target text:', target.textContent);
              console.log('[Global Change Monitor] ========================================');
              debugLog('header-location-selector.js:global-monitor', 'Global Change click detected', {
                targetTag: target.tagName,
                targetClass: target.className,
                targetId: target.id,
                targetText: target.textContent,
                isOurChangeLink: target.className === 'iia-change-link' || target.id === changeLink.id
              }, 'A');
            }
          }, true); // Use capture phase to catch early
        }
        
        changeLink.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          try {
            console.log('[Change Link] CHANGE BUTTON CLICKED!');
            console.log('[Change Link] showLocationDropdown exists:', typeof showLocationDropdown === 'function');
            
            // Directly call our custom dropdown instead of going through showLocationPicker
            // This ensures we always get our custom address entry window
            if (typeof showLocationDropdown === 'function') {
              console.log('[Change Link] Passing Change link element directly to showLocationDropdown');
              
              // FIX: Pass the changeLink element itself so dropdown appears at the correct position
              showLocationDropdown(changeLink);
            } else {
              // Fallback: try the hook
              if (typeof hookShowLocationPicker === 'function') {
                hookShowLocationPicker();
              }
              if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.showLocationPicker) {
                window.inventoryInfo.api.showLocationPicker();
              } else {
                console.warn('showLocationPicker not available, trying alternative methods');
              }
            }
          } catch(err) {
            console.error('Error opening location picker:', err);
          }
          return false;
        };
        indicator.appendChild(changeLink);
        
        // Insert after title-text or at the end of location-info
        var titleText = locationInfo.querySelector('.iia-title-text');
        if (titleText && titleText.nextSibling) {
          locationInfo.insertBefore(indicator, titleText.nextSibling);
        } else if (titleText) {
          titleText.parentNode.insertBefore(indicator, titleText.nextSibling);
        } else {
          locationInfo.appendChild(indicator);
        }
      }
    }
    
    // Run on load and after a delay (to catch dynamically loaded content)
    formatPhoneNumbers();
    formatAddresses();
    fixTitleTextLineBreaks();
    fixRadioButtonLayout();
    addSelectedLocationIndicator();
    setTimeout(function() {
      formatPhoneNumbers();
      formatAddresses();
      fixTitleTextLineBreaks();
      fixRadioButtonLayout();
      addSelectedLocationIndicator();
    }, 1000);
    setTimeout(function() {
      formatPhoneNumbers();
      formatAddresses();
      fixTitleTextLineBreaks();
      fixRadioButtonLayout();
      addSelectedLocationIndicator();
    }, 3000);
    
    // Also run when DOM changes (for dynamically loaded content) - only observe widget container
    window.addEventListener('load', function() {
      setTimeout(function() {
        var widgetContainer = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
        if (widgetContainer && widgetContainer.nodeType === 1) {
          try {
            var observer = new MutationObserver(function(mutations) {
              // Check if there are actual content changes
              var hasContentChanges = false;
              mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  hasContentChanges = true;
                }
                if (mutation.type === 'characterData' || 
                    (mutation.type === 'attributes' && 
                     (mutation.attributeName === 'class' || mutation.attributeName === 'style'))) {
                  hasContentChanges = true;
                }
              });
              
              if (hasContentChanges) {
                // Reset formatted flags when content changes
                var titleTexts = document.querySelectorAll('.iia-title-text');
                titleTexts.forEach(function(el) {
                  delete el.dataset.formatted;
                  delete el.dataset.lastContent;
                });
                
                var addresses = document.querySelectorAll('.iia-address');
                addresses.forEach(function(el) {
                  delete el.dataset.formatted;
                  delete el.dataset.lastContent;
                });
                
                // Throttle calls but allow immediate processing for content changes
                var now = Date.now();
                if (now - (observer.lastRun || 0) >= 500) {
                  observer.lastRun = now;
                  formatPhoneNumbers();
                  formatAddresses();
                  fixTitleTextLineBreaks();
                  fixRadioButtonLayout();
                  addSelectedLocationIndicator();
                  updateLocationText(); // Update header when widget changes
                }
              }
            });
            observer.observe(widgetContainer, {
              childList: true,
              subtree: true,
              characterData: true,
              attributes: true,
              attributeFilter: ['class', 'style']
            });
            
            // Listen for radio button changes to update selected location indicator and change location
            widgetContainer.addEventListener('change', function(e) {
              if (e.target && e.target.type === 'radio' && e.target.checked) {
                var radio = e.target;
                var locationId = radio.value;
                
                // Try to parse location ID as number
                var locIdNum = typeof locationId === 'string' ? parseInt(locationId, 10) : locationId;
                
                // Only proceed if we have a valid location ID and the API is available
                if (!isNaN(locIdNum) && window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.selectLocation) {
                  console.log('[Inventory Widget] Radio button changed, selecting location:', locIdNum);
                  
                  // Call the API to select the location
                  window.inventoryInfo.api.selectLocation(locIdNum).then(function() {
                    console.log('[Inventory Widget] Location selected successfully:', locIdNum);
                    
                    // Update header text with the location name
                    // First, try to get the location name from the radio button's label or parent
                    var listItem = radio.closest('.iia-list-item');
                    var locationName = null;
                    
                    if (listItem) {
                      var locationNameEl = listItem.querySelector('.iia-location, .iia-title-text, [class*="location"]');
                      if (locationNameEl) {
                        locationName = locationNameEl.textContent.trim();
                      }
                    }
                    
                    // If we couldn't find the name in the DOM, try to get it from the API
                    if (!locationName && window.inventoryInfo.api.getSelectedLocation) {
                      window.inventoryInfo.api.getSelectedLocation().then(function(loc) {
                        if (loc && loc.name) {
                          locationName = loc.name;
                          updateHeaderWithLocation(locationName);
                        }
                      }).catch(function() {});
                    } else if (locationName) {
                      updateHeaderWithLocation(locationName);
                    }
                    
                    // Update widget display
                    setTimeout(function() {
                      if (typeof updateWidgetDisplay === 'function') {
                        updateWidgetDisplay();
                      }
                      // Also update location text
                      if (typeof window.updateLocationText === 'function') {
                        window.updateLocationText();
                      }
                      // Update cart attributes with new location
                      if (typeof updateCartAttributes === 'function') {
                        updateCartAttributes();
                      }
                    }, 300);
                    
                    // Update selected location indicator
                    setTimeout(function() {
                      addSelectedLocationIndicator();
                    }, 100);
                  }).catch(function(error) {
                    console.warn('[Inventory Widget] Error selecting location:', error);
                  });
                } else {
                  // Fallback: just update the indicator
                  setTimeout(function() {
                    addSelectedLocationIndicator();
                  }, 100);
                }
              }
            });
            
            // Helper function to update header with location name
            function updateHeaderWithLocation(locationName) {
              if (typeof window.updateHeaderText === 'function') {
                window.updateHeaderText(locationName);
              } else {
                // Fallback direct update
                var locationTextEl = document.querySelector('.location-picker-text');
                var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
                if (locationTextEl) locationTextEl.textContent = locationName;
                if (locationTextElMobile) {
                  locationTextElMobile.textContent = locationName;
                  locationTextElMobile.style.display = 'inline-block';
                }
              }
              
              // Check if shipping should be disabled for this location
              if (typeof window.enforceShippingOnlyForOnlineWarehouse === 'function') {
                window.enforceShippingOnlyForOnlineWarehouse();
              }
            }
            
            // Also listen for click events on radio buttons (for immediate feedback)
            widgetContainer.addEventListener('click', function(e) {
              if (e.target && e.target.type === 'radio') {
                setTimeout(function() {
                  addSelectedLocationIndicator();
                }, 200);
              }
            });
          } catch(e) {
            // Silently fail if observation fails
          }
        }
      }, 3000);
    });
    
    // Move astro loyalty block above product information
    function moveAstroLoyaltyBlock() {
      try {
        // Find the astro block - look for the Shopify section wrapper first
        var astroSection = document.querySelector('#shopify-section-template--19876292034777__1754779198f739aad7, [id*="astro_loyalty_app_block"].shopify-section, [id*="astro_loyalty_app_block"]');
        if (!astroSection) {
          // Fallback: find by block ID
          var astroBlockInner = document.querySelector('#shopify-block-AWDRvNzQ3NEdHOFBtT__astro_loyalty_app_block_y3M8rr, [id*="astro_loyalty_app_block"]');
          if (astroBlockInner) {
            astroSection = astroBlockInner.closest('.shopify-section');
          }
        }
        
        var productInfo = document.querySelector('.tt-product-single-info');
        
        if (astroSection && productInfo) {
          // Check if already moved
          if (astroSection.dataset.moved !== 'true') {
            // Get the actual parent of productInfo
            var productParent = productInfo.parentNode;
            
            // Verify productInfo is actually a child of productParent
            if (productParent && productParent.contains(productInfo)) {
              // Check if astroSection is already in the correct position
              var astroNextSibling = astroSection.nextElementSibling;
              if (astroNextSibling !== productInfo) {
                // Insert astro section before product info in its parent
                productParent.insertBefore(astroSection, productInfo);
                astroSection.dataset.moved = 'true';
              } else {
                // Already in correct position
                astroSection.dataset.moved = 'true';
              }
            }
          }
        }
      } catch (e) {
        // Silently fail to avoid console noise
        console.debug('moveAstroLoyaltyBlock error:', e);
      }
    }
    
    // Run on load and after delays
    moveAstroLoyaltyBlock();
    setTimeout(moveAstroLoyaltyBlock, 500);
    setTimeout(moveAstroLoyaltyBlock, 1500);
    setTimeout(moveAstroLoyaltyBlock, 3000);
    
    // Also watch for dynamically loaded content (throttled) - only observe product page
    window.addEventListener('load', function() {
      setTimeout(function() {
        var productPage = document.querySelector('.tt-product-single-info, .product_page_template, main');
        if (productPage) {
          var astroLastRun = 0;
          var astroThrottleDelay = 2000; // Run at most once per 2 seconds
          var astroObserver = new MutationObserver(function(mutations) {
            var now = Date.now();
            if (now - astroLastRun >= astroThrottleDelay) {
              astroLastRun = now;
              moveAstroLoyaltyBlock();
            }
          });
          if (productPage && productPage.nodeType === 1) {
            try {
              astroObserver.observe(productPage, {
                childList: true,
                subtree: true
              });
            } catch(e) {
              // Silently fail if observation fails
            }
          }
        }
      }, 3000);
    });
    
    // Move Appstle subscription widget above wishlist
    function moveAppstleWidget() {
      try {
        // Find the product info container - only move within this section
        var productInfoContainer = document.querySelector('.tt-product-single-info');
        if (!productInfoContainer) {
          return; // Product info container not found
        }
        
        // Find the Appstle widget - look for the widget itself, not the section wrapper
        var appstleWidget = document.querySelector('.appstle_sub_widget, #appstle_subscription_widget0');
        if (!appstleWidget) {
          return; // Widget not found yet
        }
        
        // Check if widget is inside a Shopify section
        var appstleSection = appstleWidget.closest('.shopify-section');
        
        // IMPORTANT: Don't move if the section contains the availability panel (iia-container)
        // Skip moving entirely if they're in the same section to avoid breaking the layout
        if (appstleSection) {
          var availabilityPanel = appstleSection.querySelector('.iia-container, [class*="iia-container"], [id*="inventory"]');
          if (availabilityPanel) {
            // The section contains the availability panel - skip moving to preserve layout
            return;
          }
        }
        
        // Find the wishlist wrapper (the div containing the wishlist button) - must be within product info
        var wishlistWrapper = productInfoContainer.querySelector('.tt-wrapper .tt-list-btn');
        if (!wishlistWrapper) {
          // Fallback: look for the wishlist button itself
          var wishlistButton = productInfoContainer.querySelector('.wlbutton-js');
          if (wishlistButton) {
            wishlistWrapper = wishlistButton.closest('.tt-wrapper');
          }
        }
        
        if (appstleWidget && wishlistWrapper && productInfoContainer.contains(wishlistWrapper)) {
          // Check if already moved
          if (appstleWidget.dataset.moved !== 'true') {
            // Get the parent of wishlist wrapper
            var wishlistParent = wishlistWrapper.parentNode;
            
            // Ensure wishlistParent is within productInfoContainer
            if (!productInfoContainer.contains(wishlistParent) && wishlistParent !== productInfoContainer) {
              wishlistParent = productInfoContainer;
            }
            
            // Verify wishlistWrapper is actually a child of wishlistParent
            if (wishlistParent && wishlistParent.contains(wishlistWrapper)) {
              // Check if appstleWidget is already in the correct position
              var wishlistPrevSibling = wishlistWrapper.previousElementSibling;
              if (wishlistPrevSibling !== appstleWidget) {
                // Only move if appstleWidget is not already inside productInfoContainer
                // This prevents moving widgets that are already in the right place
                if (!productInfoContainer.contains(appstleWidget)) {
                  // Insert appstle widget before wishlist wrapper within productInfoContainer
                  wishlistParent.insertBefore(appstleWidget, wishlistWrapper);
                  appstleWidget.dataset.moved = 'true';
                } else {
                  // Widget is already inside productInfoContainer, just mark as moved
                  appstleWidget.dataset.moved = 'true';
                }
              } else {
                // Already in correct position
                appstleWidget.dataset.moved = 'true';
              }
            }
          }
        }
      } catch (e) {
        // Silently fail to avoid console noise
        console.debug('moveAppstleWidget error:', e);
      }
    }
    
    // Run on load and after delays
    moveAppstleWidget();
    setTimeout(moveAppstleWidget, 500);
    setTimeout(moveAppstleWidget, 1500);
    setTimeout(moveAppstleWidget, 3000);
    
    // Also watch for dynamically loaded content (throttled) - only observe product page
    window.addEventListener('load', function() {
      setTimeout(function() {
        var productPage = document.querySelector('.tt-product-single-info, .product_page_template, main');
        if (productPage) {
          var appstleLastRun = 0;
          var appstleThrottleDelay = 2000; // Run at most once per 2 seconds
          var appstleObserver = new MutationObserver(function(mutations) {
            var now = Date.now();
            if (now - appstleLastRun >= appstleThrottleDelay) {
              appstleLastRun = now;
              moveAppstleWidget();
            }
          });
          if (productPage && productPage.nodeType === 1) {
            try {
              appstleObserver.observe(productPage, {
                childList: true,
                subtree: true
              });
            } catch(e) {
              // Silently fail if observation fails
            }
          }
        }
      }, 3000);
    });
    
    // Ensure availability widget stays visible - simplified and optimized
    function ensureAvailabilityWidgetVisible() {
      try {
        // Only check main container - much faster
        var container = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
        if (!container) {
          return;
        }
        
        var computedStyle = window.getComputedStyle(container);
        var isHidden = computedStyle.display === 'none' || 
                       computedStyle.visibility === 'hidden' || 
                       parseFloat(computedStyle.opacity) < 0.01;
        
        // Only apply styles if actually hidden
        if (isHidden) {
          container.classList.remove('iia-hidden', 'hidden', 'd-none');
          container.style.setProperty('display', 'block', 'important');
          container.style.setProperty('visibility', 'visible', 'important');
          container.style.setProperty('opacity', '1', 'important');
          
          // Check only 3 levels of parents (much faster than 15)
          var parent = container.parentElement;
          var depth = 0;
          while (parent && depth < 3 && parent !== document.body) {
            var parentStyle = window.getComputedStyle(parent);
            if (parentStyle.display === 'none' || parentStyle.visibility === 'hidden') {
              parent.style.setProperty('display', 'block', 'important');
              parent.style.setProperty('visibility', 'visible', 'important');
            }
            parent = parent.parentElement;
            depth++;
          }
        }
        
        // Hide loading spinners with iia-hidden class (quick check)
        var hiddenLoaders = container.querySelectorAll('.iia-loading.iia-hidden');
        if (hiddenLoaders.length > 0) {
          hiddenLoaders.forEach(function(loader) {
            loader.style.setProperty('display', 'none', 'important');
          });
        }
      } catch (e) {
        // Silently handle errors
      }
    }
    
    // Run on load only - widget should stay visible once CSS is applied
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(ensureAvailabilityWidgetVisible, 1000);
      });
    } else {
      setTimeout(ensureAvailabilityWidgetVisible, 1000);
    }
    
    // Run once more after page fully loads
    window.addEventListener('load', function() {
      setTimeout(ensureAvailabilityWidgetVisible, 2000);
    });
    
    // Only run periodically if widget becomes hidden (much less frequent)
    window.addEventListener('load', function() {
      setTimeout(function() {
        var visibilityInterval = setInterval(function() {
          try {
            // Quick check - only run expensive function if widget is actually hidden
            var widget = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
            if (widget) {
              var style = window.getComputedStyle(widget);
              if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) < 0.01) {
                ensureAvailabilityWidgetVisible();
              }
            }
          } catch (e) {
            // Silently handle errors
          }
        }, 30000); // Check every 30 seconds, and only if hidden
      }, 10000); // Start interval 10 seconds after page load
    });
    
    // Removed scroll/resize handlers and MutationObserver - CSS should handle visibility
    // If widget becomes hidden, the periodic check will fix it
    
    // Override any CSS that might hide it - inject style tag with highest priority
    // Remove existing style if it exists
    var existingStyle = document.getElementById('force-availability-widget-visible');
    if (existingStyle) {
      existingStyle.remove();
    }
    
    var forceVisibilityStyle = document.createElement('style');
    forceVisibilityStyle.id = 'force-availability-widget-visible';
    forceVisibilityStyle.textContent = `
      div#inventory-info-app,
      div#inventory-info-app.iia-container,
      #inventory-info-app.iia-container,
      #inventory-info-app,
      .iia-container#inventory-info-app,
      [id*="inventory-info"]:not([id*="astro"]):not([id*="loyalty"]) {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        height: auto !important;
        max-height: none !important;
        min-height: 50px !important;
        position: relative !important;
        overflow: visible !important;
        clip: auto !important;
        clip-path: none !important;
        transform: none !important;
        filter: none !important;
        width: auto !important;
        min-width: auto !important;
      }
      div#inventory-info-app:empty,
      .iia-container:empty {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        min-height: 50px !important;
      }
      /* Override any hiding classes */
      div#inventory-info-app.iia-hidden,
      .iia-container.iia-hidden {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(forceVisibilityStyle);
    
    // Hide stuck loading spinners in availability widget
    function hideStuckLoaders() {
      var containers = document.querySelectorAll('.iia-container, [class*="iia-container"]');
      containers.forEach(function(container) {
        // Find and hide loading spinners
        var spinners = container.querySelectorAll('[class*="spinner"], [class*="loading"], [class*="loader"], .spinner, .loading, .loader');
        spinners.forEach(function(spinner) {
          var style = window.getComputedStyle(spinner);
          // Hide if it's been visible for more than 5 seconds (check parent for animation)
          if (style.display !== 'none' && style.visibility !== 'hidden') {
            // Check if parent has been loaded (has content other than spinner)
            var parent = spinner.parentElement;
            if (parent && parent.children.length > 1) {
              spinner.style.display = 'none';
              spinner.style.visibility = 'hidden';
            }
          }
        });
        
        // Also hide spinners that are animated but stuck
        var animatedSpinners = container.querySelectorAll('[class*="spinner"][style*="animation"], [class*="loading"][style*="animation"]');
        animatedSpinners.forEach(function(spinner) {
          // Hide after a delay if content is loaded
          setTimeout(function() {
            if (spinner.parentElement && spinner.parentElement.textContent.trim().length > 50) {
              spinner.style.display = 'none';
            }
          }, 3000);
        });
      });
    }
    
    // Run loader hiding function
    setTimeout(hideStuckLoaders, 2000);
    setTimeout(hideStuckLoaders, 5000);
    setTimeout(hideStuckLoaders, 10000);
    
    // Watch for content changes and hide loaders - only observe the widget container, not entire body
    window.addEventListener('load', function() {
      setTimeout(function() {
        var widgetContainer = document.getElementById('inventory-info-app') || document.querySelector('.iia-container');
        if (widgetContainer && widgetContainer.nodeType === 1) {
          try {
            var loaderObserver = new MutationObserver(function(mutations) {
              // Throttle calls
              var now = Date.now();
              if (now - (loaderObserver.lastRun || 0) >= 2000) {
                loaderObserver.lastRun = now;
                hideStuckLoaders();
              }
            });
            loaderObserver.observe(widgetContainer, {
              childList: true,
              subtree: true
            });
          } catch(e) {
            // Silently fail if observation fails
          }
        }
      }, 3000);
    });
      
      // Make updateWidgetDisplay globally accessible
      window.updateWidgetDisplay = updateWidgetDisplay;
    })();


// ==========================================
// FIX FOR "Location ID" DISPLAY IN CHECKOUT / CART
// Maps Shopify Location IDs to Human Readable Names
// ==========================================
(function() {
    const locationMap = {
        '85743730905': 'Gresham Pet Supply',
        '43460657288': 'Newberg Location',
        '83963379929': 'Salem Pet Supply (North)',
        '83963445465': 'South Salem Pet Supply',
        '83963281625': 'Tigard Pet Supply',
        '42639884424': 'Wilsonville Pet Supply'
    };

    function replaceLocationIDs(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            let text = node.textContent;
            let replaced = false;
            for (const [id, name] of Object.entries(locationMap)) {
                if (text.includes(id) || text.includes(`Location ${id}`)) {
                    text = text.replace(new RegExp(`Location ${id}`, 'g'), name);
                    text = text.replace(new RegExp(id, 'g'), name);
                    replaced = true;
                }
            }
            if (replaced) {
                node.textContent = text;
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if element has an ID or class containing the location ID, 
            // but we mainly care about text content.
            if (node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
                for (let child of node.childNodes) {
                    replaceLocationIDs(child);
                }
            }
        }
    }

    // Run once on load
    replaceLocationIDs(document.body);

    // Observe future changes (e.g. when app renders the modal)
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    replaceLocationIDs(node);
                });
            } else if (mutation.type === 'characterData') {
                replaceLocationIDs(mutation.target);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
    });
    
    console.log('[Location ID Fix] Activated MutationObserver for Location Names mapping.');
})();

// Force store dropdown items to display
(function() {
    const style = document.createElement('style');
    style.innerHTML = `
        .store-selection-dropdown .store-dropdown-item {
            display: block !important;
            opacity: 1 !important;
            visibility: visible !important;
            order: 3 !important;
        }
    `;
    document.head.appendChild(style);
})();


// ==========================================
// FIX FOR LOCAL DELIVERY INITIAL STORE LIST
// Injects stores into dropdown before typing
// ==========================================
(function() {
    const locationMap = {
        '42639884424': 'Wilsonville Pet Supply',
        '43460657288': 'Newberg Location',
        '83963379929': 'Salem Pet Supply (North)',
        '83963445465': 'South Salem Pet Supply',
        '85743730905': 'Gresham Pet Supply',
        '83963281625': 'Tigard Pet Supply'
    };

        function processDropdown(dropdown) {
        let input = dropdown.querySelector('input[type="text"]');
        let hasSearchText = input && input.value.trim().length > 0;
        
        // If user typed an address, let the app show its native distance-based stores. Hide ours.
        if (hasSearchText) {
            dropdown.querySelectorAll('.injected-store-item, .injected-store-divider').forEach(el => el.style.setProperty('display', 'none', 'important'));
            return;
        }

        // Check if app has natively rendered distance-based stores even without search text
        let nativeStores = Array.from(dropdown.querySelectorAll('.store-dropdown-item:not(.injected-store-item)'));
        let hasNativeLocationStores = nativeStores.some(el => {
            let text = el.textContent || '';
            return text.includes('mi') || text.includes('km') || text.includes('away');
        });
        
        if (hasNativeLocationStores) {
            dropdown.querySelectorAll('.injected-store-item, .injected-store-divider').forEach(el => el.style.setProperty('display', 'none', 'important'));
            return;
        }

        // We want to show our injected stores!
        let injected = dropdown.querySelectorAll('.injected-store-item, .injected-store-divider');
        if (injected.length > 0) {
            injected.forEach(el => el.style.setProperty('display', 'block', 'important'));
            return;
        }

        // Otherwise, inject them
        let divider = document.createElement('div');
        divider.style.cssText = 'height: 1px; background: rgb(224, 224, 224); margin: 4px 0px;';
        divider.className = 'injected-store-divider';
        dropdown.appendChild(divider);

        for (const [id, name] of Object.entries(locationMap)) {
            let item = document.createElement('div');
            item.className = 'store-dropdown-item injected-store-item';
            item.style.cssText = 'padding: 8px 16px; cursor: pointer; font-size: 13px; color: rgb(41, 49, 73); white-space: nowrap; display: block !important; order: 3;';
            item.textContent = name;
            
            // Add hover effect
            item.onmouseenter = () => item.style.backgroundColor = '#f5f5f5';
            item.onmouseleave = () => item.style.backgroundColor = 'transparent';
            
            item.onclick = function() {
                if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.selectLocation) {
                    window.inventoryInfo.api.selectLocation(id);
                    
                    let locationTextEl = document.querySelector('.location-picker-text');
                    if (locationTextEl) locationTextEl.textContent = name;
                    
                    let mobileTextEl = document.querySelector('.location-picker-text-mobile');
                    if (mobileTextEl) mobileTextEl.textContent = name;
                    
                    let modal = document.querySelector('.iia-locationModal');
                    if (modal) modal.style.display = 'none';
                    
                    document.body.click();
                }
            };
            dropdown.appendChild(item);
        }
    }

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            // Check for new dropdowns or changes inside dropdown
            if (mutation.type === 'childList') {
                let target = mutation.target;
                if (target.classList && target.classList.contains('store-selection-dropdown')) {
                    processDropdown(target);
                }
                
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.classList && node.classList.contains('store-selection-dropdown')) {
                            processDropdown(node);
                        } else {
                            node.querySelectorAll('.store-selection-dropdown').forEach(processDropdown);
                        }
                        // If address input container is added to dropdown
                        if (node.classList && node.classList.contains('address-input-container')) {
                            if (node.parentNode && node.parentNode.classList.contains('store-selection-dropdown')) {
                                processDropdown(node.parentNode);
                            }
                        }
                    }
                });
                
                mutation.removedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.classList && node.classList.contains('store-dropdown-item') && !node.classList.contains('injected-store-item')) {
                            // A native item was removed, check if we need to show ours again
                            if (target.classList && target.classList.contains('store-selection-dropdown')) {
                                processDropdown(target);
                            }
                        }
                    }
                });
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Check if already in DOM
    document.querySelectorAll('.store-selection-dropdown').forEach(processDropdown);
    
    console.log('[Location ID Fix] Activated Initial Store List injection.');
})();


// ==========================================
// AUTO-SELECT LOCATION FROM URL PARAMETER
// ==========================================
(function() {
  var urlParams = new URLSearchParams(window.location.search);
  var requestedStore = urlParams.get('store') || urlParams.get('location');
  
  if (!requestedStore) return;
  
  requestedStore = requestedStore.toLowerCase().replace(/[^a-z0-9]/g, '');
  
  var storeToId = {
    'wilsonville': '42639884424',
    'newberg': '43460657288',
    'salem': '83963379929',
    'salemnorth': '83963379929',
    'northsalem': '83963379929',
    'southsalem': '83963445465',
    'salemsouth': '83963445465',
    'gresham': '85743730905',
    'tigard': '83963281625'
  };
  
  var targetId = storeToId[requestedStore];
  if (!targetId) return;

  var checkInterval = setInterval(function() {
    if (window.inventoryInfo && window.inventoryInfo.api && typeof window.inventoryInfo.api.selectLocation === 'function') {
      clearInterval(checkInterval);
      
      console.log('[Header Location Selector] Auto-selecting store from URL:', requestedStore, targetId);
      
      // Auto-select the location
      window.inventoryInfo.api.selectLocation(targetId).then(function() {
        console.log('[Header Location Selector] Successfully auto-selected store:', targetId);
        
        // Attempt to auto-select "pickup" method since they are coming from a specific store page
        if (typeof window.inventoryInfo.api.selectMethod === 'function') {
           window.inventoryInfo.api.selectMethod('pickup').catch(function(){});
        }
        
        // Clean up URL so it doesn't force re-selection on every page refresh
        if (window.history && window.history.replaceState) {
          var newUrl = new URL(window.location.href);
          newUrl.searchParams.delete('store');
          newUrl.searchParams.delete('location');
          window.history.replaceState({}, document.title, newUrl.toString());
        }
      }).catch(function(err) {
        console.error('[Header Location Selector] Failed to auto-select store:', err);
      });
    }
  }, 200);
  
  // Stop checking after 10 seconds
  setTimeout(function() {
    clearInterval(checkInterval);
  }, 10000);
})();